/*! For license information please see qf_vendor.js.LICENSE.txt */
(() => {
  var e = {
      9669: (e, t, s) => {
        e.exports = s(1609);
      },
      5448: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = s(6026),
          n = s(4372),
          r = s(5327),
          o = s(4097),
          l = s(4109),
          d = s(7985),
          c = s(5061),
          p = s(7874),
          u = s(5263);
        e.exports = function (e) {
          return new Promise(function (t, s) {
            var h,
              f = e.data,
              m = e.headers,
              g = e.responseType;
            function w() {
              (e.cancelToken && e.cancelToken.unsubscribe(h),
                e.signal && e.signal.removeEventListener('abort', h));
            }
            i.isFormData(f) && delete m['Content-Type'];
            var v = new XMLHttpRequest();
            if (e.auth) {
              var b = e.auth.username || '',
                y = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : '';
              m.Authorization = 'Basic ' + btoa(b + ':' + y);
            }
            var x = o(e.baseURL, e.url);
            function E() {
              if (v) {
                var i = 'getAllResponseHeaders' in v ? l(v.getAllResponseHeaders()) : null,
                  n = {
                    data: g && 'text' !== g && 'json' !== g ? v.response : v.responseText,
                    status: v.status,
                    statusText: v.statusText,
                    headers: i,
                    config: e,
                    request: v,
                  };
                (a(
                  function (e) {
                    (t(e), w());
                  },
                  function (e) {
                    (s(e), w());
                  },
                  n
                ),
                  (v = null));
              }
            }
            if (
              (v.open(e.method.toUpperCase(), r(x, e.params, e.paramsSerializer), !0),
              (v.timeout = e.timeout),
              'onloadend' in v
                ? (v.onloadend = E)
                : (v.onreadystatechange = function () {
                    v &&
                      4 === v.readyState &&
                      (0 !== v.status || (v.responseURL && 0 === v.responseURL.indexOf('file:'))) &&
                      setTimeout(E);
                  }),
              (v.onabort = function () {
                v && (s(c('Request aborted', e, 'ECONNABORTED', v)), (v = null));
              }),
              (v.onerror = function () {
                (s(c('Network Error', e, null, v)), (v = null));
              }),
              (v.ontimeout = function () {
                var t = e.timeout ? 'timeout of ' + e.timeout + 'ms exceeded' : 'timeout exceeded',
                  i = e.transitional || p;
                (e.timeoutErrorMessage && (t = e.timeoutErrorMessage),
                  s(c(t, e, i.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', v)),
                  (v = null));
              }),
              i.isStandardBrowserEnv())
            ) {
              var C =
                (e.withCredentials || d(x)) && e.xsrfCookieName ? n.read(e.xsrfCookieName) : void 0;
              C && (m[e.xsrfHeaderName] = C);
            }
            ('setRequestHeader' in v &&
              i.forEach(m, function (e, t) {
                void 0 === f && 'content-type' === t.toLowerCase()
                  ? delete m[t]
                  : v.setRequestHeader(t, e);
              }),
              i.isUndefined(e.withCredentials) || (v.withCredentials = !!e.withCredentials),
              g && 'json' !== g && (v.responseType = e.responseType),
              'function' == typeof e.onDownloadProgress &&
                v.addEventListener('progress', e.onDownloadProgress),
              'function' == typeof e.onUploadProgress &&
                v.upload &&
                v.upload.addEventListener('progress', e.onUploadProgress),
              (e.cancelToken || e.signal) &&
                ((h = function (e) {
                  v && (s(!e || (e && e.type) ? new u('canceled') : e), v.abort(), (v = null));
                }),
                e.cancelToken && e.cancelToken.subscribe(h),
                e.signal && (e.signal.aborted ? h() : e.signal.addEventListener('abort', h))),
              f || (f = null),
              v.send(f));
          });
        };
      },
      1609: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = s(1849),
          n = s(321),
          r = s(7185);
        var o = (function e(t) {
          var s = new n(t),
            o = a(n.prototype.request, s);
          return (
            i.extend(o, n.prototype, s),
            i.extend(o, s),
            (o.create = function (s) {
              return e(r(t, s));
            }),
            o
          );
        })(s(5546));
        ((o.Axios = n),
          (o.Cancel = s(5263)),
          (o.CancelToken = s(4972)),
          (o.isCancel = s(6502)),
          (o.VERSION = s(7288).version),
          (o.all = function (e) {
            return Promise.all(e);
          }),
          (o.spread = s(8713)),
          (o.isAxiosError = s(6268)),
          (e.exports = o),
          (e.exports.default = o));
      },
      5263: (e) => {
        'use strict';
        function t(e) {
          this.message = e;
        }
        ((t.prototype.toString = function () {
          return 'Cancel' + (this.message ? ': ' + this.message : '');
        }),
          (t.prototype.__CANCEL__ = !0),
          (e.exports = t));
      },
      4972: (e, t, s) => {
        'use strict';
        var i = s(5263);
        function a(e) {
          if ('function' != typeof e) throw new TypeError('executor must be a function.');
          var t;
          this.promise = new Promise(function (e) {
            t = e;
          });
          var s = this;
          (this.promise.then(function (e) {
            if (s._listeners) {
              var t,
                i = s._listeners.length;
              for (t = 0; t < i; t++) s._listeners[t](e);
              s._listeners = null;
            }
          }),
            (this.promise.then = function (e) {
              var t,
                i = new Promise(function (e) {
                  (s.subscribe(e), (t = e));
                }).then(e);
              return (
                (i.cancel = function () {
                  s.unsubscribe(t);
                }),
                i
              );
            }),
            e(function (e) {
              s.reason || ((s.reason = new i(e)), t(s.reason));
            }));
        }
        ((a.prototype.throwIfRequested = function () {
          if (this.reason) throw this.reason;
        }),
          (a.prototype.subscribe = function (e) {
            this.reason
              ? e(this.reason)
              : this._listeners
                ? this._listeners.push(e)
                : (this._listeners = [e]);
          }),
          (a.prototype.unsubscribe = function (e) {
            if (this._listeners) {
              var t = this._listeners.indexOf(e);
              -1 !== t && this._listeners.splice(t, 1);
            }
          }),
          (a.source = function () {
            var e;
            return {
              token: new a(function (t) {
                e = t;
              }),
              cancel: e,
            };
          }),
          (e.exports = a));
      },
      6502: (e) => {
        'use strict';
        e.exports = function (e) {
          return !(!e || !e.__CANCEL__);
        };
      },
      321: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = s(5327),
          n = s(782),
          r = s(3572),
          o = s(7185),
          l = s(4875),
          d = l.validators;
        function c(e) {
          ((this.defaults = e), (this.interceptors = { request: new n(), response: new n() }));
        }
        ((c.prototype.request = function (e, t) {
          ('string' == typeof e ? ((t = t || {}).url = e) : (t = e || {}),
            (t = o(this.defaults, t)).method
              ? (t.method = t.method.toLowerCase())
              : this.defaults.method
                ? (t.method = this.defaults.method.toLowerCase())
                : (t.method = 'get'));
          var s = t.transitional;
          void 0 !== s &&
            l.assertOptions(
              s,
              {
                silentJSONParsing: d.transitional(d.boolean),
                forcedJSONParsing: d.transitional(d.boolean),
                clarifyTimeoutError: d.transitional(d.boolean),
              },
              !1
            );
          var i = [],
            a = !0;
          this.interceptors.request.forEach(function (e) {
            ('function' == typeof e.runWhen && !1 === e.runWhen(t)) ||
              ((a = a && e.synchronous), i.unshift(e.fulfilled, e.rejected));
          });
          var n,
            c = [];
          if (
            (this.interceptors.response.forEach(function (e) {
              c.push(e.fulfilled, e.rejected);
            }),
            !a)
          ) {
            var p = [r, void 0];
            for (
              Array.prototype.unshift.apply(p, i), p = p.concat(c), n = Promise.resolve(t);
              p.length;
            )
              n = n.then(p.shift(), p.shift());
            return n;
          }
          for (var u = t; i.length; ) {
            var h = i.shift(),
              f = i.shift();
            try {
              u = h(u);
            } catch (e) {
              f(e);
              break;
            }
          }
          try {
            n = r(u);
          } catch (e) {
            return Promise.reject(e);
          }
          for (; c.length; ) n = n.then(c.shift(), c.shift());
          return n;
        }),
          (c.prototype.getUri = function (e) {
            return (
              (e = o(this.defaults, e)),
              a(e.url, e.params, e.paramsSerializer).replace(/^\?/, '')
            );
          }),
          i.forEach(['delete', 'get', 'head', 'options'], function (e) {
            c.prototype[e] = function (t, s) {
              return this.request(o(s || {}, { method: e, url: t, data: (s || {}).data }));
            };
          }),
          i.forEach(['post', 'put', 'patch'], function (e) {
            c.prototype[e] = function (t, s, i) {
              return this.request(o(i || {}, { method: e, url: t, data: s }));
            };
          }),
          (e.exports = c));
      },
      782: (e, t, s) => {
        'use strict';
        var i = s(4867);
        function a() {
          this.handlers = [];
        }
        ((a.prototype.use = function (e, t, s) {
          return (
            this.handlers.push({
              fulfilled: e,
              rejected: t,
              synchronous: !!s && s.synchronous,
              runWhen: s ? s.runWhen : null,
            }),
            this.handlers.length - 1
          );
        }),
          (a.prototype.eject = function (e) {
            this.handlers[e] && (this.handlers[e] = null);
          }),
          (a.prototype.forEach = function (e) {
            i.forEach(this.handlers, function (t) {
              null !== t && e(t);
            });
          }),
          (e.exports = a));
      },
      4097: (e, t, s) => {
        'use strict';
        var i = s(1793),
          a = s(7303);
        e.exports = function (e, t) {
          return e && !i(t) ? a(e, t) : t;
        };
      },
      5061: (e, t, s) => {
        'use strict';
        var i = s(481);
        e.exports = function (e, t, s, a, n) {
          var r = new Error(e);
          return i(r, t, s, a, n);
        };
      },
      3572: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = s(8527),
          n = s(6502),
          r = s(5546),
          o = s(5263);
        function l(e) {
          if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted))
            throw new o('canceled');
        }
        e.exports = function (e) {
          return (
            l(e),
            (e.headers = e.headers || {}),
            (e.data = a.call(e, e.data, e.headers, e.transformRequest)),
            (e.headers = i.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers)),
            i.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function (t) {
              delete e.headers[t];
            }),
            (e.adapter || r.adapter)(e).then(
              function (t) {
                return (l(e), (t.data = a.call(e, t.data, t.headers, e.transformResponse)), t);
              },
              function (t) {
                return (
                  n(t) ||
                    (l(e),
                    t &&
                      t.response &&
                      (t.response.data = a.call(
                        e,
                        t.response.data,
                        t.response.headers,
                        e.transformResponse
                      ))),
                  Promise.reject(t)
                );
              }
            )
          );
        };
      },
      481: (e) => {
        'use strict';
        e.exports = function (e, t, s, i, a) {
          return (
            (e.config = t),
            s && (e.code = s),
            (e.request = i),
            (e.response = a),
            (e.isAxiosError = !0),
            (e.toJSON = function () {
              return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
                status: this.response && this.response.status ? this.response.status : null,
              };
            }),
            e
          );
        };
      },
      7185: (e, t, s) => {
        'use strict';
        var i = s(4867);
        e.exports = function (e, t) {
          t = t || {};
          var s = {};
          function a(e, t) {
            return i.isPlainObject(e) && i.isPlainObject(t)
              ? i.merge(e, t)
              : i.isPlainObject(t)
                ? i.merge({}, t)
                : i.isArray(t)
                  ? t.slice()
                  : t;
          }
          function n(s) {
            return i.isUndefined(t[s])
              ? i.isUndefined(e[s])
                ? void 0
                : a(void 0, e[s])
              : a(e[s], t[s]);
          }
          function r(e) {
            if (!i.isUndefined(t[e])) return a(void 0, t[e]);
          }
          function o(s) {
            return i.isUndefined(t[s])
              ? i.isUndefined(e[s])
                ? void 0
                : a(void 0, e[s])
              : a(void 0, t[s]);
          }
          function l(s) {
            return s in t ? a(e[s], t[s]) : s in e ? a(void 0, e[s]) : void 0;
          }
          var d = {
            url: r,
            method: r,
            data: r,
            baseURL: o,
            transformRequest: o,
            transformResponse: o,
            paramsSerializer: o,
            timeout: o,
            timeoutMessage: o,
            withCredentials: o,
            adapter: o,
            responseType: o,
            xsrfCookieName: o,
            xsrfHeaderName: o,
            onUploadProgress: o,
            onDownloadProgress: o,
            decompress: o,
            maxContentLength: o,
            maxBodyLength: o,
            transport: o,
            httpAgent: o,
            httpsAgent: o,
            cancelToken: o,
            socketPath: o,
            responseEncoding: o,
            validateStatus: l,
          };
          return (
            i.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
              var t = d[e] || n,
                a = t(e);
              (i.isUndefined(a) && t !== l) || (s[e] = a);
            }),
            s
          );
        };
      },
      6026: (e, t, s) => {
        'use strict';
        var i = s(5061);
        e.exports = function (e, t, s) {
          var a = s.config.validateStatus;
          s.status && a && !a(s.status)
            ? t(i('Request failed with status code ' + s.status, s.config, null, s.request, s))
            : e(s);
        };
      },
      8527: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = s(5546);
        e.exports = function (e, t, s) {
          var n = this || a;
          return (
            i.forEach(s, function (s) {
              e = s.call(n, e, t);
            }),
            e
          );
        };
      },
      5546: (e, t, s) => {
        'use strict';
        var i = s(4155),
          a = s(4867),
          n = s(6016),
          r = s(481),
          o = s(7874),
          l = { 'Content-Type': 'application/x-www-form-urlencoded' };
        function d(e, t) {
          !a.isUndefined(e) && a.isUndefined(e['Content-Type']) && (e['Content-Type'] = t);
        }
        var c,
          p = {
            transitional: o,
            adapter:
              (('undefined' != typeof XMLHttpRequest ||
                (void 0 !== i && '[object process]' === Object.prototype.toString.call(i))) &&
                (c = s(5448)),
              c),
            transformRequest: [
              function (e, t) {
                return (
                  n(t, 'Accept'),
                  n(t, 'Content-Type'),
                  a.isFormData(e) ||
                  a.isArrayBuffer(e) ||
                  a.isBuffer(e) ||
                  a.isStream(e) ||
                  a.isFile(e) ||
                  a.isBlob(e)
                    ? e
                    : a.isArrayBufferView(e)
                      ? e.buffer
                      : a.isURLSearchParams(e)
                        ? (d(t, 'application/x-www-form-urlencoded;charset=utf-8'), e.toString())
                        : a.isObject(e) || (t && 'application/json' === t['Content-Type'])
                          ? (d(t, 'application/json'),
                            (function (e, t, s) {
                              if (a.isString(e))
                                try {
                                  return ((t || JSON.parse)(e), a.trim(e));
                                } catch (e) {
                                  if ('SyntaxError' !== e.name) throw e;
                                }
                              return (s || JSON.stringify)(e);
                            })(e))
                          : e
                );
              },
            ],
            transformResponse: [
              function (e) {
                var t = this.transitional || p.transitional,
                  s = t && t.silentJSONParsing,
                  i = t && t.forcedJSONParsing,
                  n = !s && 'json' === this.responseType;
                if (n || (i && a.isString(e) && e.length))
                  try {
                    return JSON.parse(e);
                  } catch (e) {
                    if (n) {
                      if ('SyntaxError' === e.name) throw r(e, this, 'E_JSON_PARSE');
                      throw e;
                    }
                  }
                return e;
              },
            ],
            timeout: 0,
            xsrfCookieName: 'XSRF-TOKEN',
            xsrfHeaderName: 'X-XSRF-TOKEN',
            maxContentLength: -1,
            maxBodyLength: -1,
            validateStatus: function (e) {
              return e >= 200 && e < 300;
            },
            headers: { common: { Accept: 'application/json, text/plain, */*' } },
          };
        (a.forEach(['delete', 'get', 'head'], function (e) {
          p.headers[e] = {};
        }),
          a.forEach(['post', 'put', 'patch'], function (e) {
            p.headers[e] = a.merge(l);
          }),
          (e.exports = p));
      },
      7874: (e) => {
        'use strict';
        e.exports = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 };
      },
      7288: (e) => {
        e.exports = { version: '0.26.1' };
      },
      1849: (e) => {
        'use strict';
        e.exports = function (e, t) {
          return function () {
            for (var s = new Array(arguments.length), i = 0; i < s.length; i++) s[i] = arguments[i];
            return e.apply(t, s);
          };
        };
      },
      5327: (e, t, s) => {
        'use strict';
        var i = s(4867);
        function a(e) {
          return encodeURIComponent(e)
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']');
        }
        e.exports = function (e, t, s) {
          if (!t) return e;
          var n;
          if (s) n = s(t);
          else if (i.isURLSearchParams(t)) n = t.toString();
          else {
            var r = [];
            (i.forEach(t, function (e, t) {
              null != e &&
                (i.isArray(e) ? (t += '[]') : (e = [e]),
                i.forEach(e, function (e) {
                  (i.isDate(e) ? (e = e.toISOString()) : i.isObject(e) && (e = JSON.stringify(e)),
                    r.push(a(t) + '=' + a(e)));
                }));
            }),
              (n = r.join('&')));
          }
          if (n) {
            var o = e.indexOf('#');
            (-1 !== o && (e = e.slice(0, o)), (e += (-1 === e.indexOf('?') ? '?' : '&') + n));
          }
          return e;
        };
      },
      7303: (e) => {
        'use strict';
        e.exports = function (e, t) {
          return t ? e.replace(/\/+$/, '') + '/' + t.replace(/^\/+/, '') : e;
        };
      },
      4372: (e, t, s) => {
        'use strict';
        var i = s(4867);
        e.exports = i.isStandardBrowserEnv()
          ? {
              write: function (e, t, s, a, n, r) {
                var o = [];
                (o.push(e + '=' + encodeURIComponent(t)),
                  i.isNumber(s) && o.push('expires=' + new Date(s).toGMTString()),
                  i.isString(a) && o.push('path=' + a),
                  i.isString(n) && o.push('domain=' + n),
                  !0 === r && o.push('secure'),
                  (document.cookie = o.join('; ')));
              },
              read: function (e) {
                var t = document.cookie.match(new RegExp('(^|;\\s*)(' + e + ')=([^;]*)'));
                return t ? decodeURIComponent(t[3]) : null;
              },
              remove: function (e) {
                this.write(e, '', Date.now() - 864e5);
              },
            }
          : {
              write: function () {},
              read: function () {
                return null;
              },
              remove: function () {},
            };
      },
      1793: (e) => {
        'use strict';
        e.exports = function (e) {
          return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
        };
      },
      6268: (e, t, s) => {
        'use strict';
        var i = s(4867);
        e.exports = function (e) {
          return i.isObject(e) && !0 === e.isAxiosError;
        };
      },
      7985: (e, t, s) => {
        'use strict';
        var i = s(4867);
        e.exports = i.isStandardBrowserEnv()
          ? (function () {
              var e,
                t = /(msie|trident)/i.test(navigator.userAgent),
                s = document.createElement('a');
              function a(e) {
                var i = e;
                return (
                  t && (s.setAttribute('href', i), (i = s.href)),
                  s.setAttribute('href', i),
                  {
                    href: s.href,
                    protocol: s.protocol ? s.protocol.replace(/:$/, '') : '',
                    host: s.host,
                    search: s.search ? s.search.replace(/^\?/, '') : '',
                    hash: s.hash ? s.hash.replace(/^#/, '') : '',
                    hostname: s.hostname,
                    port: s.port,
                    pathname: '/' === s.pathname.charAt(0) ? s.pathname : '/' + s.pathname,
                  }
                );
              }
              return (
                (e = a(window.location.href)),
                function (t) {
                  var s = i.isString(t) ? a(t) : t;
                  return s.protocol === e.protocol && s.host === e.host;
                }
              );
            })()
          : function () {
              return !0;
            };
      },
      6016: (e, t, s) => {
        'use strict';
        var i = s(4867);
        e.exports = function (e, t) {
          i.forEach(e, function (s, i) {
            i !== t && i.toUpperCase() === t.toUpperCase() && ((e[t] = s), delete e[i]);
          });
        };
      },
      4109: (e, t, s) => {
        'use strict';
        var i = s(4867),
          a = [
            'age',
            'authorization',
            'content-length',
            'content-type',
            'etag',
            'expires',
            'from',
            'host',
            'if-modified-since',
            'if-unmodified-since',
            'last-modified',
            'location',
            'max-forwards',
            'proxy-authorization',
            'referer',
            'retry-after',
            'user-agent',
          ];
        e.exports = function (e) {
          var t,
            s,
            n,
            r = {};
          return e
            ? (i.forEach(e.split('\n'), function (e) {
                if (
                  ((n = e.indexOf(':')),
                  (t = i.trim(e.substr(0, n)).toLowerCase()),
                  (s = i.trim(e.substr(n + 1))),
                  t)
                ) {
                  if (r[t] && a.indexOf(t) >= 0) return;
                  r[t] =
                    'set-cookie' === t
                      ? (r[t] ? r[t] : []).concat([s])
                      : r[t]
                        ? r[t] + ', ' + s
                        : s;
                }
              }),
              r)
            : r;
        };
      },
      8713: (e) => {
        'use strict';
        e.exports = function (e) {
          return function (t) {
            return e.apply(null, t);
          };
        };
      },
      4875: (e, t, s) => {
        'use strict';
        var i = s(7288).version,
          a = {};
        ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (e, t) {
          a[e] = function (s) {
            return typeof s === e || 'a' + (t < 1 ? 'n ' : ' ') + e;
          };
        });
        var n = {};
        ((a.transitional = function (e, t, s) {
          function a(e, t) {
            return '[Axios v' + i + "] Transitional option '" + e + "'" + t + (s ? '. ' + s : '');
          }
          return function (s, i, r) {
            if (!1 === e) throw new Error(a(i, ' has been removed' + (t ? ' in ' + t : '')));
            return (
              t &&
                !n[i] &&
                ((n[i] = !0),
                console.warn(
                  a(
                    i,
                    ' has been deprecated since v' + t + ' and will be removed in the near future'
                  )
                )),
              !e || e(s, i, r)
            );
          };
        }),
          (e.exports = {
            assertOptions: function (e, t, s) {
              if ('object' != typeof e) throw new TypeError('options must be an object');
              for (var i = Object.keys(e), a = i.length; a-- > 0; ) {
                var n = i[a],
                  r = t[n];
                if (r) {
                  var o = e[n],
                    l = void 0 === o || r(o, n, e);
                  if (!0 !== l) throw new TypeError('option ' + n + ' must be ' + l);
                } else if (!0 !== s) throw Error('Unknown option ' + n);
              }
            },
            validators: a,
          }));
      },
      4867: (e, t, s) => {
        'use strict';
        var i = s(1849),
          a = Object.prototype.toString;
        function n(e) {
          return Array.isArray(e);
        }
        function r(e) {
          return void 0 === e;
        }
        function o(e) {
          return '[object ArrayBuffer]' === a.call(e);
        }
        function l(e) {
          return null !== e && 'object' == typeof e;
        }
        function d(e) {
          if ('[object Object]' !== a.call(e)) return !1;
          var t = Object.getPrototypeOf(e);
          return null === t || t === Object.prototype;
        }
        function c(e) {
          return '[object Function]' === a.call(e);
        }
        function p(e, t) {
          if (null != e)
            if (('object' != typeof e && (e = [e]), n(e)))
              for (var s = 0, i = e.length; s < i; s++) t.call(null, e[s], s, e);
            else
              for (var a in e)
                Object.prototype.hasOwnProperty.call(e, a) && t.call(null, e[a], a, e);
        }
        e.exports = {
          isArray: n,
          isArrayBuffer: o,
          isBuffer: function (e) {
            return (
              null !== e &&
              !r(e) &&
              null !== e.constructor &&
              !r(e.constructor) &&
              'function' == typeof e.constructor.isBuffer &&
              e.constructor.isBuffer(e)
            );
          },
          isFormData: function (e) {
            return '[object FormData]' === a.call(e);
          },
          isArrayBufferView: function (e) {
            return 'undefined' != typeof ArrayBuffer && ArrayBuffer.isView
              ? ArrayBuffer.isView(e)
              : e && e.buffer && o(e.buffer);
          },
          isString: function (e) {
            return 'string' == typeof e;
          },
          isNumber: function (e) {
            return 'number' == typeof e;
          },
          isObject: l,
          isPlainObject: d,
          isUndefined: r,
          isDate: function (e) {
            return '[object Date]' === a.call(e);
          },
          isFile: function (e) {
            return '[object File]' === a.call(e);
          },
          isBlob: function (e) {
            return '[object Blob]' === a.call(e);
          },
          isFunction: c,
          isStream: function (e) {
            return l(e) && c(e.pipe);
          },
          isURLSearchParams: function (e) {
            return '[object URLSearchParams]' === a.call(e);
          },
          isStandardBrowserEnv: function () {
            return (
              ('undefined' == typeof navigator ||
                ('ReactNative' !== navigator.product &&
                  'NativeScript' !== navigator.product &&
                  'NS' !== navigator.product)) &&
              'undefined' != typeof window &&
              'undefined' != typeof document
            );
          },
          forEach: p,
          merge: function e() {
            var t = {};
            function s(s, i) {
              d(t[i]) && d(s)
                ? (t[i] = e(t[i], s))
                : d(s)
                  ? (t[i] = e({}, s))
                  : n(s)
                    ? (t[i] = s.slice())
                    : (t[i] = s);
            }
            for (var i = 0, a = arguments.length; i < a; i++) p(arguments[i], s);
            return t;
          },
          extend: function (e, t, s) {
            return (
              p(t, function (t, a) {
                e[a] = s && 'function' == typeof t ? i(t, s) : t;
              }),
              e
            );
          },
          trim: function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, '');
          },
          stripBOM: function (e) {
            return (65279 === e.charCodeAt(0) && (e = e.slice(1)), e);
          },
        };
      },
      456: (e, t, s) => {
        'use strict';
        function i(e) {
          return (
            (function (e) {
              if (Array.isArray(e)) return a(e);
            })(e) ||
            (function (e) {
              if (
                ('undefined' != typeof Symbol && null != e[Symbol.iterator]) ||
                null != e['@@iterator']
              )
                return Array.from(e);
            })(e) ||
            (function (e, t) {
              if (!e) return;
              if ('string' == typeof e) return a(e, t);
              var s = Object.prototype.toString.call(e).slice(8, -1);
              'Object' === s && e.constructor && (s = e.constructor.name);
              if ('Map' === s || 'Set' === s) return Array.from(e);
              if ('Arguments' === s || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
                return a(e, t);
            })(e) ||
            (function () {
              throw new TypeError(
                'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
              );
            })()
          );
        }
        function a(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var s = 0, i = new Array(t); s < t; s++) i[s] = e[s];
          return i;
        }
        s.d(t, {
          $8: () => u,
          Bz: () => m,
          LL: () => f,
          Qb: () => g,
          Xq: () => r,
          Xu: () => l,
          cr: () => o,
          dv: () => d,
          h2: () => p,
          xu: () => h,
        });
        var n = s(9669);
        function r(e, t) {
          var s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
            r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null;
          return n
            .post('/cart/add.js', { items: [{ id: e, quantity: t, properties: s }] })
            .then(function (n) {
              (window.log('Success:', n),
                i instanceof Function && (window.log('Calling success callback'), i(n)));
              var o = new CustomEvent('cart_changed', {
                detail: {
                  response: n,
                  items: [{ variant_id: e, quantity: t, properties: s }],
                  successCallBack: i,
                  errorCallBack: a,
                  completeCallBack: r,
                },
              });
              window.dispatchEvent(o);
              var l = new CustomEvent('item_added', {
                detail: {
                  response: n,
                  variant_id: e,
                  quantity: t,
                  properties: s,
                  successCallBack: i,
                  errorCallBack: a,
                  completeCallBack: r,
                },
              });
              window.dispatchEvent(l);
            })
            .catch(function (e) {
              if ((window.log('Error:', e), a instanceof Function && a(), e.response)) {
                var t = e.response.data.description;
                t &&
                  window
                    .Toastify({
                      text: t,
                      duration: 3e3,
                      close: !0,
                      gravity: 'top',
                      position: 'right',
                      stopOnFocus: !0,
                      style: { background: 'black' },
                      onClick: window.qf_side_cart.openSideCart,
                    })
                    .showToast();
              }
            })
            .then(function () {
              (window.log('Complete'), r instanceof Function && r(), window.vatCheckingBox());
            });
        }
        function o(e, t) {
          var s = e;
          if (
            (window.log('item', e),
            window.log('isVatInputCart', t),
            t && 'false' == e.properties._taxDeductible)
          ) {
            var i,
              a =
                parseInt(
                  null === (i = document.querySelector('#taxAmount')) || void 0 === i
                    ? void 0
                    : i.getAttribute('data-vat-amount')
                ) || 20,
              n = Math.round((e.final_price / (a + 100)) * 100);
            ((s.properties._taxDeductible =
              'true' == e.properties._taxDeductible || 'false' == e.properties._taxDeductible
                ? 'true'
                : 'null'),
              (s.properties._reducedPrice =
                'true' == e.properties._taxDeductible || 'false' == e.properties._taxDeductible
                  ? n
                  : ''));
          } else
            0 == t &&
              ((s.properties._taxDeductible =
                'true' == e.properties._taxDeductible || 'false' == e.properties._taxDeductible
                  ? 'false'
                  : 'null'),
              (s.properties._reducedPrice = ''));
          return (window.log('return item', s), s);
        }
        function l(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = [];
          (e
            ? document.querySelectorAll('[data-tax-deductible]').forEach(function (e) {
                var t, s;
                ('true' !=
                  (null === (t = e.getAttribute('data-tax-deductible')) || void 0 === t
                    ? void 0
                    : t.toLocaleLowerCase()) &&
                  'false' !=
                    (null === (s = e.getAttribute('data-tax-deductible')) || void 0 === s
                      ? void 0
                      : s.toLocaleLowerCase())) ||
                  e.setAttribute('data-tax-deductible', 'true');
              })
            : document.querySelectorAll('[data-tax-deductible]').forEach(function (e) {
                var t, s;
                ('true' !=
                  (null === (t = e.getAttribute('data-tax-deductible')) || void 0 === t
                    ? void 0
                    : t.toLocaleLowerCase()) &&
                  'false' !=
                    (null === (s = e.getAttribute('data-tax-deductible')) || void 0 === s
                      ? void 0
                      : s.toLocaleLowerCase())) ||
                  e.setAttribute('data-tax-deductible', 'false');
              }),
            document.querySelector('.vat-click-blocker').classList.add('active'),
            n.get('/cart.js').then(function (a) {
              if (a.data.items.length > 0) {
                var n = document.querySelector('.change-vat-selection');
                (n && ((n.disabled = !0), (n.innerHTML = 'Updating Cart, Please wait...')),
                  a.data.items.forEach(function (t) {
                    s.push(o(t, e));
                  }),
                  window.axios.post('/cart/clear.js').then(function () {
                    var e;
                    null != t
                      ? (e = window.axios).post.apply(e, i(t)).then(function () {
                          (c(s), n && ((n.disabled = !1), (n.innerHTML = 'Change VAT Selection')));
                        })
                      : (c(s), n && ((n.disabled = !1), (n.innerHTML = 'Change VAT Selection')));
                  }));
              } else document.querySelector('.vat-click-blocker').classList.remove('active');
            }));
        }
        function d(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          return (
            window.log('bulk add to cart', e),
            n
              .post('/cart/add.js', { items: e })
              .then(function (a) {
                window.log('Success:', a);
                var r = 0;
                n.get('/cart.js').then(function (n) {
                  (window.log('Success cart:', n),
                    t instanceof Function && t(n),
                    (r = n.data.items.length));
                  var o = new CustomEvent('cart_changed', {
                    detail: {
                      response: a,
                      items: e,
                      successCallBack: t,
                      errorCallBack: s,
                      completeCallBack: i,
                      cartSize: r,
                    },
                  });
                  window.dispatchEvent(o);
                });
              })
              .then(function () {
                (window.log('Complete'), i instanceof Function && i(), window.vatCheckingBox());
              })
              .catch(function (e) {
                (window.log('Error:', e), s instanceof Function && s());
              })
          );
        }
        function c(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          return (
            window.log('bulk add to cart', e),
            n
              .post('/cart/add.js', { items: e })
              .then(function (e) {
                window.log('Success:', e);
                n.get('/cart.js').then(function (e) {
                  (window.log('Success cart:', e),
                    t instanceof Function && t(e),
                    'cart' == window.template
                      ? window.qf_cart.reRenderCart()
                      : window.qf_side_cart.reRenderSideCart());
                });
              })
              .then(function () {
                (window.log('Complete'),
                  i instanceof Function && i(),
                  window.vatCheckingBox(),
                  document.querySelector('.vat-click-blocker').classList.remove('active'));
              })
              .catch(function (e) {
                (window.log('Error:', e), s instanceof Function && s());
              })
          );
        }
        function p(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          window.log('Removing '.concat(e, ' from the cart'));
          var a = {};
          if (Array.isArray(e)) for (var r = 0; r < e.length; r++) a[e[r]] = 0;
          else a[e] = 0;
          return n
            .post('/cart/update.js', { updates: a })
            .then(function (a) {
              (window.log('Success:', a), t instanceof Function && t());
              var n = new CustomEvent('item_removed', {
                detail: {
                  response: a,
                  variant_id: e,
                  successCallBack: t,
                  errorCallBack: s,
                  completeCallBack: i,
                },
              });
              a &&
                document.querySelectorAll('.cart-count').forEach(function (e) {
                  e.innerHTML = a.data.item_count;
                });
              window.dispatchEvent(n);
            })
            .catch(function (e) {
              (window.log('Error:', e), s instanceof Function && s());
            })
            .then(function () {
              (window.log('Complete'), i instanceof Function && i(), window.vatCheckingBox());
            });
        }
        function u(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          return (
            window.log('CHANGE.JS: Removing '.concat(e)),
            n
              .post('/cart/update.js', { updates: e })
              .then(function (a) {
                (window.log('Success:', a), t instanceof Function && t());
                var n = new CustomEvent('uniq_item_removed', {
                  detail: {
                    response: a,
                    items: e,
                    successCallBack: t,
                    errorCallBack: s,
                    completeCallBack: i,
                  },
                });
                a &&
                  document.querySelectorAll('.cart-count').forEach(function (e) {
                    e.innerHTML = a.data.item_count;
                  });
                window.dispatchEvent(n);
              })
              .catch(function (e) {
                (window.log('Error:', e), s instanceof Function && s());
              })
              .then(function () {
                (window.log('Complete'), i instanceof Function && i(), g());
              })
          );
        }
        function h() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          return n
            .post('/cart/update.js', { updates: e })
            .then(function (a) {
              (window.log('Success:', a), t instanceof Function && t());
              var n = new CustomEvent('cart_changed', {
                detail: {
                  response: a,
                  items: e,
                  successCallBack: t,
                  errorCallBack: s,
                  completeCallBack: i,
                },
              });
              window.dispatchEvent(n);
            })
            .catch(function (e) {
              (window.log('Error:', e), s instanceof Function && s());
            })
            .then(function () {
              (window.log('Complete'), i instanceof Function && i(), window.vatCheckingBox());
            });
        }
        function f() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return n
            .post('/cart/clear.js')
            .then(function (i) {
              (window.log('Success:', i), e instanceof Function && e(i));
              var a = new CustomEvent('cart_changed', {
                detail: {
                  response: i,
                  items: [],
                  successCallBack: e,
                  errorCallBack: t,
                  completeCallBack: s,
                },
              });
              window.dispatchEvent(a);
              var n = new CustomEvent('cart_cleared', { detail: {} });
              window.dispatchEvent(n);
            })
            .catch(function (e) {
              (window.log('Error:', e), t instanceof Function && t());
            })
            .then(function () {
              (window.log('Complete'), s instanceof Function && s(), window.vatCheckingBox());
            });
        }
        function m() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return n
            .get('/cart.js')
            .then(function (t) {
              (window.log('Success:', t), e instanceof Function && e(t));
            })
            .catch(function (e) {
              (window.log('Error:', e), t instanceof Function && t());
            })
            .then(function () {
              (window.log('Complete'), s instanceof Function && s(), window.vatCheckingBox());
            });
        }
        function g() {
          return (
            window.log('Redrendering cart'),
            n
              .get(' /cart?sections=cart-qf', {})
              .then(function (e) {
                var t = e.data['cart-qf'],
                  s = document.querySelector('#cart-container');
                if (s && t) {
                  if ('cart' === window.template)
                    ((t = new DOMParser()
                      .parseFromString(t, 'text/html')
                      .querySelector('.cart-step[data-step="2"]').innerHTML),
                      (s = document.querySelector("#cart-container .cart-step[data-step='2']")));
                  s.innerHTML = t;
                  var i = new CustomEvent('cart_rendered', { detail: { response: e, html: t } });
                  (window.dispatchEvent(i),
                    'cart' === window.template &&
                      0 === document.querySelectorAll('.cart-item-vat').length &&
                      (document.querySelector('.cart-step[data-step="1"]').style.display = 'none'));
                }
              })
              .catch(function (e) {
                window.log('Error:', e);
              })
              .then(function () {
                (window.log('Complete'), window.vatCheckingBox());
              })
          );
        }
      },
      2615: (e, t, s) => {
        'use strict';
        s.d(t, { Z: () => n });
        var i = s(3645),
          a = s.n(i)()(function (e) {
            return e[1];
          });
        a.push([
          e.id,
          '@font-face{font-family:swiper-icons;font-style:normal;font-weight:400;src:url("data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA")}:root{--swiper-theme-color:#007aff}.swiper{list-style:none;margin-left:auto;margin-right:auto;overflow:hidden;padding:0;position:relative;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{box-sizing:initial;display:flex;height:100%;position:relative;transition-property:transform;width:100%;z-index:1}.swiper-android .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;height:100%;position:relative;transition-property:transform;width:100%}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:10}.swiper-3d .swiper-slide-shadow{background:#00000026}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(270deg,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(90deg,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(0deg,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(180deg,#00000080,#0000)}.swiper-css-mode>.swiper-wrapper{-ms-overflow-style:none;overflow:auto;scrollbar-width:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper:before{content:"";flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper:before{height:var(--swiper-centered-offset-after);min-width:1px;width:100%}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center}.swiper-virtual.swiper-css-mode .swiper-wrapper:after{content:"";left:0;pointer-events:none;position:absolute;top:0}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper:after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper:after{height:var(--swiper-virtual-size);width:1px}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{align-items:center;color:var(--swiper-navigation-color,var(--swiper-theme-color));cursor:pointer;display:flex;height:var(--swiper-navigation-size);justify-content:center;margin-top:calc(0px - var(--swiper-navigation-size)/2);position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/44*27);z-index:10}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{cursor:auto;opacity:.35;pointer-events:none}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);font-variant:normal;letter-spacing:0;line-height:1;text-transform:none!important;text-transform:none}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:"prev"}.swiper-button-next,.swiper-rtl .swiper-button-prev{left:auto;right:10px}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:"next"}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transform:translateZ(0);transition:opacity .3s;z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{font-size:0;overflow:hidden}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{position:relative;transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{background:var(--swiper-pagination-bullet-inactive-color,#000);border-radius:50%;display:inline-block;height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));opacity:var(--swiper-pagination-bullet-inactive-opacity,.2);width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px))}button.swiper-pagination-bullet{appearance:none;border:none;box-shadow:none;margin:0;padding:0}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{background:var(--swiper-pagination-color,var(--swiper-theme-color));opacity:var(--swiper-pagination-bullet-opacity,1)}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{display:block;margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:transform .2s,top .2s}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:transform .2s,left .2s}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:transform .2s,right .2s}.swiper-pagination-progressbar{background:#00000040;position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));height:100%;left:0;position:absolute;top:0;transform:scale(0);transform-origin:left top;width:100%}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{height:4px;left:0;top:0;width:100%}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{height:100%;left:0;top:0;width:4px}.swiper-pagination-lock{display:none}.swiper-scrollbar{background:#0000001a;border-radius:10px;position:relative;-ms-touch-action:none}.swiper-horizontal>.swiper-scrollbar{bottom:3px;height:5px;left:1%;position:absolute;width:98%;z-index:50}.swiper-vertical>.swiper-scrollbar{height:98%;position:absolute;right:3px;top:1%;width:5px;z-index:50}.swiper-scrollbar-drag{background:#00000080;border-radius:10px;height:100%;left:0;position:relative;top:0;width:100%}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{align-items:center;display:flex;height:100%;justify-content:center;text-align:center;width:100%}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-height:100%;max-width:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s linear infinite;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top:4px solid #0000;box-sizing:border-box;height:42px;left:50%;margin-left:-21px;margin-top:-21px;position:absolute;top:50%;transform-origin:50%;width:42px;z-index:10}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{to{transform:rotate(1turn)}}.swiper .swiper-notification{left:0;opacity:0;pointer-events:none;position:absolute;top:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{margin:0 auto;transition-timing-function:ease-out}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-direction:column;flex-wrap:wrap}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{backface-visibility:hidden;height:100%;pointer-events:none;transform-origin:0 0;visibility:hidden;width:100%;z-index:1}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-next+.swiper-slide,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{backface-visibility:hidden;z-index:0}.swiper-cube .swiper-cube-shadow{bottom:0;height:100%;left:0;opacity:.6;position:absolute;width:100%;z-index:0}.swiper-cube .swiper-cube-shadow:before{background:#000;bottom:0;content:"";filter:blur(50px);left:0;position:absolute;right:0;top:0}.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{backface-visibility:hidden;pointer-events:none;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{backface-visibility:hidden;z-index:0}.swiper-creative .swiper-slide{backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{backface-visibility:hidden;overflow:hidden;transform-origin:center bottom}',
          '',
        ]);
        const n = a;
      },
      9528: (e, t, s) => {
        'use strict';
        s.d(t, { Z: () => n });
        var i = s(3645),
          a = s.n(i)()(function (e) {
            return e[1];
          });
        a.push([
          e.id,
          '/*!\n * Toastify js 1.11.2\n * https://github.com/apvarun/toastify-js\n * @license MIT licensed\n *\n * Copyright (C) 2018 Varun A P\n */.toastify{background:linear-gradient(135deg,#73a5ff,#5477f5);border-radius:2px;box-shadow:0 3px 6px -1px #0000001f,0 10px 36px -4px #4d60e84d;color:#fff;cursor:pointer;display:inline-block;max-width:calc(50% - 20px);opacity:0;padding:12px 20px;position:fixed;text-decoration:none;transition:all .4s cubic-bezier(.215,.61,.355,1);z-index:2147483647}.toastify.on{opacity:1}.toast-close{opacity:.4;padding:0 5px}.toastify-right{right:15px}.toastify-left{left:15px}.toastify-top{top:-150px}.toastify-bottom{bottom:-150px}.toastify-rounded{border-radius:25px}.toastify-avatar{border-radius:2px;height:1.5em;margin:-7px 5px;width:1.5em}.toastify-center{left:0;margin-left:auto;margin-right:auto;max-width:fit-content;max-width:-moz-fit-content;right:0}@media only screen and (max-width:360px){.toastify-left,.toastify-right{left:0;margin-left:auto;margin-right:auto;max-width:-moz-fit-content;max-width:fit-content;right:0}}',
          '',
        ]);
        const n = a;
      },
      3645: (e) => {
        'use strict';
        e.exports = function (e) {
          var t = [];
          return (
            (t.toString = function () {
              return this.map(function (t) {
                var s = e(t);
                return t[2] ? '@media '.concat(t[2], ' {').concat(s, '}') : s;
              }).join('');
            }),
            (t.i = function (e, s, i) {
              'string' == typeof e && (e = [[null, e, '']]);
              var a = {};
              if (i)
                for (var n = 0; n < this.length; n++) {
                  var r = this[n][0];
                  null != r && (a[r] = !0);
                }
              for (var o = 0; o < e.length; o++) {
                var l = [].concat(e[o]);
                (i && a[l[0]]) ||
                  (s && (l[2] ? (l[2] = ''.concat(s, ' and ').concat(l[2])) : (l[2] = s)),
                  t.push(l));
              }
            }),
            t
          );
        };
      },
      4155: (e) => {
        var t,
          s,
          i = (e.exports = {});
        function a() {
          throw new Error('setTimeout has not been defined');
        }
        function n() {
          throw new Error('clearTimeout has not been defined');
        }
        function r(e) {
          if (t === setTimeout) return setTimeout(e, 0);
          if ((t === a || !t) && setTimeout) return ((t = setTimeout), setTimeout(e, 0));
          try {
            return t(e, 0);
          } catch (s) {
            try {
              return t.call(null, e, 0);
            } catch (s) {
              return t.call(this, e, 0);
            }
          }
        }
        !(function () {
          try {
            t = 'function' == typeof setTimeout ? setTimeout : a;
          } catch (e) {
            t = a;
          }
          try {
            s = 'function' == typeof clearTimeout ? clearTimeout : n;
          } catch (e) {
            s = n;
          }
        })();
        var o,
          l = [],
          d = !1,
          c = -1;
        function p() {
          d && o && ((d = !1), o.length ? (l = o.concat(l)) : (c = -1), l.length && u());
        }
        function u() {
          if (!d) {
            var e = r(p);
            d = !0;
            for (var t = l.length; t; ) {
              for (o = l, l = []; ++c < t; ) o && o[c].run();
              ((c = -1), (t = l.length));
            }
            ((o = null),
              (d = !1),
              (function (e) {
                if (s === clearTimeout) return clearTimeout(e);
                if ((s === n || !s) && clearTimeout) return ((s = clearTimeout), clearTimeout(e));
                try {
                  s(e);
                } catch (t) {
                  try {
                    return s.call(null, e);
                  } catch (t) {
                    return s.call(this, e);
                  }
                }
              })(e));
          }
        }
        function h(e, t) {
          ((this.fun = e), (this.array = t));
        }
        function f() {}
        ((i.nextTick = function (e) {
          var t = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var s = 1; s < arguments.length; s++) t[s - 1] = arguments[s];
          (l.push(new h(e, t)), 1 !== l.length || d || r(u));
        }),
          (h.prototype.run = function () {
            this.fun.apply(null, this.array);
          }),
          (i.title = 'browser'),
          (i.browser = !0),
          (i.env = {}),
          (i.argv = []),
          (i.version = ''),
          (i.versions = {}),
          (i.on = f),
          (i.addListener = f),
          (i.once = f),
          (i.off = f),
          (i.removeListener = f),
          (i.removeAllListeners = f),
          (i.emit = f),
          (i.prependListener = f),
          (i.prependOnceListener = f),
          (i.listeners = function (e) {
            return [];
          }),
          (i.binding = function (e) {
            throw new Error('process.binding is not supported');
          }),
          (i.cwd = function () {
            return '/';
          }),
          (i.chdir = function (e) {
            throw new Error('process.chdir is not supported');
          }),
          (i.umask = function () {
            return 0;
          }));
      },
      3379: (e, t, s) => {
        'use strict';
        var i,
          a = function () {
            return (
              void 0 === i && (i = Boolean(window && document && document.all && !window.atob)),
              i
            );
          },
          n = (function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var s = document.querySelector(t);
                if (window.HTMLIFrameElement && s instanceof window.HTMLIFrameElement)
                  try {
                    s = s.contentDocument.head;
                  } catch (e) {
                    s = null;
                  }
                e[t] = s;
              }
              return e[t];
            };
          })(),
          r = [];
        function o(e) {
          for (var t = -1, s = 0; s < r.length; s++)
            if (r[s].identifier === e) {
              t = s;
              break;
            }
          return t;
        }
        function l(e, t) {
          for (var s = {}, i = [], a = 0; a < e.length; a++) {
            var n = e[a],
              l = t.base ? n[0] + t.base : n[0],
              d = s[l] || 0,
              c = ''.concat(l, ' ').concat(d);
            s[l] = d + 1;
            var p = o(c),
              u = { css: n[1], media: n[2], sourceMap: n[3] };
            (-1 !== p
              ? (r[p].references++, r[p].updater(u))
              : r.push({ identifier: c, updater: g(u, t), references: 1 }),
              i.push(c));
          }
          return i;
        }
        function d(e) {
          var t = document.createElement('style'),
            i = e.attributes || {};
          if (void 0 === i.nonce) {
            var a = s.nc;
            a && (i.nonce = a);
          }
          if (
            (Object.keys(i).forEach(function (e) {
              t.setAttribute(e, i[e]);
            }),
            'function' == typeof e.insert)
          )
            e.insert(t);
          else {
            var r = n(e.insert || 'head');
            if (!r)
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            r.appendChild(t);
          }
          return t;
        }
        var c,
          p =
            ((c = []),
            function (e, t) {
              return ((c[e] = t), c.filter(Boolean).join('\n'));
            });
        function u(e, t, s, i) {
          var a = s ? '' : i.media ? '@media '.concat(i.media, ' {').concat(i.css, '}') : i.css;
          if (e.styleSheet) e.styleSheet.cssText = p(t, a);
          else {
            var n = document.createTextNode(a),
              r = e.childNodes;
            (r[t] && e.removeChild(r[t]), r.length ? e.insertBefore(n, r[t]) : e.appendChild(n));
          }
        }
        function h(e, t, s) {
          var i = s.css,
            a = s.media,
            n = s.sourceMap;
          if (
            (a ? e.setAttribute('media', a) : e.removeAttribute('media'),
            n &&
              'undefined' != typeof btoa &&
              (i += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
                btoa(unescape(encodeURIComponent(JSON.stringify(n)))),
                ' */'
              )),
            e.styleSheet)
          )
            e.styleSheet.cssText = i;
          else {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(i));
          }
        }
        var f = null,
          m = 0;
        function g(e, t) {
          var s, i, a;
          if (t.singleton) {
            var n = m++;
            ((s = f || (f = d(t))), (i = u.bind(null, s, n, !1)), (a = u.bind(null, s, n, !0)));
          } else
            ((s = d(t)),
              (i = h.bind(null, s, t)),
              (a = function () {
                !(function (e) {
                  if (null === e.parentNode) return !1;
                  e.parentNode.removeChild(e);
                })(s);
              }));
          return (
            i(e),
            function (t) {
              if (t) {
                if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                i((e = t));
              } else a();
            }
          );
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || 'boolean' == typeof t.singleton || (t.singleton = a());
          var s = l((e = e || []), t);
          return function (e) {
            if (((e = e || []), '[object Array]' === Object.prototype.toString.call(e))) {
              for (var i = 0; i < s.length; i++) {
                var a = o(s[i]);
                r[a].references--;
              }
              for (var n = l(e, t), d = 0; d < s.length; d++) {
                var c = o(s[d]);
                0 === r[c].references && (r[c].updater(), r.splice(c, 1));
              }
              s = n;
            }
          };
        };
      },
      8588: function (e) {
        var t, s;
        ((t = this),
          (s = function (e) {
            var t = function (e) {
              return new t.lib.init(e);
            };
            function s(e, t) {
              return t.offset[e] ? (isNaN(t.offset[e]) ? t.offset[e] : t.offset[e] + 'px') : '0px';
            }
            function i(e, t) {
              return !(
                !e ||
                'string' != typeof t ||
                !(e.className && e.className.trim().split(/\s+/gi).indexOf(t) > -1)
              );
            }
            return (
              (t.defaults = {
                oldestFirst: !0,
                text: 'Toastify is awesome!',
                node: void 0,
                duration: 3e3,
                selector: void 0,
                callback: function () {},
                destination: void 0,
                newWindow: !1,
                close: !1,
                gravity: 'toastify-top',
                positionLeft: !1,
                position: '',
                backgroundColor: '',
                avatar: '',
                className: '',
                stopOnFocus: !0,
                onClick: function () {},
                offset: { x: 0, y: 0 },
                escapeMarkup: !0,
                style: { background: '' },
              }),
              (t.lib = t.prototype =
                {
                  toastify: '1.11.2',
                  constructor: t,
                  init: function (e) {
                    return (
                      e || (e = {}),
                      (this.options = {}),
                      (this.toastElement = null),
                      (this.options.text = e.text || t.defaults.text),
                      (this.options.node = e.node || t.defaults.node),
                      (this.options.duration =
                        0 === e.duration ? 0 : e.duration || t.defaults.duration),
                      (this.options.selector = e.selector || t.defaults.selector),
                      (this.options.callback = e.callback || t.defaults.callback),
                      (this.options.destination = e.destination || t.defaults.destination),
                      (this.options.newWindow = e.newWindow || t.defaults.newWindow),
                      (this.options.close = e.close || t.defaults.close),
                      (this.options.gravity =
                        'bottom' === e.gravity ? 'toastify-bottom' : t.defaults.gravity),
                      (this.options.positionLeft = e.positionLeft || t.defaults.positionLeft),
                      (this.options.position = e.position || t.defaults.position),
                      (this.options.backgroundColor =
                        e.backgroundColor || t.defaults.backgroundColor),
                      (this.options.avatar = e.avatar || t.defaults.avatar),
                      (this.options.className = e.className || t.defaults.className),
                      (this.options.stopOnFocus =
                        void 0 === e.stopOnFocus ? t.defaults.stopOnFocus : e.stopOnFocus),
                      (this.options.onClick = e.onClick || t.defaults.onClick),
                      (this.options.offset = e.offset || t.defaults.offset),
                      (this.options.escapeMarkup =
                        void 0 !== e.escapeMarkup ? e.escapeMarkup : t.defaults.escapeMarkup),
                      (this.options.style = e.style || t.defaults.style),
                      e.backgroundColor && (this.options.style.background = e.backgroundColor),
                      this
                    );
                  },
                  buildToast: function () {
                    if (!this.options) throw 'Toastify is not initialized';
                    var e = document.createElement('div');
                    for (var t in ((e.className = 'toastify on ' + this.options.className),
                    this.options.position
                      ? (e.className += ' toastify-' + this.options.position)
                      : !0 === this.options.positionLeft
                        ? ((e.className += ' toastify-left'),
                          console.warn(
                            'Property `positionLeft` will be depreciated in further versions. Please use `position` instead.'
                          ))
                        : (e.className += ' toastify-right'),
                    (e.className += ' ' + this.options.gravity),
                    this.options.backgroundColor &&
                      console.warn(
                        'DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.'
                      ),
                    this.options.style))
                      e.style[t] = this.options.style[t];
                    if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE)
                      e.appendChild(this.options.node);
                    else if (
                      (this.options.escapeMarkup
                        ? (e.innerText = this.options.text)
                        : (e.innerHTML = this.options.text),
                      '' !== this.options.avatar)
                    ) {
                      var i = document.createElement('img');
                      ((i.src = this.options.avatar),
                        (i.className = 'toastify-avatar'),
                        'left' == this.options.position || !0 === this.options.positionLeft
                          ? e.appendChild(i)
                          : e.insertAdjacentElement('afterbegin', i));
                    }
                    if (!0 === this.options.close) {
                      var a = document.createElement('span');
                      ((a.innerHTML = '&#10006;'),
                        (a.className = 'toast-close'),
                        a.addEventListener(
                          'click',
                          function (e) {
                            (e.stopPropagation(),
                              this.removeElement(this.toastElement),
                              window.clearTimeout(this.toastElement.timeOutValue));
                          }.bind(this)
                        ));
                      var n = window.innerWidth > 0 ? window.innerWidth : screen.width;
                      ('left' == this.options.position || !0 === this.options.positionLeft) &&
                      n > 360
                        ? e.insertAdjacentElement('afterbegin', a)
                        : e.appendChild(a);
                    }
                    if (this.options.stopOnFocus && this.options.duration > 0) {
                      var r = this;
                      (e.addEventListener('mouseover', function (t) {
                        window.clearTimeout(e.timeOutValue);
                      }),
                        e.addEventListener('mouseleave', function () {
                          e.timeOutValue = window.setTimeout(function () {
                            r.removeElement(e);
                          }, r.options.duration);
                        }));
                    }
                    if (
                      (void 0 !== this.options.destination &&
                        e.addEventListener(
                          'click',
                          function (e) {
                            (e.stopPropagation(),
                              !0 === this.options.newWindow
                                ? window.open(this.options.destination, '_blank')
                                : (window.location = this.options.destination));
                          }.bind(this)
                        ),
                      'function' == typeof this.options.onClick &&
                        void 0 === this.options.destination &&
                        e.addEventListener(
                          'click',
                          function (e) {
                            (e.stopPropagation(), this.options.onClick());
                          }.bind(this)
                        ),
                      'object' == typeof this.options.offset)
                    ) {
                      var o = s('x', this.options),
                        l = s('y', this.options),
                        d = 'left' == this.options.position ? o : '-' + o,
                        c = 'toastify-top' == this.options.gravity ? l : '-' + l;
                      e.style.transform = 'translate(' + d + ',' + c + ')';
                    }
                    return e;
                  },
                  showToast: function () {
                    var e;
                    if (
                      ((this.toastElement = this.buildToast()),
                      !(e =
                        'string' == typeof this.options.selector
                          ? document.getElementById(this.options.selector)
                          : this.options.selector instanceof HTMLElement ||
                              ('undefined' != typeof ShadowRoot &&
                                this.options.selector instanceof ShadowRoot)
                            ? this.options.selector
                            : document.body))
                    )
                      throw 'Root element is not defined';
                    var s = t.defaults.oldestFirst ? e.firstChild : e.lastChild;
                    return (
                      e.insertBefore(this.toastElement, s),
                      t.reposition(),
                      this.options.duration > 0 &&
                        (this.toastElement.timeOutValue = window.setTimeout(
                          function () {
                            this.removeElement(this.toastElement);
                          }.bind(this),
                          this.options.duration
                        )),
                      this
                    );
                  },
                  hideToast: function () {
                    (this.toastElement.timeOutValue && clearTimeout(this.toastElement.timeOutValue),
                      this.removeElement(this.toastElement));
                  },
                  removeElement: function (e) {
                    ((e.className = e.className.replace(' on', '')),
                      window.setTimeout(
                        function () {
                          (this.options.node &&
                            this.options.node.parentNode &&
                            this.options.node.parentNode.removeChild(this.options.node),
                            e.parentNode && e.parentNode.removeChild(e),
                            this.options.callback.call(e),
                            t.reposition());
                        }.bind(this),
                        400
                      ));
                  },
                }),
              (t.reposition = function () {
                for (
                  var e,
                    t = { top: 15, bottom: 15 },
                    s = { top: 15, bottom: 15 },
                    a = { top: 15, bottom: 15 },
                    n = document.getElementsByClassName('toastify'),
                    r = 0;
                  r < n.length;
                  r++
                ) {
                  e = !0 === i(n[r], 'toastify-top') ? 'toastify-top' : 'toastify-bottom';
                  var o = n[r].offsetHeight;
                  ((e = e.substr(9, e.length - 1)),
                    (window.innerWidth > 0 ? window.innerWidth : screen.width) <= 360
                      ? ((n[r].style[e] = a[e] + 'px'), (a[e] += o + 15))
                      : !0 === i(n[r], 'toastify-left')
                        ? ((n[r].style[e] = t[e] + 'px'), (t[e] += o + 15))
                        : ((n[r].style[e] = s[e] + 'px'), (s[e] += o + 15)));
                }
                return this;
              }),
              (t.lib.init.prototype = t.lib),
              t
            );
          }),
          e.exports ? (e.exports = s()) : (t.Toastify = s()));
      },
    },
    t = {};
  function s(i) {
    var a = t[i];
    if (void 0 !== a) return a.exports;
    var n = (t[i] = { id: i, exports: {} });
    return (e[i].call(n.exports, n, n.exports, s), n.exports);
  }
  ((s.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return (s.d(t, { a: t }), t);
  }),
    (s.d = (e, t) => {
      for (var i in t)
        s.o(t, i) && !s.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
    }),
    (s.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (s.nc = void 0),
    (() => {
      'use strict';
      function e(e) {
        return null !== e && 'object' == typeof e && 'constructor' in e && e.constructor === Object;
      }
      function t(s = {}, i = {}) {
        Object.keys(i).forEach((a) => {
          void 0 === s[a]
            ? (s[a] = i[a])
            : e(i[a]) && e(s[a]) && Object.keys(i[a]).length > 0 && t(s[a], i[a]);
        });
      }
      const i = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName: () => [],
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function a() {
        const e = 'undefined' != typeof document ? document : {};
        return (t(e, i), e);
      }
      const n = {
        document: i,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => '' }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) =>
          'undefined' == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
        cancelAnimationFrame(e) {
          'undefined' != typeof setTimeout && clearTimeout(e);
        },
      };
      function r() {
        const e = 'undefined' != typeof window ? window : {};
        return (t(e, n), e);
      }
      class o extends Array {
        constructor(e) {
          'number' == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, '__proto__', {
                  get: () => t,
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function l(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...l(e)) : t.push(e);
          }),
          t
        );
      }
      function d(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function c(e, t) {
        const s = r(),
          i = a();
        let n = [];
        if (!t && e instanceof o) return e;
        if (!e) return new o(n);
        if ('string' == typeof e) {
          const s = e.trim();
          if (s.indexOf('<') >= 0 && s.indexOf('>') >= 0) {
            let e = 'div';
            (0 === s.indexOf('<li') && (e = 'ul'),
              0 === s.indexOf('<tr') && (e = 'tbody'),
              (0 !== s.indexOf('<td') && 0 !== s.indexOf('<th')) || (e = 'tr'),
              0 === s.indexOf('<tbody') && (e = 'table'),
              0 === s.indexOf('<option') && (e = 'select'));
            const t = i.createElement(e);
            t.innerHTML = s;
            for (let e = 0; e < t.childNodes.length; e += 1) n.push(t.childNodes[e]);
          } else
            n = (function (e, t) {
              if ('string' != typeof e) return [e];
              const s = [],
                i = t.querySelectorAll(e);
              for (let e = 0; e < i.length; e += 1) s.push(i[e]);
              return s;
            })(e.trim(), t || i);
        } else if (e.nodeType || e === s || e === i) n.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof o) return e;
          n = e;
        }
        return new o(
          (function (e) {
            const t = [];
            for (let s = 0; s < e.length; s += 1) -1 === t.indexOf(e[s]) && t.push(e[s]);
            return t;
          })(n)
        );
      }
      c.fn = o.prototype;
      const p = 'resize scroll'.split(' ');
      function u(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              p.indexOf(e) < 0 && (e in this[t] ? this[t][e]() : c(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      (u('click'),
        u('blur'),
        u('focus'),
        u('focusin'),
        u('focusout'),
        u('keyup'),
        u('keydown'),
        u('keypress'),
        u('submit'),
        u('change'),
        u('mousedown'),
        u('mousemove'),
        u('mouseup'),
        u('mouseenter'),
        u('mouseleave'),
        u('mouseout'),
        u('mouseover'),
        u('touchstart'),
        u('touchend'),
        u('touchmove'),
        u('resize'),
        u('scroll'));
      const h = {
        addClass: function (...e) {
          const t = l(e.map((e) => e.split(' ')));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = l(e.map((e) => e.split(' ')));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = l(e.map((e) => e.split(' ')));
          return d(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0).length > 0;
        },
        toggleClass: function (...e) {
          const t = l(e.map((e) => e.split(' ')));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && 'string' == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (let s = 0; s < this.length; s += 1)
            if (2 === arguments.length) this[s].setAttribute(e, t);
            else for (const t in e) ((this[s][t] = e[t]), this[s].setAttribute(t, e[t]));
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration = 'string' != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, s, i, a] = e;
          function n(e) {
            const t = e.target;
            if (!t) return;
            const a = e.target.dom7EventData || [];
            if ((a.indexOf(e) < 0 && a.unshift(e), c(t).is(s))) i.apply(t, a);
            else {
              const e = c(t).parents();
              for (let t = 0; t < e.length; t += 1) c(e[t]).is(s) && i.apply(e[t], a);
            }
          }
          function r(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            (t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t));
          }
          ('function' == typeof e[1] && (([t, i, a] = e), (s = void 0)), a || (a = !1));
          const o = t.split(' ');
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (s)
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                (t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({ listener: i, proxyListener: n }),
                  t.addEventListener(e, n, a));
              }
            else
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                (t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: i, proxyListener: r }),
                  t.addEventListener(e, r, a));
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, s, i, a] = e;
          ('function' == typeof e[1] && (([t, i, a] = e), (s = void 0)), a || (a = !1));
          const n = t.split(' ');
          for (let e = 0; e < n.length; e += 1) {
            const t = n[e];
            for (let e = 0; e < this.length; e += 1) {
              const n = this[e];
              let r;
              if (
                (!s && n.dom7Listeners
                  ? (r = n.dom7Listeners[t])
                  : s && n.dom7LiveListeners && (r = n.dom7LiveListeners[t]),
                r && r.length)
              )
                for (let e = r.length - 1; e >= 0; e -= 1) {
                  const s = r[e];
                  (i && s.listener === i) ||
                  (i && s.listener && s.listener.dom7proxy && s.listener.dom7proxy === i)
                    ? (n.removeEventListener(t, s.proxyListener, a), r.splice(e, 1))
                    : i || (n.removeEventListener(t, s.proxyListener, a), r.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = r(),
            s = e[0].split(' '),
            i = e[1];
          for (let a = 0; a < s.length; a += 1) {
            const n = s[a];
            for (let s = 0; s < this.length; s += 1) {
              const a = this[s];
              if (t.CustomEvent) {
                const s = new t.CustomEvent(n, { detail: i, bubbles: !0, cancelable: !0 });
                ((a.dom7EventData = e.filter((e, t) => t > 0)),
                  a.dispatchEvent(s),
                  (a.dom7EventData = []),
                  delete a.dom7EventData);
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
              t.on('transitionend', function s(i) {
                i.target === this && (e.call(this, i), t.off('transitionend', s));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue('margin-right')) +
                parseFloat(e.getPropertyValue('margin-left'))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue('margin-top')) +
                parseFloat(e.getPropertyValue('margin-bottom'))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = r();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = r(),
              t = a(),
              s = this[0],
              i = s.getBoundingClientRect(),
              n = t.body,
              o = s.clientTop || n.clientTop || 0,
              l = s.clientLeft || n.clientLeft || 0,
              d = s === e ? e.scrollY : s.scrollTop,
              c = s === e ? e.scrollX : s.scrollLeft;
            return { top: i.top + d - o, left: i.left + c - l };
          }
          return null;
        },
        css: function (e, t) {
          const s = r();
          let i;
          if (1 === arguments.length) {
            if ('string' != typeof e) {
              for (i = 0; i < this.length; i += 1) for (const t in e) this[i].style[t] = e[t];
              return this;
            }
            if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && 'string' == typeof e) {
            for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, s) => {
                e.apply(t, [t, s]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = r(),
            s = a(),
            i = this[0];
          let n, l;
          if (!i || void 0 === e) return !1;
          if ('string' == typeof e) {
            if (i.matches) return i.matches(e);
            if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
            if (i.msMatchesSelector) return i.msMatchesSelector(e);
            for (n = c(e), l = 0; l < n.length; l += 1) if (n[l] === i) return !0;
            return !1;
          }
          if (e === s) return i === s;
          if (e === t) return i === t;
          if (e.nodeType || e instanceof o) {
            for (n = e.nodeType ? [e] : e, l = 0; l < n.length; l += 1) if (n[l] === i) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return c([]);
          if (e < 0) {
            const s = t + e;
            return c(s < 0 ? [] : [this[s]]);
          }
          return c([this[e]]);
        },
        append: function (...e) {
          let t;
          const s = a();
          for (let i = 0; i < e.length; i += 1) {
            t = e[i];
            for (let e = 0; e < this.length; e += 1)
              if ('string' == typeof t) {
                const i = s.createElement('div');
                for (i.innerHTML = t; i.firstChild; ) this[e].appendChild(i.firstChild);
              } else if (t instanceof o)
                for (let s = 0; s < t.length; s += 1) this[e].appendChild(t[s]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = a();
          let s, i;
          for (s = 0; s < this.length; s += 1)
            if ('string' == typeof e) {
              const a = t.createElement('div');
              for (a.innerHTML = e, i = a.childNodes.length - 1; i >= 0; i -= 1)
                this[s].insertBefore(a.childNodes[i], this[s].childNodes[0]);
            } else if (e instanceof o)
              for (i = 0; i < e.length; i += 1) this[s].insertBefore(e[i], this[s].childNodes[0]);
            else this[s].insertBefore(e, this[s].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling && c(this[0].nextElementSibling).is(e)
                ? c([this[0].nextElementSibling])
                : c([])
              : this[0].nextElementSibling
                ? c([this[0].nextElementSibling])
                : c([])
            : c([]);
        },
        nextAll: function (e) {
          const t = [];
          let s = this[0];
          if (!s) return c([]);
          for (; s.nextElementSibling; ) {
            const i = s.nextElementSibling;
            (e ? c(i).is(e) && t.push(i) : t.push(i), (s = i));
          }
          return c(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && c(t.previousElementSibling).is(e)
                ? c([t.previousElementSibling])
                : c([])
              : t.previousElementSibling
                ? c([t.previousElementSibling])
                : c([]);
          }
          return c([]);
        },
        prevAll: function (e) {
          const t = [];
          let s = this[0];
          if (!s) return c([]);
          for (; s.previousElementSibling; ) {
            const i = s.previousElementSibling;
            (e ? c(i).is(e) && t.push(i) : t.push(i), (s = i));
          }
          return c(t);
        },
        parent: function (e) {
          const t = [];
          for (let s = 0; s < this.length; s += 1)
            null !== this[s].parentNode &&
              (e
                ? c(this[s].parentNode).is(e) && t.push(this[s].parentNode)
                : t.push(this[s].parentNode));
          return c(t);
        },
        parents: function (e) {
          const t = [];
          for (let s = 0; s < this.length; s += 1) {
            let i = this[s].parentNode;
            for (; i; ) (e ? c(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode));
          }
          return c(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e ? c([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let s = 0; s < this.length; s += 1) {
            const i = this[s].querySelectorAll(e);
            for (let e = 0; e < i.length; e += 1) t.push(i[e]);
          }
          return c(t);
        },
        children: function (e) {
          const t = [];
          for (let s = 0; s < this.length; s += 1) {
            const i = this[s].children;
            for (let s = 0; s < i.length; s += 1) (e && !c(i[s]).is(e)) || t.push(i[s]);
          }
          return c(t);
        },
        filter: function (e) {
          return c(d(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(h).forEach((e) => {
        Object.defineProperty(c.fn, e, { value: h[e], writable: !0 });
      });
      const f = c;
      function m(e, t = 0) {
        return setTimeout(e, t);
      }
      function g() {
        return Date.now();
      }
      function w(e, t = 'x') {
        const s = r();
        let i, a, n;
        const o = (function (e) {
          const t = r();
          let s;
          return (
            t.getComputedStyle && (s = t.getComputedStyle(e, null)),
            !s && e.currentStyle && (s = e.currentStyle),
            s || (s = e.style),
            s
          );
        })(e);
        return (
          s.WebKitCSSMatrix
            ? ((a = o.transform || o.webkitTransform),
              a.split(',').length > 6 &&
                (a = a
                  .split(', ')
                  .map((e) => e.replace(',', '.'))
                  .join(', ')),
              (n = new s.WebKitCSSMatrix('none' === a ? '' : a)))
            : ((n =
                o.MozTransform ||
                o.OTransform ||
                o.MsTransform ||
                o.msTransform ||
                o.transform ||
                o.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')),
              (i = n.toString().split(','))),
          'x' === t &&
            (a = s.WebKitCSSMatrix
              ? n.m41
              : 16 === i.length
                ? parseFloat(i[12])
                : parseFloat(i[4])),
          'y' === t &&
            (a = s.WebKitCSSMatrix
              ? n.m42
              : 16 === i.length
                ? parseFloat(i[13])
                : parseFloat(i[5])),
          a || 0
        );
      }
      function v(e) {
        return (
          'object' == typeof e &&
          null !== e &&
          e.constructor &&
          'Object' === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function b(...e) {
        const t = Object(e[0]),
          s = ['__proto__', 'constructor', 'prototype'];
        for (let a = 1; a < e.length; a += 1) {
          const n = e[a];
          if (
            null != n &&
            ((i = n),
            !('undefined' != typeof window && void 0 !== window.HTMLElement
              ? i instanceof HTMLElement
              : i && (1 === i.nodeType || 11 === i.nodeType)))
          ) {
            const e = Object.keys(Object(n)).filter((e) => s.indexOf(e) < 0);
            for (let s = 0, i = e.length; s < i; s += 1) {
              const i = e[s],
                a = Object.getOwnPropertyDescriptor(n, i);
              void 0 !== a &&
                a.enumerable &&
                (v(t[i]) && v(n[i])
                  ? n[i].__swiper__
                    ? (t[i] = n[i])
                    : b(t[i], n[i])
                  : !v(t[i]) && v(n[i])
                    ? ((t[i] = {}), n[i].__swiper__ ? (t[i] = n[i]) : b(t[i], n[i]))
                    : (t[i] = n[i]));
            }
          }
        }
        var i;
        return t;
      }
      function y(e, t, s) {
        e.style.setProperty(t, s);
      }
      function x({ swiper: e, targetPosition: t, side: s }) {
        const i = r(),
          a = -e.translate;
        let n,
          o = null;
        const l = e.params.speed;
        ((e.wrapperEl.style.scrollSnapType = 'none'), i.cancelAnimationFrame(e.cssModeFrameID));
        const d = t > a ? 'next' : 'prev',
          c = (e, t) => ('next' === d && e >= t) || ('prev' === d && e <= t),
          p = () => {
            ((n = new Date().getTime()), null === o && (o = n));
            const r = Math.max(Math.min((n - o) / l, 1), 0),
              d = 0.5 - Math.cos(r * Math.PI) / 2;
            let u = a + d * (t - a);
            if ((c(u, t) && (u = t), e.wrapperEl.scrollTo({ [s]: u }), c(u, t)))
              return (
                (e.wrapperEl.style.overflow = 'hidden'),
                (e.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  ((e.wrapperEl.style.overflow = ''), e.wrapperEl.scrollTo({ [s]: u }));
                }),
                void i.cancelAnimationFrame(e.cssModeFrameID)
              );
            e.cssModeFrameID = i.requestAnimationFrame(p);
          };
        p();
      }
      let E, C, T;
      function S() {
        return (
          E ||
            (E = (function () {
              const e = r(),
                t = a();
              return {
                smoothScroll: t.documentElement && 'scrollBehavior' in t.documentElement.style,
                touch: !!('ontouchstart' in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                passiveListener: (function () {
                  let t = !1;
                  try {
                    const s = Object.defineProperty({}, 'passive', {
                      get() {
                        t = !0;
                      },
                    });
                    e.addEventListener('testPassiveListener', null, s);
                  } catch (e) {}
                  return t;
                })(),
                gestures: 'ongesturestart' in e,
              };
            })()),
          E
        );
      }
      function A(e = {}) {
        return (
          C ||
            (C = (function ({ userAgent: e } = {}) {
              const t = S(),
                s = r(),
                i = s.navigator.platform,
                a = e || s.navigator.userAgent,
                n = { ios: !1, android: !1 },
                o = s.screen.width,
                l = s.screen.height,
                d = a.match(/(Android);?[\s\/]+([\d.]+)?/);
              let c = a.match(/(iPad).*OS\s([\d_]+)/);
              const p = a.match(/(iPod)(.*OS\s([\d_]+))?/),
                u = !c && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                h = 'Win32' === i;
              let f = 'MacIntel' === i;
              return (
                !c &&
                  f &&
                  t.touch &&
                  [
                    '1024x1366',
                    '1366x1024',
                    '834x1194',
                    '1194x834',
                    '834x1112',
                    '1112x834',
                    '768x1024',
                    '1024x768',
                    '820x1180',
                    '1180x820',
                    '810x1080',
                    '1080x810',
                  ].indexOf(`${o}x${l}`) >= 0 &&
                  ((c = a.match(/(Version)\/([\d.]+)/)), c || (c = [0, 1, '13_0_0']), (f = !1)),
                d && !h && ((n.os = 'android'), (n.android = !0)),
                (c || u || p) && ((n.os = 'ios'), (n.ios = !0)),
                n
              );
            })(e)),
          C
        );
      }
      function $() {
        return (
          T ||
            (T = (function () {
              const e = r();
              return {
                isSafari: (function () {
                  const t = e.navigator.userAgent.toLowerCase();
                  return (
                    t.indexOf('safari') >= 0 && t.indexOf('chrome') < 0 && t.indexOf('android') < 0
                  );
                })(),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                  e.navigator.userAgent
                ),
              };
            })()),
          T
        );
      }
      const M = {
        on(e, t, s) {
          const i = this;
          if ('function' != typeof t) return i;
          const a = s ? 'unshift' : 'push';
          return (
            e.split(' ').forEach((e) => {
              (i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][a](t));
            }),
            i
          );
        },
        once(e, t, s) {
          const i = this;
          if ('function' != typeof t) return i;
          function a(...s) {
            (i.off(e, a), a.__emitterProxy && delete a.__emitterProxy, t.apply(i, s));
          }
          return ((a.__emitterProxy = t), i.on(e, a, s));
        },
        onAny(e, t) {
          const s = this;
          if ('function' != typeof e) return s;
          const i = t ? 'unshift' : 'push';
          return (s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s);
        },
        offAny(e) {
          const t = this;
          if (!t.eventsAnyListeners) return t;
          const s = t.eventsAnyListeners.indexOf(e);
          return (s >= 0 && t.eventsAnyListeners.splice(s, 1), t);
        },
        off(e, t) {
          const s = this;
          return s.eventsListeners
            ? (e.split(' ').forEach((e) => {
                void 0 === t
                  ? (s.eventsListeners[e] = [])
                  : s.eventsListeners[e] &&
                    s.eventsListeners[e].forEach((i, a) => {
                      (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                        s.eventsListeners[e].splice(a, 1);
                    });
              }),
              s)
            : s;
        },
        emit(...e) {
          const t = this;
          if (!t.eventsListeners) return t;
          let s, i, a;
          ('string' == typeof e[0] || Array.isArray(e[0])
            ? ((s = e[0]), (i = e.slice(1, e.length)), (a = t))
            : ((s = e[0].events), (i = e[0].data), (a = e[0].context || t)),
            i.unshift(a));
          return (
            (Array.isArray(s) ? s : s.split(' ')).forEach((e) => {
              (t.eventsAnyListeners &&
                t.eventsAnyListeners.length &&
                t.eventsAnyListeners.forEach((t) => {
                  t.apply(a, [e, ...i]);
                }),
                t.eventsListeners &&
                  t.eventsListeners[e] &&
                  t.eventsListeners[e].forEach((e) => {
                    e.apply(a, i);
                  }));
            }),
            t
          );
        },
      };
      const k = {
        updateSize: function () {
          const e = this;
          let t, s;
          const i = e.$el;
          ((t =
            void 0 !== e.params.width && null !== e.params.width
              ? e.params.width
              : i[0].clientWidth),
            (s =
              void 0 !== e.params.height && null !== e.params.height
                ? e.params.height
                : i[0].clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === s && e.isVertical()) ||
              ((t =
                t -
                parseInt(i.css('padding-left') || 0, 10) -
                parseInt(i.css('padding-right') || 0, 10)),
              (s =
                s -
                parseInt(i.css('padding-top') || 0, 10) -
                parseInt(i.css('padding-bottom') || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(s) && (s = 0),
              Object.assign(e, { width: t, height: s, size: e.isHorizontal() ? t : s })));
        },
        updateSlides: function () {
          const e = this;
          function t(t) {
            return e.isHorizontal()
              ? t
              : {
                  width: 'height',
                  'margin-top': 'margin-left',
                  'margin-bottom ': 'margin-right',
                  'margin-left': 'margin-top',
                  'margin-right': 'margin-bottom',
                  'padding-left': 'padding-top',
                  'padding-right': 'padding-bottom',
                  marginRight: 'marginBottom',
                }[t];
          }
          function s(e, s) {
            return parseFloat(e.getPropertyValue(t(s)) || 0);
          }
          const i = e.params,
            { $wrapperEl: a, size: n, rtlTranslate: r, wrongRTL: o } = e,
            l = e.virtual && i.virtual.enabled,
            d = l ? e.virtual.slides.length : e.slides.length,
            c = a.children(`.${e.params.slideClass}`),
            p = l ? e.virtual.slides.length : c.length;
          let u = [];
          const h = [],
            f = [];
          let m = i.slidesOffsetBefore;
          'function' == typeof m && (m = i.slidesOffsetBefore.call(e));
          let g = i.slidesOffsetAfter;
          'function' == typeof g && (g = i.slidesOffsetAfter.call(e));
          const w = e.snapGrid.length,
            v = e.slidesGrid.length;
          let b = i.spaceBetween,
            x = -m,
            E = 0,
            C = 0;
          if (void 0 === n) return;
          ('string' == typeof b &&
            b.indexOf('%') >= 0 &&
            (b = (parseFloat(b.replace('%', '')) / 100) * n),
            (e.virtualSize = -b),
            r
              ? c.css({ marginLeft: '', marginBottom: '', marginTop: '' })
              : c.css({ marginRight: '', marginBottom: '', marginTop: '' }),
            i.centeredSlides &&
              i.cssMode &&
              (y(e.wrapperEl, '--swiper-centered-offset-before', ''),
              y(e.wrapperEl, '--swiper-centered-offset-after', '')));
          const T = i.grid && i.grid.rows > 1 && e.grid;
          let S;
          T && e.grid.initSlides(p);
          const A =
            'auto' === i.slidesPerView &&
            i.breakpoints &&
            Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView)
              .length > 0;
          for (let a = 0; a < p; a += 1) {
            S = 0;
            const r = c.eq(a);
            if ((T && e.grid.updateSlide(a, r, p, t), 'none' !== r.css('display'))) {
              if ('auto' === i.slidesPerView) {
                A && (c[a].style[t('width')] = '');
                const n = getComputedStyle(r[0]),
                  o = r[0].style.transform,
                  l = r[0].style.webkitTransform;
                if (
                  (o && (r[0].style.transform = 'none'),
                  l && (r[0].style.webkitTransform = 'none'),
                  i.roundLengths)
                )
                  S = e.isHorizontal() ? r.outerWidth(!0) : r.outerHeight(!0);
                else {
                  const e = s(n, 'width'),
                    t = s(n, 'padding-left'),
                    i = s(n, 'padding-right'),
                    a = s(n, 'margin-left'),
                    o = s(n, 'margin-right'),
                    l = n.getPropertyValue('box-sizing');
                  if (l && 'border-box' === l) S = e + a + o;
                  else {
                    const { clientWidth: s, offsetWidth: n } = r[0];
                    S = e + t + i + a + o + (n - s);
                  }
                }
                (o && (r[0].style.transform = o),
                  l && (r[0].style.webkitTransform = l),
                  i.roundLengths && (S = Math.floor(S)));
              } else
                ((S = (n - (i.slidesPerView - 1) * b) / i.slidesPerView),
                  i.roundLengths && (S = Math.floor(S)),
                  c[a] && (c[a].style[t('width')] = `${S}px`));
              (c[a] && (c[a].swiperSlideSize = S),
                f.push(S),
                i.centeredSlides
                  ? ((x = x + S / 2 + E / 2 + b),
                    0 === E && 0 !== a && (x = x - n / 2 - b),
                    0 === a && (x = x - n / 2 - b),
                    Math.abs(x) < 0.001 && (x = 0),
                    i.roundLengths && (x = Math.floor(x)),
                    C % i.slidesPerGroup == 0 && u.push(x),
                    h.push(x))
                  : (i.roundLengths && (x = Math.floor(x)),
                    (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 &&
                      u.push(x),
                    h.push(x),
                    (x = x + S + b)),
                (e.virtualSize += S + b),
                (E = S),
                (C += 1));
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, n) + g),
            r &&
              o &&
              ('slide' === i.effect || 'coverflow' === i.effect) &&
              a.css({ width: `${e.virtualSize + i.spaceBetween}px` }),
            i.setWrapperSize && a.css({ [t('width')]: `${e.virtualSize + i.spaceBetween}px` }),
            T && e.grid.updateWrapperSize(S, u, t),
            !i.centeredSlides)
          ) {
            const t = [];
            for (let s = 0; s < u.length; s += 1) {
              let a = u[s];
              (i.roundLengths && (a = Math.floor(a)), u[s] <= e.virtualSize - n && t.push(a));
            }
            ((u = t),
              Math.floor(e.virtualSize - n) - Math.floor(u[u.length - 1]) > 1 &&
                u.push(e.virtualSize - n));
          }
          if ((0 === u.length && (u = [0]), 0 !== i.spaceBetween)) {
            const s = e.isHorizontal() && r ? 'marginLeft' : t('marginRight');
            c.filter((e, t) => !i.cssMode || t !== c.length - 1).css({ [s]: `${b}px` });
          }
          if (i.centeredSlides && i.centeredSlidesBounds) {
            let e = 0;
            (f.forEach((t) => {
              e += t + (i.spaceBetween ? i.spaceBetween : 0);
            }),
              (e -= i.spaceBetween));
            const t = e - n;
            u = u.map((e) => (e < 0 ? -m : e > t ? t + g : e));
          }
          if (i.centerInsufficientSlides) {
            let e = 0;
            if (
              (f.forEach((t) => {
                e += t + (i.spaceBetween ? i.spaceBetween : 0);
              }),
              (e -= i.spaceBetween),
              e < n)
            ) {
              const t = (n - e) / 2;
              (u.forEach((e, s) => {
                u[s] = e - t;
              }),
                h.forEach((e, s) => {
                  h[s] = e + t;
                }));
            }
          }
          if (
            (Object.assign(e, { slides: c, snapGrid: u, slidesGrid: h, slidesSizesGrid: f }),
            i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
          ) {
            (y(e.wrapperEl, '--swiper-centered-offset-before', -u[0] + 'px'),
              y(
                e.wrapperEl,
                '--swiper-centered-offset-after',
                e.size / 2 - f[f.length - 1] / 2 + 'px'
              ));
            const t = -e.snapGrid[0],
              s = -e.slidesGrid[0];
            ((e.snapGrid = e.snapGrid.map((e) => e + t)),
              (e.slidesGrid = e.slidesGrid.map((e) => e + s)));
          }
          (p !== d && e.emit('slidesLengthChange'),
            u.length !== w &&
              (e.params.watchOverflow && e.checkOverflow(), e.emit('snapGridLengthChange')),
            h.length !== v && e.emit('slidesGridLengthChange'),
            i.watchSlidesProgress && e.updateSlidesOffset());
        },
        updateAutoHeight: function (e) {
          const t = this,
            s = [],
            i = t.virtual && t.params.virtual.enabled;
          let a,
            n = 0;
          'number' == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
          const r = (e) =>
            i
              ? t.slides.filter(
                  (t) => parseInt(t.getAttribute('data-swiper-slide-index'), 10) === e
                )[0]
              : t.slides.eq(e)[0];
          if ('auto' !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              t.visibleSlides.each((e) => {
                s.push(e);
              });
            else
              for (a = 0; a < Math.ceil(t.params.slidesPerView); a += 1) {
                const e = t.activeIndex + a;
                if (e > t.slides.length && !i) break;
                s.push(r(e));
              }
          else s.push(r(t.activeIndex));
          for (a = 0; a < s.length; a += 1)
            if (void 0 !== s[a]) {
              const e = s[a].offsetHeight;
              n = e > n ? e : n;
            }
          (n || 0 === n) && t.$wrapperEl.css('height', `${n}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides;
          for (let s = 0; s < t.length; s += 1)
            t[s].swiperSlideOffset = e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop;
        },
        updateSlidesProgress: function (e = (this && this.translate) || 0) {
          const t = this,
            s = t.params,
            { slides: i, rtlTranslate: a, snapGrid: n } = t;
          if (0 === i.length) return;
          void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
          let r = -e;
          (a && (r = e),
            i.removeClass(s.slideVisibleClass),
            (t.visibleSlidesIndexes = []),
            (t.visibleSlides = []));
          for (let e = 0; e < i.length; e += 1) {
            const o = i[e];
            let l = o.swiperSlideOffset;
            s.cssMode && s.centeredSlides && (l -= i[0].swiperSlideOffset);
            const d =
                (r + (s.centeredSlides ? t.minTranslate() : 0) - l) /
                (o.swiperSlideSize + s.spaceBetween),
              c =
                (r - n[0] + (s.centeredSlides ? t.minTranslate() : 0) - l) /
                (o.swiperSlideSize + s.spaceBetween),
              p = -(r - l),
              u = p + t.slidesSizesGrid[e];
            (((p >= 0 && p < t.size - 1) || (u > 1 && u <= t.size) || (p <= 0 && u >= t.size)) &&
              (t.visibleSlides.push(o),
              t.visibleSlidesIndexes.push(e),
              i.eq(e).addClass(s.slideVisibleClass)),
              (o.progress = a ? -d : d),
              (o.originalProgress = a ? -c : c));
          }
          t.visibleSlides = f(t.visibleSlides);
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const s = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * s) || 0;
          }
          const s = t.params,
            i = t.maxTranslate() - t.minTranslate();
          let { progress: a, isBeginning: n, isEnd: r } = t;
          const o = n,
            l = r;
          (0 === i
            ? ((a = 0), (n = !0), (r = !0))
            : ((a = (e - t.minTranslate()) / i), (n = a <= 0), (r = a >= 1)),
            Object.assign(t, { progress: a, isBeginning: n, isEnd: r }),
            (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
              t.updateSlidesProgress(e),
            n && !o && t.emit('reachBeginning toEdge'),
            r && !l && t.emit('reachEnd toEdge'),
            ((o && !n) || (l && !r)) && t.emit('fromEdge'),
            t.emit('progress', a));
        },
        updateSlidesClasses: function () {
          const e = this,
            { slides: t, params: s, $wrapperEl: i, activeIndex: a, realIndex: n } = e,
            r = e.virtual && s.virtual.enabled;
          let o;
          (t.removeClass(
            `${s.slideActiveClass} ${s.slideNextClass} ${s.slidePrevClass} ${s.slideDuplicateActiveClass} ${s.slideDuplicateNextClass} ${s.slideDuplicatePrevClass}`
          ),
            (o = r
              ? e.$wrapperEl.find(`.${s.slideClass}[data-swiper-slide-index="${a}"]`)
              : t.eq(a)),
            o.addClass(s.slideActiveClass),
            s.loop &&
              (o.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${n}"]`
                    )
                    .addClass(s.slideDuplicateActiveClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${n}"]`
                    )
                    .addClass(s.slideDuplicateActiveClass)));
          let l = o.nextAll(`.${s.slideClass}`).eq(0).addClass(s.slideNextClass);
          s.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(s.slideNextClass));
          let d = o.prevAll(`.${s.slideClass}`).eq(0).addClass(s.slidePrevClass);
          (s.loop && 0 === d.length && ((d = t.eq(-1)), d.addClass(s.slidePrevClass)),
            s.loop &&
              (l.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${l.attr('data-swiper-slide-index')}"]`
                    )
                    .addClass(s.slideDuplicateNextClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${l.attr('data-swiper-slide-index')}"]`
                    )
                    .addClass(s.slideDuplicateNextClass),
              d.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${d.attr('data-swiper-slide-index')}"]`
                    )
                    .addClass(s.slideDuplicatePrevClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${d.attr('data-swiper-slide-index')}"]`
                    )
                    .addClass(s.slideDuplicatePrevClass)),
            e.emitSlidesClasses());
        },
        updateActiveIndex: function (e) {
          const t = this,
            s = t.rtlTranslate ? t.translate : -t.translate,
            {
              slidesGrid: i,
              snapGrid: a,
              params: n,
              activeIndex: r,
              realIndex: o,
              snapIndex: l,
            } = t;
          let d,
            c = e;
          if (void 0 === c) {
            for (let e = 0; e < i.length; e += 1)
              void 0 !== i[e + 1]
                ? s >= i[e] && s < i[e + 1] - (i[e + 1] - i[e]) / 2
                  ? (c = e)
                  : s >= i[e] && s < i[e + 1] && (c = e + 1)
                : s >= i[e] && (c = e);
            n.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
          }
          if (a.indexOf(s) >= 0) d = a.indexOf(s);
          else {
            const e = Math.min(n.slidesPerGroupSkip, c);
            d = e + Math.floor((c - e) / n.slidesPerGroup);
          }
          if ((d >= a.length && (d = a.length - 1), c === r))
            return void (d !== l && ((t.snapIndex = d), t.emit('snapIndexChange')));
          const p = parseInt(t.slides.eq(c).attr('data-swiper-slide-index') || c, 10);
          (Object.assign(t, { snapIndex: d, realIndex: p, previousIndex: r, activeIndex: c }),
            t.emit('activeIndexChange'),
            t.emit('snapIndexChange'),
            o !== p && t.emit('realIndexChange'),
            (t.initialized || t.params.runCallbacksOnInit) && t.emit('slideChange'));
        },
        updateClickedSlide: function (e) {
          const t = this,
            s = t.params,
            i = f(e).closest(`.${s.slideClass}`)[0];
          let a,
            n = !1;
          if (i)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === i) {
                ((n = !0), (a = e));
                break;
              }
          if (!i || !n) return ((t.clickedSlide = void 0), void (t.clickedIndex = void 0));
          ((t.clickedSlide = i),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(f(i).attr('data-swiper-slide-index'), 10))
              : (t.clickedIndex = a),
            s.slideToClickedSlide &&
              void 0 !== t.clickedIndex &&
              t.clickedIndex !== t.activeIndex &&
              t.slideToClickedSlide());
        },
      };
      const P = {
        getTranslate: function (e = this.isHorizontal() ? 'x' : 'y') {
          const { params: t, rtlTranslate: s, translate: i, $wrapperEl: a } = this;
          if (t.virtualTranslate) return s ? -i : i;
          if (t.cssMode) return i;
          let n = w(a[0], e);
          return (s && (n = -n), n || 0);
        },
        setTranslate: function (e, t) {
          const s = this,
            { rtlTranslate: i, params: a, $wrapperEl: n, wrapperEl: r, progress: o } = s;
          let l,
            d = 0,
            c = 0;
          (s.isHorizontal() ? (d = i ? -e : e) : (c = e),
            a.roundLengths && ((d = Math.floor(d)), (c = Math.floor(c))),
            a.cssMode
              ? (r[s.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = s.isHorizontal() ? -d : -c)
              : a.virtualTranslate || n.transform(`translate3d(${d}px, ${c}px, 0px)`),
            (s.previousTranslate = s.translate),
            (s.translate = s.isHorizontal() ? d : c));
          const p = s.maxTranslate() - s.minTranslate();
          ((l = 0 === p ? 0 : (e - s.minTranslate()) / p),
            l !== o && s.updateProgress(e),
            s.emit('setTranslate', s.translate, t));
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, a) {
          const n = this,
            { params: r, wrapperEl: o } = n;
          if (n.animating && r.preventInteractionOnTransition) return !1;
          const l = n.minTranslate(),
            d = n.maxTranslate();
          let c;
          if (((c = i && e > l ? l : i && e < d ? d : e), n.updateProgress(c), r.cssMode)) {
            const e = n.isHorizontal();
            if (0 === t) o[e ? 'scrollLeft' : 'scrollTop'] = -c;
            else {
              if (!n.support.smoothScroll)
                return (x({ swiper: n, targetPosition: -c, side: e ? 'left' : 'top' }), !0);
              o.scrollTo({ [e ? 'left' : 'top']: -c, behavior: 'smooth' });
            }
            return !0;
          }
          return (
            0 === t
              ? (n.setTransition(0),
                n.setTranslate(c),
                s && (n.emit('beforeTransitionStart', t, a), n.emit('transitionEnd')))
              : (n.setTransition(t),
                n.setTranslate(c),
                s && (n.emit('beforeTransitionStart', t, a), n.emit('transitionStart')),
                n.animating ||
                  ((n.animating = !0),
                  n.onTranslateToWrapperTransitionEnd ||
                    (n.onTranslateToWrapperTransitionEnd = function (e) {
                      n &&
                        !n.destroyed &&
                        e.target === this &&
                        (n.$wrapperEl[0].removeEventListener(
                          'transitionend',
                          n.onTranslateToWrapperTransitionEnd
                        ),
                        n.$wrapperEl[0].removeEventListener(
                          'webkitTransitionEnd',
                          n.onTranslateToWrapperTransitionEnd
                        ),
                        (n.onTranslateToWrapperTransitionEnd = null),
                        delete n.onTranslateToWrapperTransitionEnd,
                        s && n.emit('transitionEnd'));
                    }),
                  n.$wrapperEl[0].addEventListener(
                    'transitionend',
                    n.onTranslateToWrapperTransitionEnd
                  ),
                  n.$wrapperEl[0].addEventListener(
                    'webkitTransitionEnd',
                    n.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      };
      function z({ swiper: e, runCallbacks: t, direction: s, step: i }) {
        const { activeIndex: a, previousIndex: n } = e;
        let r = s;
        if (
          (r || (r = a > n ? 'next' : a < n ? 'prev' : 'reset'),
          e.emit(`transition${i}`),
          t && a !== n)
        ) {
          if ('reset' === r) return void e.emit(`slideResetTransition${i}`);
          (e.emit(`slideChangeTransition${i}`),
            'next' === r ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`));
        }
      }
      const O = {
        slideTo: function (e = 0, t = this.params.speed, s = !0, i, a) {
          if ('number' != typeof e && 'string' != typeof e)
            throw new Error(
              `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
            );
          if ('string' == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t))
              throw new Error(
                `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
              );
            e = t;
          }
          const n = this;
          let r = e;
          r < 0 && (r = 0);
          const {
            params: o,
            snapGrid: l,
            slidesGrid: d,
            previousIndex: c,
            activeIndex: p,
            rtlTranslate: u,
            wrapperEl: h,
            enabled: f,
          } = n;
          if ((n.animating && o.preventInteractionOnTransition) || (!f && !i && !a)) return !1;
          const m = Math.min(n.params.slidesPerGroupSkip, r);
          let g = m + Math.floor((r - m) / n.params.slidesPerGroup);
          (g >= l.length && (g = l.length - 1),
            (p || o.initialSlide || 0) === (c || 0) && s && n.emit('beforeSlideChangeStart'));
          const w = -l[g];
          if ((n.updateProgress(w), o.normalizeSlideIndex))
            for (let e = 0; e < d.length; e += 1) {
              const t = -Math.floor(100 * w),
                s = Math.floor(100 * d[e]),
                i = Math.floor(100 * d[e + 1]);
              void 0 !== d[e + 1]
                ? t >= s && t < i - (i - s) / 2
                  ? (r = e)
                  : t >= s && t < i && (r = e + 1)
                : t >= s && (r = e);
            }
          if (n.initialized && r !== p) {
            if (!n.allowSlideNext && w < n.translate && w < n.minTranslate()) return !1;
            if (!n.allowSlidePrev && w > n.translate && w > n.maxTranslate() && (p || 0) !== r)
              return !1;
          }
          let v;
          if (
            ((v = r > p ? 'next' : r < p ? 'prev' : 'reset'),
            (u && -w === n.translate) || (!u && w === n.translate))
          )
            return (
              n.updateActiveIndex(r),
              o.autoHeight && n.updateAutoHeight(),
              n.updateSlidesClasses(),
              'slide' !== o.effect && n.setTranslate(w),
              'reset' !== v && (n.transitionStart(s, v), n.transitionEnd(s, v)),
              !1
            );
          if (o.cssMode) {
            const e = n.isHorizontal(),
              s = u ? w : -w;
            if (0 === t) {
              const t = n.virtual && n.params.virtual.enabled;
              (t && ((n.wrapperEl.style.scrollSnapType = 'none'), (n._immediateVirtual = !0)),
                (h[e ? 'scrollLeft' : 'scrollTop'] = s),
                t &&
                  requestAnimationFrame(() => {
                    ((n.wrapperEl.style.scrollSnapType = ''), (n._swiperImmediateVirtual = !1));
                  }));
            } else {
              if (!n.support.smoothScroll)
                return (x({ swiper: n, targetPosition: s, side: e ? 'left' : 'top' }), !0);
              h.scrollTo({ [e ? 'left' : 'top']: s, behavior: 'smooth' });
            }
            return !0;
          }
          return (
            n.setTransition(t),
            n.setTranslate(w),
            n.updateActiveIndex(r),
            n.updateSlidesClasses(),
            n.emit('beforeTransitionStart', t, i),
            n.transitionStart(s, v),
            0 === t
              ? n.transitionEnd(s, v)
              : n.animating ||
                ((n.animating = !0),
                n.onSlideToWrapperTransitionEnd ||
                  (n.onSlideToWrapperTransitionEnd = function (e) {
                    n &&
                      !n.destroyed &&
                      e.target === this &&
                      (n.$wrapperEl[0].removeEventListener(
                        'transitionend',
                        n.onSlideToWrapperTransitionEnd
                      ),
                      n.$wrapperEl[0].removeEventListener(
                        'webkitTransitionEnd',
                        n.onSlideToWrapperTransitionEnd
                      ),
                      (n.onSlideToWrapperTransitionEnd = null),
                      delete n.onSlideToWrapperTransitionEnd,
                      n.transitionEnd(s, v));
                  }),
                n.$wrapperEl[0].addEventListener('transitionend', n.onSlideToWrapperTransitionEnd),
                n.$wrapperEl[0].addEventListener(
                  'webkitTransitionEnd',
                  n.onSlideToWrapperTransitionEnd
                )),
            !0
          );
        },
        slideToLoop: function (e = 0, t = this.params.speed, s = !0, i) {
          const a = this;
          let n = e;
          return (a.params.loop && (n += a.loopedSlides), a.slideTo(n, t, s, i));
        },
        slideNext: function (e = this.params.speed, t = !0, s) {
          const i = this,
            { animating: a, enabled: n, params: r } = i;
          if (!n) return i;
          let o = r.slidesPerGroup;
          'auto' === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            (o = Math.max(i.slidesPerViewDynamic('current', !0), 1));
          const l = i.activeIndex < r.slidesPerGroupSkip ? 1 : o;
          if (r.loop) {
            if (a && r.loopPreventsSlide) return !1;
            (i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft));
          }
          return r.rewind && i.isEnd
            ? i.slideTo(0, e, t, s)
            : i.slideTo(i.activeIndex + l, e, t, s);
        },
        slidePrev: function (e = this.params.speed, t = !0, s) {
          const i = this,
            {
              params: a,
              animating: n,
              snapGrid: r,
              slidesGrid: o,
              rtlTranslate: l,
              enabled: d,
            } = i;
          if (!d) return i;
          if (a.loop) {
            if (n && a.loopPreventsSlide) return !1;
            (i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft));
          }
          function c(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const p = c(l ? i.translate : -i.translate),
            u = r.map((e) => c(e));
          let h = r[u.indexOf(p) - 1];
          if (void 0 === h && a.cssMode) {
            let e;
            (r.forEach((t, s) => {
              p >= t && (e = s);
            }),
              void 0 !== e && (h = r[e > 0 ? e - 1 : e]));
          }
          let f = 0;
          return (
            void 0 !== h &&
              ((f = o.indexOf(h)),
              f < 0 && (f = i.activeIndex - 1),
              'auto' === a.slidesPerView &&
                1 === a.slidesPerGroup &&
                a.slidesPerGroupAuto &&
                ((f = f - i.slidesPerViewDynamic('previous', !0) + 1), (f = Math.max(f, 0)))),
            a.rewind && i.isBeginning
              ? i.slideTo(i.slides.length - 1, e, t, s)
              : i.slideTo(f, e, t, s)
          );
        },
        slideReset: function (e = this.params.speed, t = !0, s) {
          return this.slideTo(this.activeIndex, e, t, s);
        },
        slideToClosest: function (e = this.params.speed, t = !0, s, i = 0.5) {
          const a = this;
          let n = a.activeIndex;
          const r = Math.min(a.params.slidesPerGroupSkip, n),
            o = r + Math.floor((n - r) / a.params.slidesPerGroup),
            l = a.rtlTranslate ? a.translate : -a.translate;
          if (l >= a.snapGrid[o]) {
            const e = a.snapGrid[o];
            l - e > (a.snapGrid[o + 1] - e) * i && (n += a.params.slidesPerGroup);
          } else {
            const e = a.snapGrid[o - 1];
            l - e <= (a.snapGrid[o] - e) * i && (n -= a.params.slidesPerGroup);
          }
          return (
            (n = Math.max(n, 0)),
            (n = Math.min(n, a.slidesGrid.length - 1)),
            a.slideTo(n, e, t, s)
          );
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, $wrapperEl: s } = e,
            i = 'auto' === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let a,
            n = e.clickedIndex;
          if (t.loop) {
            if (e.animating) return;
            ((a = parseInt(f(e.clickedSlide).attr('data-swiper-slide-index'), 10)),
              t.centeredSlides
                ? n < e.loopedSlides - i / 2 || n > e.slides.length - e.loopedSlides + i / 2
                  ? (e.loopFix(),
                    (n = s
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    m(() => {
                      e.slideTo(n);
                    }))
                  : e.slideTo(n)
                : n > e.slides.length - i
                  ? (e.loopFix(),
                    (n = s
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    m(() => {
                      e.slideTo(n);
                    }))
                  : e.slideTo(n));
          } else e.slideTo(n);
        },
      };
      const L = {
        loopCreate: function () {
          const e = this,
            t = a(),
            { params: s, $wrapperEl: i } = e,
            n = i.children().length > 0 ? f(i.children()[0].parentNode) : i;
          n.children(`.${s.slideClass}.${s.slideDuplicateClass}`).remove();
          let r = n.children(`.${s.slideClass}`);
          if (s.loopFillGroupWithBlank) {
            const e = s.slidesPerGroup - (r.length % s.slidesPerGroup);
            if (e !== s.slidesPerGroup) {
              for (let i = 0; i < e; i += 1) {
                const e = f(t.createElement('div')).addClass(
                  `${s.slideClass} ${s.slideBlankClass}`
                );
                n.append(e);
              }
              r = n.children(`.${s.slideClass}`);
            }
          }
          ('auto' !== s.slidesPerView || s.loopedSlides || (s.loopedSlides = r.length),
            (e.loopedSlides = Math.ceil(parseFloat(s.loopedSlides || s.slidesPerView, 10))),
            (e.loopedSlides += s.loopAdditionalSlides),
            e.loopedSlides > r.length && (e.loopedSlides = r.length));
          const o = [],
            l = [];
          r.each((t, s) => {
            const i = f(t);
            (s < e.loopedSlides && l.push(t),
              s < r.length && s >= r.length - e.loopedSlides && o.push(t),
              i.attr('data-swiper-slide-index', s));
          });
          for (let e = 0; e < l.length; e += 1)
            n.append(f(l[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
          for (let e = o.length - 1; e >= 0; e -= 1)
            n.prepend(f(o[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
        },
        loopFix: function () {
          const e = this;
          e.emit('beforeLoopFix');
          const {
            activeIndex: t,
            slides: s,
            loopedSlides: i,
            allowSlidePrev: a,
            allowSlideNext: n,
            snapGrid: r,
            rtlTranslate: o,
          } = e;
          let l;
          ((e.allowSlidePrev = !0), (e.allowSlideNext = !0));
          const d = -r[t] - e.getTranslate();
          if (t < i) {
            ((l = s.length - 3 * i + t), (l += i));
            e.slideTo(l, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((o ? -e.translate : e.translate) - d);
          } else if (t >= s.length - i) {
            ((l = -s.length + t + i), (l += i));
            e.slideTo(l, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((o ? -e.translate : e.translate) - d);
          }
          ((e.allowSlidePrev = a), (e.allowSlideNext = n), e.emit('loopFix'));
        },
        loopDestroy: function () {
          const { $wrapperEl: e, params: t, slides: s } = this;
          (e
            .children(
              `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
            )
            .remove(),
            s.removeAttr('data-swiper-slide-index'));
        },
      };
      function B(e) {
        const t = this,
          s = a(),
          i = r(),
          n = t.touchEventsData,
          { params: o, touches: l, enabled: d } = t;
        if (!d) return;
        if (t.animating && o.preventInteractionOnTransition) return;
        !t.animating && o.cssMode && o.loop && t.loopFix();
        let c = e;
        c.originalEvent && (c = c.originalEvent);
        let p = f(c.target);
        if ('wrapper' === o.touchEventsTarget && !p.closest(t.wrapperEl).length) return;
        if (
          ((n.isTouchEvent = 'touchstart' === c.type),
          !n.isTouchEvent && 'which' in c && 3 === c.which)
        )
          return;
        if (!n.isTouchEvent && 'button' in c && c.button > 0) return;
        if (n.isTouched && n.isMoved) return;
        !!o.noSwipingClass &&
          '' !== o.noSwipingClass &&
          c.target &&
          c.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (p = f(e.path[0]));
        const u = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`,
          h = !(!c.target || !c.target.shadowRoot);
        if (
          o.noSwiping &&
          (h
            ? (function (e, t = this) {
                return (function t(s) {
                  return s && s !== a() && s !== r()
                    ? (s.assignedSlot && (s = s.assignedSlot),
                      s.closest(e) || t(s.getRootNode().host))
                    : null;
                })(t);
              })(u, c.target)
            : p.closest(u)[0])
        )
          return void (t.allowClick = !0);
        if (o.swipeHandler && !p.closest(o.swipeHandler)[0]) return;
        ((l.currentX = 'touchstart' === c.type ? c.targetTouches[0].pageX : c.pageX),
          (l.currentY = 'touchstart' === c.type ? c.targetTouches[0].pageY : c.pageY));
        const m = l.currentX,
          w = l.currentY,
          v = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
          b = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
        if (v && (m <= b || m >= i.innerWidth - b)) {
          if ('prevent' !== v) return;
          e.preventDefault();
        }
        if (
          (Object.assign(n, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
          (l.startX = m),
          (l.startY = w),
          (n.touchStartTime = g()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          o.threshold > 0 && (n.allowThresholdMove = !1),
          'touchstart' !== c.type)
        ) {
          let e = !0;
          (p.is(n.focusableElements) && (e = !1),
            s.activeElement &&
              f(s.activeElement).is(n.focusableElements) &&
              s.activeElement !== p[0] &&
              s.activeElement.blur());
          const i = e && t.allowTouchMove && o.touchStartPreventDefault;
          (!o.touchStartForcePreventDefault && !i) || p[0].isContentEditable || c.preventDefault();
        }
        t.emit('touchStart', c);
      }
      function I(e) {
        const t = a(),
          s = this,
          i = s.touchEventsData,
          { params: n, touches: r, rtlTranslate: o, enabled: l } = s;
        if (!l) return;
        let d = e;
        if ((d.originalEvent && (d = d.originalEvent), !i.isTouched))
          return void (i.startMoving && i.isScrolling && s.emit('touchMoveOpposite', d));
        if (i.isTouchEvent && 'touchmove' !== d.type) return;
        const c =
            'touchmove' === d.type &&
            d.targetTouches &&
            (d.targetTouches[0] || d.changedTouches[0]),
          p = 'touchmove' === d.type ? c.pageX : d.pageX,
          u = 'touchmove' === d.type ? c.pageY : d.pageY;
        if (d.preventedByNestedSwiper) return ((r.startX = p), void (r.startY = u));
        if (!s.allowTouchMove)
          return (
            (s.allowClick = !1),
            void (
              i.isTouched &&
              (Object.assign(r, { startX: p, startY: u, currentX: p, currentY: u }),
              (i.touchStartTime = g()))
            )
          );
        if (i.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
          if (s.isVertical()) {
            if (
              (u < r.startY && s.translate <= s.maxTranslate()) ||
              (u > r.startY && s.translate >= s.minTranslate())
            )
              return ((i.isTouched = !1), void (i.isMoved = !1));
          } else if (
            (p < r.startX && s.translate <= s.maxTranslate()) ||
            (p > r.startX && s.translate >= s.minTranslate())
          )
            return;
        if (
          i.isTouchEvent &&
          t.activeElement &&
          d.target === t.activeElement &&
          f(d.target).is(i.focusableElements)
        )
          return ((i.isMoved = !0), void (s.allowClick = !1));
        if (
          (i.allowTouchCallbacks && s.emit('touchMove', d),
          d.targetTouches && d.targetTouches.length > 1)
        )
          return;
        ((r.currentX = p), (r.currentY = u));
        const h = r.currentX - r.startX,
          m = r.currentY - r.startY;
        if (s.params.threshold && Math.sqrt(h ** 2 + m ** 2) < s.params.threshold) return;
        if (void 0 === i.isScrolling) {
          let e;
          (s.isHorizontal() && r.currentY === r.startY) ||
          (s.isVertical() && r.currentX === r.startX)
            ? (i.isScrolling = !1)
            : h * h + m * m >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(m), Math.abs(h))) / Math.PI),
              (i.isScrolling = s.isHorizontal() ? e > n.touchAngle : 90 - e > n.touchAngle));
        }
        if (
          (i.isScrolling && s.emit('touchMoveOpposite', d),
          void 0 === i.startMoving &&
            ((r.currentX === r.startX && r.currentY === r.startY) || (i.startMoving = !0)),
          i.isScrolling)
        )
          return void (i.isTouched = !1);
        if (!i.startMoving) return;
        ((s.allowClick = !1),
          !n.cssMode && d.cancelable && d.preventDefault(),
          n.touchMoveStopPropagation && !n.nested && d.stopPropagation(),
          i.isMoved ||
            (n.loop && !n.cssMode && s.loopFix(),
            (i.startTranslate = s.getTranslate()),
            s.setTransition(0),
            s.animating && s.$wrapperEl.trigger('webkitTransitionEnd transitionend'),
            (i.allowMomentumBounce = !1),
            !n.grabCursor ||
              (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) ||
              s.setGrabCursor(!0),
            s.emit('sliderFirstMove', d)),
          s.emit('sliderMove', d),
          (i.isMoved = !0));
        let w = s.isHorizontal() ? h : m;
        ((r.diff = w),
          (w *= n.touchRatio),
          o && (w = -w),
          (s.swipeDirection = w > 0 ? 'prev' : 'next'),
          (i.currentTranslate = w + i.startTranslate));
        let v = !0,
          b = n.resistanceRatio;
        if (
          (n.touchReleaseOnEdges && (b = 0),
          w > 0 && i.currentTranslate > s.minTranslate()
            ? ((v = !1),
              n.resistance &&
                (i.currentTranslate =
                  s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + w) ** b))
            : w < 0 &&
              i.currentTranslate < s.maxTranslate() &&
              ((v = !1),
              n.resistance &&
                (i.currentTranslate =
                  s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - w) ** b)),
          v && (d.preventedByNestedSwiper = !0),
          !s.allowSlideNext &&
            'next' === s.swipeDirection &&
            i.currentTranslate < i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
          !s.allowSlidePrev &&
            'prev' === s.swipeDirection &&
            i.currentTranslate > i.startTranslate &&
            (i.currentTranslate = i.startTranslate),
          s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate),
          n.threshold > 0)
        ) {
          if (!(Math.abs(w) > n.threshold || i.allowThresholdMove))
            return void (i.currentTranslate = i.startTranslate);
          if (!i.allowThresholdMove)
            return (
              (i.allowThresholdMove = !0),
              (r.startX = r.currentX),
              (r.startY = r.currentY),
              (i.currentTranslate = i.startTranslate),
              void (r.diff = s.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY)
            );
        }
        n.followFinger &&
          !n.cssMode &&
          (((n.freeMode && n.freeMode.enabled && s.freeMode) || n.watchSlidesProgress) &&
            (s.updateActiveIndex(), s.updateSlidesClasses()),
          s.params.freeMode && n.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(),
          s.updateProgress(i.currentTranslate),
          s.setTranslate(i.currentTranslate));
      }
      function N(e) {
        const t = this,
          s = t.touchEventsData,
          { params: i, touches: a, rtlTranslate: n, slidesGrid: r, enabled: o } = t;
        if (!o) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
          s.allowTouchCallbacks && t.emit('touchEnd', l),
          (s.allowTouchCallbacks = !1),
          !s.isTouched)
        )
          return (
            s.isMoved && i.grabCursor && t.setGrabCursor(!1),
            (s.isMoved = !1),
            void (s.startMoving = !1)
          );
        i.grabCursor &&
          s.isMoved &&
          s.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const d = g(),
          c = d - s.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          (t.updateClickedSlide((e && e[0]) || l.target),
            t.emit('tap click', l),
            c < 300 && d - s.lastClickTime < 300 && t.emit('doubleTap doubleClick', l));
        }
        if (
          ((s.lastClickTime = g()),
          m(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !s.isTouched ||
            !s.isMoved ||
            !t.swipeDirection ||
            0 === a.diff ||
            s.currentTranslate === s.startTranslate)
        )
          return ((s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1));
        let p;
        if (
          ((s.isTouched = !1),
          (s.isMoved = !1),
          (s.startMoving = !1),
          (p = i.followFinger ? (n ? t.translate : -t.translate) : -s.currentTranslate),
          i.cssMode)
        )
          return;
        if (t.params.freeMode && i.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: p });
        let u = 0,
          h = t.slidesSizesGrid[0];
        for (let e = 0; e < r.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
          const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== r[e + t]
            ? p >= r[e] && p < r[e + t] && ((u = e), (h = r[e + t] - r[e]))
            : p >= r[e] && ((u = e), (h = r[r.length - 1] - r[r.length - 2]));
        }
        const f = (p - r[u]) / h,
          w = u < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        if (c > i.longSwipesMs) {
          if (!i.longSwipes) return void t.slideTo(t.activeIndex);
          ('next' === t.swipeDirection &&
            (f >= i.longSwipesRatio ? t.slideTo(u + w) : t.slideTo(u)),
            'prev' === t.swipeDirection &&
              (f > 1 - i.longSwipesRatio ? t.slideTo(u + w) : t.slideTo(u)));
        } else {
          if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
          t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl)
            ? l.target === t.navigation.nextEl
              ? t.slideTo(u + w)
              : t.slideTo(u)
            : ('next' === t.swipeDirection && t.slideTo(u + w),
              'prev' === t.swipeDirection && t.slideTo(u));
        }
      }
      function D() {
        const e = this,
          { params: t, el: s } = e;
        if (s && 0 === s.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: i, allowSlidePrev: a, snapGrid: n } = e;
        ((e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ('auto' === t.slidesPerView || t.slidesPerView > 1) &&
          e.isEnd &&
          !e.isBeginning &&
          !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
          (e.allowSlidePrev = a),
          (e.allowSlideNext = i),
          e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow());
      }
      function j(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function G() {
        const e = this,
          { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
        if (!i) return;
        let a;
        ((e.previousTranslate = e.translate),
          e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
          -0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses());
        const n = e.maxTranslate() - e.minTranslate();
        ((a = 0 === n ? 0 : (e.translate - e.minTranslate()) / n),
          a !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
          e.emit('setTranslate', e.translate, !1));
      }
      let Y = !1;
      function R() {}
      const H = (e, t) => {
        const s = a(),
          { params: i, touchEvents: n, el: r, wrapperEl: o, device: l, support: d } = e,
          c = !!i.nested,
          p = 'on' === t ? 'addEventListener' : 'removeEventListener',
          u = t;
        if (d.touch) {
          const t = !('touchstart' !== n.start || !d.passiveListener || !i.passiveListeners) && {
            passive: !0,
            capture: !1,
          };
          (r[p](n.start, e.onTouchStart, t),
            r[p](n.move, e.onTouchMove, d.passiveListener ? { passive: !1, capture: c } : c),
            r[p](n.end, e.onTouchEnd, t),
            n.cancel && r[p](n.cancel, e.onTouchEnd, t));
        } else
          (r[p](n.start, e.onTouchStart, !1),
            s[p](n.move, e.onTouchMove, c),
            s[p](n.end, e.onTouchEnd, !1));
        ((i.preventClicks || i.preventClicksPropagation) && r[p]('click', e.onClick, !0),
          i.cssMode && o[p]('scroll', e.onScroll),
          i.updateOnWindowResize
            ? e[u](
                l.ios || l.android
                  ? 'resize orientationchange observerUpdate'
                  : 'resize observerUpdate',
                D,
                !0
              )
            : e[u]('observerUpdate', D, !0));
      };
      const q = {
          attachEvents: function () {
            const e = this,
              t = a(),
              { params: s, support: i } = e;
            ((e.onTouchStart = B.bind(e)),
              (e.onTouchMove = I.bind(e)),
              (e.onTouchEnd = N.bind(e)),
              s.cssMode && (e.onScroll = G.bind(e)),
              (e.onClick = j.bind(e)),
              i.touch && !Y && (t.addEventListener('touchstart', R), (Y = !0)),
              H(e, 'on'));
          },
          detachEvents: function () {
            H(this, 'off');
          },
        },
        F = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      const _ = {
        setBreakpoint: function () {
          const e = this,
            { activeIndex: t, initialized: s, loopedSlides: i = 0, params: a, $el: n } = e,
            r = a.breakpoints;
          if (!r || (r && 0 === Object.keys(r).length)) return;
          const o = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
          if (!o || e.currentBreakpoint === o) return;
          const l = (o in r ? r[o] : void 0) || e.originalParams,
            d = F(e, a),
            c = F(e, l),
            p = a.enabled;
          d && !c
            ? (n.removeClass(
                `${a.containerModifierClass}grid ${a.containerModifierClass}grid-column`
              ),
              e.emitContainerClasses())
            : !d &&
              c &&
              (n.addClass(`${a.containerModifierClass}grid`),
              ((l.grid.fill && 'column' === l.grid.fill) ||
                (!l.grid.fill && 'column' === a.grid.fill)) &&
                n.addClass(`${a.containerModifierClass}grid-column`),
              e.emitContainerClasses());
          const u = l.direction && l.direction !== a.direction,
            h = a.loop && (l.slidesPerView !== a.slidesPerView || u);
          (u && s && e.changeDirection(), b(e.params, l));
          const f = e.params.enabled;
          (Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            p && !f ? e.disable() : !p && f && e.enable(),
            (e.currentBreakpoint = o),
            e.emit('_beforeBreakpoint', l),
            h &&
              s &&
              (e.loopDestroy(),
              e.loopCreate(),
              e.updateSlides(),
              e.slideTo(t - i + e.loopedSlides, 0, !1)),
            e.emit('breakpoint', l));
        },
        getBreakpoint: function (e, t = 'window', s) {
          if (!e || ('container' === t && !s)) return;
          let i = !1;
          const a = r(),
            n = 'window' === t ? a.innerHeight : s.clientHeight,
            o = Object.keys(e).map((e) => {
              if ('string' == typeof e && 0 === e.indexOf('@')) {
                const t = parseFloat(e.substr(1));
                return { value: n * t, point: e };
              }
              return { value: e, point: e };
            });
          o.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < o.length; e += 1) {
            const { point: n, value: r } = o[e];
            'window' === t
              ? a.matchMedia(`(min-width: ${r}px)`).matches && (i = n)
              : r <= s.clientWidth && (i = n);
          }
          return i || 'max';
        },
      };
      const X = {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: i, $el: a, device: n, support: r } = e,
            o = (function (e, t) {
              const s = [];
              return (
                e.forEach((e) => {
                  'object' == typeof e
                    ? Object.keys(e).forEach((i) => {
                        e[i] && s.push(t + i);
                      })
                    : 'string' == typeof e && s.push(t + e);
                }),
                s
              );
            })(
              [
                'initialized',
                s.direction,
                { 'pointer-events': !r.touch },
                { 'free-mode': e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: i },
                { grid: s.grid && s.grid.rows > 1 },
                { 'grid-column': s.grid && s.grid.rows > 1 && 'column' === s.grid.fill },
                { android: n.android },
                { ios: n.ios },
                { 'css-mode': s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
              ],
              s.containerModifierClass
            );
          (t.push(...o), a.addClass([...t].join(' ')), e.emitContainerClasses());
        },
        removeClasses: function () {
          const { $el: e, classNames: t } = this;
          (e.removeClass(t.join(' ')), this.emitContainerClasses());
        },
      };
      const W = {
        init: !0,
        direction: 'horizontal',
        touchEventsTarget: 'wrapper',
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        enabled: !0,
        focusableElements: 'input, select, option, textarea, button, video, label',
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: 'slide',
        breakpoints: void 0,
        breakpointsBase: 'window',
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: 'swiper-',
        slideClass: 'swiper-slide',
        slideBlankClass: 'swiper-slide-invisible-blank',
        slideActiveClass: 'swiper-slide-active',
        slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
        slideVisibleClass: 'swiper-slide-visible',
        slideDuplicateClass: 'swiper-slide-duplicate',
        slideNextClass: 'swiper-slide-next',
        slideDuplicateNextClass: 'swiper-slide-duplicate-next',
        slidePrevClass: 'swiper-slide-prev',
        slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
        wrapperClass: 'swiper-wrapper',
        runCallbacksOnInit: !0,
        _emitClasses: !1,
      };
      function V(e, t) {
        return function (s = {}) {
          const i = Object.keys(s)[0],
            a = s[i];
          'object' == typeof a && null !== a
            ? (['navigation', 'pagination', 'scrollbar'].indexOf(i) >= 0 &&
                !0 === e[i] &&
                (e[i] = { auto: !0 }),
              i in e && 'enabled' in a
                ? (!0 === e[i] && (e[i] = { enabled: !0 }),
                  'object' != typeof e[i] || 'enabled' in e[i] || (e[i].enabled = !0),
                  e[i] || (e[i] = { enabled: !1 }),
                  b(t, s))
                : b(t, s))
            : b(t, s);
        };
      }
      const U = {
          eventsEmitter: M,
          update: k,
          translate: P,
          transition: {
            setTransition: function (e, t) {
              const s = this;
              (s.params.cssMode || s.$wrapperEl.transition(e), s.emit('setTransition', e, t));
            },
            transitionStart: function (e = !0, t) {
              const s = this,
                { params: i } = s;
              i.cssMode ||
                (i.autoHeight && s.updateAutoHeight(),
                z({ swiper: s, runCallbacks: e, direction: t, step: 'Start' }));
            },
            transitionEnd: function (e = !0, t) {
              const s = this,
                { params: i } = s;
              ((s.animating = !1),
                i.cssMode ||
                  (s.setTransition(0),
                  z({ swiper: s, runCallbacks: e, direction: t, step: 'End' })));
            },
          },
          slide: O,
          loop: L,
          grabCursor: {
            setGrabCursor: function (e) {
              const t = this;
              if (
                t.support.touch ||
                !t.params.simulateTouch ||
                (t.params.watchOverflow && t.isLocked) ||
                t.params.cssMode
              )
                return;
              const s = 'container' === t.params.touchEventsTarget ? t.el : t.wrapperEl;
              ((s.style.cursor = 'move'),
                (s.style.cursor = e ? '-webkit-grabbing' : '-webkit-grab'),
                (s.style.cursor = e ? '-moz-grabbin' : '-moz-grab'),
                (s.style.cursor = e ? 'grabbing' : 'grab'));
            },
            unsetGrabCursor: function () {
              const e = this;
              e.support.touch ||
                (e.params.watchOverflow && e.isLocked) ||
                e.params.cssMode ||
                (e['container' === e.params.touchEventsTarget ? 'el' : 'wrapperEl'].style.cursor =
                  '');
            },
          },
          events: q,
          breakpoints: _,
          checkOverflow: {
            checkOverflow: function () {
              const e = this,
                { isLocked: t, params: s } = e,
                { slidesOffsetBefore: i } = s;
              if (i) {
                const t = e.slides.length - 1,
                  s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                e.isLocked = e.size > s;
              } else e.isLocked = 1 === e.snapGrid.length;
              (!0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                t && t !== e.isLocked && (e.isEnd = !1),
                t !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock'));
            },
          },
          classes: X,
          images: {
            loadImage: function (e, t, s, i, a, n) {
              const o = r();
              let l;
              function d() {
                n && n();
              }
              f(e).parent('picture')[0] || (e.complete && a)
                ? d()
                : t
                  ? ((l = new o.Image()),
                    (l.onload = d),
                    (l.onerror = d),
                    i && (l.sizes = i),
                    s && (l.srcset = s),
                    t && (l.src = t))
                  : d();
            },
            preloadImages: function () {
              const e = this;
              function t() {
                null != e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(), e.emit('imagesReady')));
              }
              e.imagesToLoad = e.$el.find('img');
              for (let s = 0; s < e.imagesToLoad.length; s += 1) {
                const i = e.imagesToLoad[s];
                e.loadImage(
                  i,
                  i.currentSrc || i.getAttribute('src'),
                  i.srcset || i.getAttribute('srcset'),
                  i.sizes || i.getAttribute('sizes'),
                  !0,
                  t
                );
              }
            },
          },
        },
        Z = {};
      class Q {
        constructor(...e) {
          let t, s;
          if (
            (1 === e.length &&
            e[0].constructor &&
            'Object' === Object.prototype.toString.call(e[0]).slice(8, -1)
              ? (s = e[0])
              : ([t, s] = e),
            s || (s = {}),
            (s = b({}, s)),
            t && !s.el && (s.el = t),
            s.el && f(s.el).length > 1)
          ) {
            const e = [];
            return (
              f(s.el).each((t) => {
                const i = b({}, s, { el: t });
                e.push(new Q(i));
              }),
              e
            );
          }
          const i = this;
          ((i.__swiper__ = !0),
            (i.support = S()),
            (i.device = A({ userAgent: s.userAgent })),
            (i.browser = $()),
            (i.eventsListeners = {}),
            (i.eventsAnyListeners = []),
            (i.modules = [...i.__modules__]),
            s.modules && Array.isArray(s.modules) && i.modules.push(...s.modules));
          const a = {};
          i.modules.forEach((e) => {
            e({
              swiper: i,
              extendParams: V(s, a),
              on: i.on.bind(i),
              once: i.once.bind(i),
              off: i.off.bind(i),
              emit: i.emit.bind(i),
            });
          });
          const n = b({}, W, a);
          return (
            (i.params = b({}, n, Z, s)),
            (i.originalParams = b({}, i.params)),
            (i.passedParams = b({}, s)),
            i.params &&
              i.params.on &&
              Object.keys(i.params.on).forEach((e) => {
                i.on(e, i.params.on[e]);
              }),
            i.params && i.params.onAny && i.onAny(i.params.onAny),
            (i.$ = f),
            Object.assign(i, {
              enabled: i.params.enabled,
              el: t,
              classNames: [],
              slides: f(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => 'horizontal' === i.params.direction,
              isVertical: () => 'vertical' === i.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: i.params.allowSlideNext,
              allowSlidePrev: i.params.allowSlidePrev,
              touchEvents: (function () {
                const e = ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
                  t = ['pointerdown', 'pointermove', 'pointerup'];
                return (
                  (i.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                  (i.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                  i.support.touch || !i.params.simulateTouch
                    ? i.touchEventsTouch
                    : i.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: i.params.focusableElements,
                lastClickTime: g(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: i.params.allowTouchMove,
              touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            i.emit('_swiper'),
            i.params.init && i.init(),
            i
          );
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit('enable'));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit('disable'));
        }
        setProgress(e, t) {
          const s = this;
          e = Math.min(Math.max(e, 0), 1);
          const i = s.minTranslate(),
            a = (s.maxTranslate() - i) * e + i;
          (s.translateTo(a, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses());
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(' ')
            .filter(
              (t) => 0 === t.indexOf('swiper') || 0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit('_containerClasses', t.join(' '));
        }
        getSlideClasses(e) {
          const t = this;
          return e.className
            .split(' ')
            .filter((e) => 0 === e.indexOf('swiper-slide') || 0 === e.indexOf(t.params.slideClass))
            .join(' ');
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          (e.slides.each((s) => {
            const i = e.getSlideClasses(s);
            (t.push({ slideEl: s, classNames: i }), e.emit('_slideClass', s, i));
          }),
            e.emit('_slideClasses', t));
        }
        slidesPerViewDynamic(e = 'current', t = !1) {
          const {
            params: s,
            slides: i,
            slidesGrid: a,
            slidesSizesGrid: n,
            size: r,
            activeIndex: o,
          } = this;
          let l = 1;
          if (s.centeredSlides) {
            let e,
              t = i[o].swiperSlideSize;
            for (let s = o + 1; s < i.length; s += 1)
              i[s] && !e && ((t += i[s].swiperSlideSize), (l += 1), t > r && (e = !0));
            for (let s = o - 1; s >= 0; s -= 1)
              i[s] && !e && ((t += i[s].swiperSlideSize), (l += 1), t > r && (e = !0));
          } else if ('current' === e)
            for (let e = o + 1; e < i.length; e += 1) {
              (t ? a[e] + n[e] - a[o] < r : a[e] - a[o] < r) && (l += 1);
            }
          else
            for (let e = o - 1; e >= 0; e -= 1) {
              a[o] - a[e] < r && (l += 1);
            }
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: s } = e;
          function i() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            (e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses());
          }
          let a;
          (s.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (i(), e.params.autoHeight && e.updateAutoHeight())
              : ((a =
                  ('auto' === e.params.slidesPerView || e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)),
                a || i()),
            s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit('update'));
        }
        changeDirection(e, t = !0) {
          const s = this,
            i = s.params.direction;
          return (
            e || (e = 'horizontal' === i ? 'vertical' : 'horizontal'),
            e === i ||
              ('horizontal' !== e && 'vertical' !== e) ||
              (s.$el
                .removeClass(`${s.params.containerModifierClass}${i}`)
                .addClass(`${s.params.containerModifierClass}${e}`),
              s.emitContainerClasses(),
              (s.params.direction = e),
              s.slides.each((t) => {
                'vertical' === e ? (t.style.width = '') : (t.style.height = '');
              }),
              s.emit('changeDirection'),
              t && s.update()),
            s
          );
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const s = f(e || t.params.el);
          if (!(e = s[0])) return !1;
          e.swiper = t;
          const i = () => `.${(t.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let n = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = f(e.shadowRoot.querySelector(i()));
              return ((t.children = (e) => s.children(e)), t);
            }
            return s.children(i());
          })();
          if (0 === n.length && t.params.createElements) {
            const e = a().createElement('div');
            ((n = f(e)),
              (e.className = t.params.wrapperClass),
              s.append(e),
              s.children(`.${t.params.slideClass}`).each((e) => {
                n.append(e);
              }));
          }
          return (
            Object.assign(t, {
              $el: s,
              el: e,
              $wrapperEl: n,
              wrapperEl: n[0],
              mounted: !0,
              rtl: 'rtl' === e.dir.toLowerCase() || 'rtl' === s.css('direction'),
              rtlTranslate:
                'horizontal' === t.params.direction &&
                ('rtl' === e.dir.toLowerCase() || 'rtl' === s.css('direction')),
              wrongRTL: '-webkit-box' === n.css('display'),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          if (t.initialized) return t;
          return (
            !1 === t.mount(e) ||
              (t.emit('beforeInit'),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit('init'),
              t.emit('afterInit')),
            t
          );
        }
        destroy(e = !0, t = !0) {
          const s = this,
            { params: i, $el: a, $wrapperEl: n, slides: r } = s;
          return (
            void 0 === s.params ||
              s.destroyed ||
              (s.emit('beforeDestroy'),
              (s.initialized = !1),
              s.detachEvents(),
              i.loop && s.loopDestroy(),
              t &&
                (s.removeClasses(),
                a.removeAttr('style'),
                n.removeAttr('style'),
                r &&
                  r.length &&
                  r
                    .removeClass(
                      [
                        i.slideVisibleClass,
                        i.slideActiveClass,
                        i.slideNextClass,
                        i.slidePrevClass,
                      ].join(' ')
                    )
                    .removeAttr('style')
                    .removeAttr('data-swiper-slide-index')),
              s.emit('destroy'),
              Object.keys(s.eventsListeners).forEach((e) => {
                s.off(e);
              }),
              !1 !== e &&
                ((s.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(s)),
              (s.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          b(Z, e);
        }
        static get extendedDefaults() {
          return Z;
        }
        static get defaults() {
          return W;
        }
        static installModule(e) {
          Q.prototype.__modules__ || (Q.prototype.__modules__ = []);
          const t = Q.prototype.__modules__;
          'function' == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => Q.installModule(e)), Q)
            : (Q.installModule(e), Q);
        }
      }
      (Object.keys(U).forEach((e) => {
        Object.keys(U[e]).forEach((t) => {
          Q.prototype[t] = U[e][t];
        });
      }),
        Q.use([
          function ({ swiper: e, on: t, emit: s }) {
            const i = r();
            let a = null;
            const n = () => {
                e && !e.destroyed && e.initialized && (s('beforeResize'), s('resize'));
              },
              o = () => {
                e && !e.destroyed && e.initialized && s('orientationchange');
              };
            (t('init', () => {
              e.params.resizeObserver && void 0 !== i.ResizeObserver
                ? e &&
                  !e.destroyed &&
                  e.initialized &&
                  ((a = new ResizeObserver((t) => {
                    const { width: s, height: i } = e;
                    let a = s,
                      r = i;
                    (t.forEach(({ contentBoxSize: t, contentRect: s, target: i }) => {
                      (i && i !== e.el) ||
                        ((a = s ? s.width : (t[0] || t).inlineSize),
                        (r = s ? s.height : (t[0] || t).blockSize));
                    }),
                      (a === s && r === i) || n());
                  })),
                  a.observe(e.el))
                : (i.addEventListener('resize', n), i.addEventListener('orientationchange', o));
            }),
              t('destroy', () => {
                (a && a.unobserve && e.el && (a.unobserve(e.el), (a = null)),
                  i.removeEventListener('resize', n),
                  i.removeEventListener('orientationchange', o));
              }));
          },
          function ({ swiper: e, extendParams: t, on: s, emit: i }) {
            const a = [],
              n = r(),
              o = (e, t = {}) => {
                const s = new (n.MutationObserver || n.WebkitMutationObserver)((e) => {
                  if (1 === e.length) return void i('observerUpdate', e[0]);
                  const t = function () {
                    i('observerUpdate', e[0]);
                  };
                  n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0);
                });
                (s.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  a.push(s));
              };
            (t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              s('init', () => {
                if (e.params.observer) {
                  if (e.params.observeParents) {
                    const t = e.$el.parents();
                    for (let e = 0; e < t.length; e += 1) o(t[e]);
                  }
                  (o(e.$el[0], { childList: e.params.observeSlideChildren }),
                    o(e.$wrapperEl[0], { attributes: !1 }));
                }
              }),
              s('destroy', () => {
                (a.forEach((e) => {
                  e.disconnect();
                }),
                  a.splice(0, a.length));
              }));
          },
        ]));
      const J = Q;
      function K(e, t, s, i) {
        const n = a();
        return (
          e.params.createElements &&
            Object.keys(i).forEach((a) => {
              if (!s[a] && !0 === s.auto) {
                let r = e.$el.children(`.${i[a]}`)[0];
                (r || ((r = n.createElement('div')), (r.className = i[a]), e.$el.append(r)),
                  (s[a] = r),
                  (t[a] = r));
              }
            }),
          s
        );
      }
      function ee(e = '') {
        return `.${e
          .trim()
          .replace(/([\.:!\/])/g, '\\$1')
          .replace(/ /g, '.')}`;
      }
      function te(e) {
        const t = this,
          { $wrapperEl: s, params: i } = t;
        if ((i.loop && t.loopDestroy(), 'object' == typeof e && 'length' in e))
          for (let t = 0; t < e.length; t += 1) e[t] && s.append(e[t]);
        else s.append(e);
        (i.loop && t.loopCreate(), i.observer || t.update());
      }
      function se(e) {
        const t = this,
          { params: s, $wrapperEl: i, activeIndex: a } = t;
        s.loop && t.loopDestroy();
        let n = a + 1;
        if ('object' == typeof e && 'length' in e) {
          for (let t = 0; t < e.length; t += 1) e[t] && i.prepend(e[t]);
          n = a + e.length;
        } else i.prepend(e);
        (s.loop && t.loopCreate(), s.observer || t.update(), t.slideTo(n, 0, !1));
      }
      function ie(e, t) {
        const s = this,
          { $wrapperEl: i, params: a, activeIndex: n } = s;
        let r = n;
        a.loop &&
          ((r -= s.loopedSlides), s.loopDestroy(), (s.slides = i.children(`.${a.slideClass}`)));
        const o = s.slides.length;
        if (e <= 0) return void s.prependSlide(t);
        if (e >= o) return void s.appendSlide(t);
        let l = r > e ? r + 1 : r;
        const d = [];
        for (let t = o - 1; t >= e; t -= 1) {
          const e = s.slides.eq(t);
          (e.remove(), d.unshift(e));
        }
        if ('object' == typeof t && 'length' in t) {
          for (let e = 0; e < t.length; e += 1) t[e] && i.append(t[e]);
          l = r > e ? r + t.length : r;
        } else i.append(t);
        for (let e = 0; e < d.length; e += 1) i.append(d[e]);
        (a.loop && s.loopCreate(),
          a.observer || s.update(),
          a.loop ? s.slideTo(l + s.loopedSlides, 0, !1) : s.slideTo(l, 0, !1));
      }
      function ae(e) {
        const t = this,
          { params: s, $wrapperEl: i, activeIndex: a } = t;
        let n = a;
        s.loop &&
          ((n -= t.loopedSlides), t.loopDestroy(), (t.slides = i.children(`.${s.slideClass}`)));
        let r,
          o = n;
        if ('object' == typeof e && 'length' in e) {
          for (let s = 0; s < e.length; s += 1)
            ((r = e[s]), t.slides[r] && t.slides.eq(r).remove(), r < o && (o -= 1));
          o = Math.max(o, 0);
        } else
          ((r = e),
            t.slides[r] && t.slides.eq(r).remove(),
            r < o && (o -= 1),
            (o = Math.max(o, 0)));
        (s.loop && t.loopCreate(),
          s.observer || t.update(),
          s.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1));
      }
      function ne() {
        const e = this,
          t = [];
        for (let s = 0; s < e.slides.length; s += 1) t.push(s);
        e.removeSlide(t);
      }
      function re(e) {
        const {
          effect: t,
          swiper: s,
          on: i,
          setTranslate: a,
          setTransition: n,
          overwriteParams: r,
          perspective: o,
        } = e;
        (i('beforeInit', () => {
          if (s.params.effect !== t) return;
          (s.classNames.push(`${s.params.containerModifierClass}${t}`),
            o && o() && s.classNames.push(`${s.params.containerModifierClass}3d`));
          const e = r ? r() : {};
          (Object.assign(s.params, e), Object.assign(s.originalParams, e));
        }),
          i('setTranslate', () => {
            s.params.effect === t && a();
          }),
          i('setTransition', (e, i) => {
            s.params.effect === t && n(i);
          }));
      }
      function oe(e, t) {
        return e.transformEl
          ? t
              .find(e.transformEl)
              .css({ 'backface-visibility': 'hidden', '-webkit-backface-visibility': 'hidden' })
          : t;
      }
      function le({ swiper: e, duration: t, transformEl: s, allSlides: i }) {
        const { slides: a, activeIndex: n, $wrapperEl: r } = e;
        if (e.params.virtualTranslate && 0 !== t) {
          let t,
            o = !1;
          ((t = i ? (s ? a.find(s) : a) : s ? a.eq(n).find(s) : a.eq(n)),
            t.transitionEnd(() => {
              if (o) return;
              if (!e || e.destroyed) return;
              ((o = !0), (e.animating = !1));
              const t = ['webkitTransitionEnd', 'transitionend'];
              for (let e = 0; e < t.length; e += 1) r.trigger(t[e]);
            }));
        }
      }
      function de(e, t, s) {
        const i = 'swiper-slide-shadow' + (s ? `-${s}` : ''),
          a = e.transformEl ? t.find(e.transformEl) : t;
        let n = a.children(`.${i}`);
        return (
          n.length ||
            ((n = f(`<div class="swiper-slide-shadow${s ? `-${s}` : ''}"></div>`)), a.append(n)),
          n
        );
      }
      const ce = [
        function ({ swiper: e, extendParams: t, on: s }) {
          let i;
          function a(t, s) {
            const i = e.params.virtual;
            if (i.cache && e.virtual.cache[s]) return e.virtual.cache[s];
            const a = i.renderSlide
              ? f(i.renderSlide.call(e, t, s))
              : f(`<div class="${e.params.slideClass}" data-swiper-slide-index="${s}">${t}</div>`);
            return (
              a.attr('data-swiper-slide-index') || a.attr('data-swiper-slide-index', s),
              i.cache && (e.virtual.cache[s] = a),
              a
            );
          }
          function n(t) {
            const { slidesPerView: s, slidesPerGroup: i, centeredSlides: n } = e.params,
              { addSlidesBefore: r, addSlidesAfter: o } = e.params.virtual,
              { from: l, to: d, slides: c, slidesGrid: p, offset: u } = e.virtual;
            e.params.cssMode || e.updateActiveIndex();
            const h = e.activeIndex || 0;
            let f, m, g;
            ((f = e.rtlTranslate ? 'right' : e.isHorizontal() ? 'left' : 'top'),
              n
                ? ((m = Math.floor(s / 2) + i + o), (g = Math.floor(s / 2) + i + r))
                : ((m = s + (i - 1) + o), (g = i + r)));
            const w = Math.max((h || 0) - g, 0),
              v = Math.min((h || 0) + m, c.length - 1),
              b = (e.slidesGrid[w] || 0) - (e.slidesGrid[0] || 0);
            function y() {
              (e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.lazy && e.params.lazy.enabled && e.lazy.load());
            }
            if (
              (Object.assign(e.virtual, { from: w, to: v, offset: b, slidesGrid: e.slidesGrid }),
              l === w && d === v && !t)
            )
              return (
                e.slidesGrid !== p && b !== u && e.slides.css(f, `${b}px`),
                void e.updateProgress()
              );
            if (e.params.virtual.renderExternal)
              return (
                e.params.virtual.renderExternal.call(e, {
                  offset: b,
                  from: w,
                  to: v,
                  slides: (function () {
                    const e = [];
                    for (let t = w; t <= v; t += 1) e.push(c[t]);
                    return e;
                  })(),
                }),
                void (e.params.virtual.renderExternalUpdate && y())
              );
            const x = [],
              E = [];
            if (t) e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
            else
              for (let t = l; t <= d; t += 1)
                (t < w || t > v) &&
                  e.$wrapperEl
                    .find(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`)
                    .remove();
            for (let e = 0; e < c.length; e += 1)
              e >= w &&
                e <= v &&
                (void 0 === d || t ? E.push(e) : (e > d && E.push(e), e < l && x.push(e)));
            (E.forEach((t) => {
              e.$wrapperEl.append(a(c[t], t));
            }),
              x
                .sort((e, t) => t - e)
                .forEach((t) => {
                  e.$wrapperEl.prepend(a(c[t], t));
                }),
              e.$wrapperEl.children('.swiper-slide').css(f, `${b}px`),
              y());
          }
          (t({
            virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              renderExternalUpdate: !0,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          }),
            (e.virtual = {
              cache: {},
              from: void 0,
              to: void 0,
              slides: [],
              offset: 0,
              slidesGrid: [],
            }),
            s('beforeInit', () => {
              e.params.virtual.enabled &&
                ((e.virtual.slides = e.params.virtual.slides),
                e.classNames.push(`${e.params.containerModifierClass}virtual`),
                (e.params.watchSlidesProgress = !0),
                (e.originalParams.watchSlidesProgress = !0),
                e.params.initialSlide || n());
            }),
            s('setTranslate', () => {
              e.params.virtual.enabled &&
                (e.params.cssMode && !e._immediateVirtual
                  ? (clearTimeout(i),
                    (i = setTimeout(() => {
                      n();
                    }, 100)))
                  : n());
            }),
            s('init update resize', () => {
              e.params.virtual.enabled &&
                e.params.cssMode &&
                y(e.wrapperEl, '--swiper-virtual-size', `${e.virtualSize}px`);
            }),
            Object.assign(e.virtual, {
              appendSlide: function (t) {
                if ('object' == typeof t && 'length' in t)
                  for (let s = 0; s < t.length; s += 1) t[s] && e.virtual.slides.push(t[s]);
                else e.virtual.slides.push(t);
                n(!0);
              },
              prependSlide: function (t) {
                const s = e.activeIndex;
                let i = s + 1,
                  a = 1;
                if (Array.isArray(t)) {
                  for (let s = 0; s < t.length; s += 1) t[s] && e.virtual.slides.unshift(t[s]);
                  ((i = s + t.length), (a = t.length));
                } else e.virtual.slides.unshift(t);
                if (e.params.virtual.cache) {
                  const t = e.virtual.cache,
                    s = {};
                  (Object.keys(t).forEach((e) => {
                    const i = t[e],
                      n = i.attr('data-swiper-slide-index');
                    (n && i.attr('data-swiper-slide-index', parseInt(n, 10) + a),
                      (s[parseInt(e, 10) + a] = i));
                  }),
                    (e.virtual.cache = s));
                }
                (n(!0), e.slideTo(i, 0));
              },
              removeSlide: function (t) {
                if (null == t) return;
                let s = e.activeIndex;
                if (Array.isArray(t))
                  for (let i = t.length - 1; i >= 0; i -= 1)
                    (e.virtual.slides.splice(t[i], 1),
                      e.params.virtual.cache && delete e.virtual.cache[t[i]],
                      t[i] < s && (s -= 1),
                      (s = Math.max(s, 0)));
                else
                  (e.virtual.slides.splice(t, 1),
                    e.params.virtual.cache && delete e.virtual.cache[t],
                    t < s && (s -= 1),
                    (s = Math.max(s, 0)));
                (n(!0), e.slideTo(s, 0));
              },
              removeAllSlides: function () {
                ((e.virtual.slides = []),
                  e.params.virtual.cache && (e.virtual.cache = {}),
                  n(!0),
                  e.slideTo(0, 0));
              },
              update: n,
            }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          const n = a(),
            o = r();
          function l(t) {
            if (!e.enabled) return;
            const { rtlTranslate: s } = e;
            let a = t;
            a.originalEvent && (a = a.originalEvent);
            const r = a.keyCode || a.charCode,
              l = e.params.keyboard.pageUpDown,
              d = l && 33 === r,
              c = l && 34 === r,
              p = 37 === r,
              u = 39 === r,
              h = 38 === r,
              f = 40 === r;
            if (!e.allowSlideNext && ((e.isHorizontal() && u) || (e.isVertical() && f) || c))
              return !1;
            if (!e.allowSlidePrev && ((e.isHorizontal() && p) || (e.isVertical() && h) || d))
              return !1;
            if (
              !(
                a.shiftKey ||
                a.altKey ||
                a.ctrlKey ||
                a.metaKey ||
                (n.activeElement &&
                  n.activeElement.nodeName &&
                  ('input' === n.activeElement.nodeName.toLowerCase() ||
                    'textarea' === n.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (e.params.keyboard.onlyInViewport && (d || c || p || u || h || f)) {
                let t = !1;
                if (
                  e.$el.parents(`.${e.params.slideClass}`).length > 0 &&
                  0 === e.$el.parents(`.${e.params.slideActiveClass}`).length
                )
                  return;
                const i = e.$el,
                  a = i[0].clientWidth,
                  n = i[0].clientHeight,
                  r = o.innerWidth,
                  l = o.innerHeight,
                  d = e.$el.offset();
                s && (d.left -= e.$el[0].scrollLeft);
                const c = [
                  [d.left, d.top],
                  [d.left + a, d.top],
                  [d.left, d.top + n],
                  [d.left + a, d.top + n],
                ];
                for (let e = 0; e < c.length; e += 1) {
                  const s = c[e];
                  if (s[0] >= 0 && s[0] <= r && s[1] >= 0 && s[1] <= l) {
                    if (0 === s[0] && 0 === s[1]) continue;
                    t = !0;
                  }
                }
                if (!t) return;
              }
              (e.isHorizontal()
                ? ((d || c || p || u) &&
                    (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
                  (((c || u) && !s) || ((d || p) && s)) && e.slideNext(),
                  (((d || p) && !s) || ((c || u) && s)) && e.slidePrev())
                : ((d || c || h || f) &&
                    (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
                  (c || f) && e.slideNext(),
                  (d || h) && e.slidePrev()),
                i('keyPress', r));
            }
          }
          function d() {
            e.keyboard.enabled || (f(n).on('keydown', l), (e.keyboard.enabled = !0));
          }
          function c() {
            e.keyboard.enabled && (f(n).off('keydown', l), (e.keyboard.enabled = !1));
          }
          ((e.keyboard = { enabled: !1 }),
            t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
            s('init', () => {
              e.params.keyboard.enabled && d();
            }),
            s('destroy', () => {
              e.keyboard.enabled && c();
            }),
            Object.assign(e.keyboard, { enable: d, disable: c }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          const a = r();
          let n;
          (t({
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarget: 'container',
              thresholdDelta: null,
              thresholdTime: null,
            },
          }),
            (e.mousewheel = { enabled: !1 }));
          let o,
            l = g();
          const d = [];
          function c() {
            e.enabled && (e.mouseEntered = !0);
          }
          function p() {
            e.enabled && (e.mouseEntered = !1);
          }
          function u(t) {
            return (
              !(
                e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta
              ) &&
              !(e.params.mousewheel.thresholdTime && g() - l < e.params.mousewheel.thresholdTime) &&
              ((t.delta >= 6 && g() - l < 60) ||
                (t.direction < 0
                  ? (e.isEnd && !e.params.loop) ||
                    e.animating ||
                    (e.slideNext(), i('scroll', t.raw))
                  : (e.isBeginning && !e.params.loop) ||
                    e.animating ||
                    (e.slidePrev(), i('scroll', t.raw)),
                (l = new a.Date().getTime()),
                !1))
            );
          }
          function h(t) {
            let s = t,
              a = !0;
            if (!e.enabled) return;
            const r = e.params.mousewheel;
            e.params.cssMode && s.preventDefault();
            let l = e.$el;
            if (
              ('container' !== e.params.mousewheel.eventsTarget &&
                (l = f(e.params.mousewheel.eventsTarget)),
              !e.mouseEntered && !l[0].contains(s.target) && !r.releaseOnEdges)
            )
              return !0;
            s.originalEvent && (s = s.originalEvent);
            let c = 0;
            const p = e.rtlTranslate ? -1 : 1,
              h = (function (e) {
                let t = 0,
                  s = 0,
                  i = 0,
                  a = 0;
                return (
                  'detail' in e && (s = e.detail),
                  'wheelDelta' in e && (s = -e.wheelDelta / 120),
                  'wheelDeltaY' in e && (s = -e.wheelDeltaY / 120),
                  'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120),
                  'axis' in e && e.axis === e.HORIZONTAL_AXIS && ((t = s), (s = 0)),
                  (i = 10 * t),
                  (a = 10 * s),
                  'deltaY' in e && (a = e.deltaY),
                  'deltaX' in e && (i = e.deltaX),
                  e.shiftKey && !i && ((i = a), (a = 0)),
                  (i || a) &&
                    e.deltaMode &&
                    (1 === e.deltaMode ? ((i *= 40), (a *= 40)) : ((i *= 800), (a *= 800))),
                  i && !t && (t = i < 1 ? -1 : 1),
                  a && !s && (s = a < 1 ? -1 : 1),
                  { spinX: t, spinY: s, pixelX: i, pixelY: a }
                );
              })(s);
            if (r.forceToAxis)
              if (e.isHorizontal()) {
                if (!(Math.abs(h.pixelX) > Math.abs(h.pixelY))) return !0;
                c = -h.pixelX * p;
              } else {
                if (!(Math.abs(h.pixelY) > Math.abs(h.pixelX))) return !0;
                c = -h.pixelY;
              }
            else c = Math.abs(h.pixelX) > Math.abs(h.pixelY) ? -h.pixelX * p : -h.pixelY;
            if (0 === c) return !0;
            r.invert && (c = -c);
            let w = e.getTranslate() + c * r.sensitivity;
            if (
              (w >= e.minTranslate() && (w = e.minTranslate()),
              w <= e.maxTranslate() && (w = e.maxTranslate()),
              (a = !!e.params.loop || !(w === e.minTranslate() || w === e.maxTranslate())),
              a && e.params.nested && s.stopPropagation(),
              e.params.freeMode && e.params.freeMode.enabled)
            ) {
              const t = { time: g(), delta: Math.abs(c), direction: Math.sign(c) },
                a = o && t.time < o.time + 500 && t.delta <= o.delta && t.direction === o.direction;
              if (!a) {
                ((o = void 0), e.params.loop && e.loopFix());
                let l = e.getTranslate() + c * r.sensitivity;
                const p = e.isBeginning,
                  u = e.isEnd;
                if (
                  (l >= e.minTranslate() && (l = e.minTranslate()),
                  l <= e.maxTranslate() && (l = e.maxTranslate()),
                  e.setTransition(0),
                  e.setTranslate(l),
                  e.updateProgress(),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses(),
                  ((!p && e.isBeginning) || (!u && e.isEnd)) && e.updateSlidesClasses(),
                  e.params.freeMode.sticky)
                ) {
                  (clearTimeout(n), (n = void 0), d.length >= 15 && d.shift());
                  const s = d.length ? d[d.length - 1] : void 0,
                    i = d[0];
                  if ((d.push(t), s && (t.delta > s.delta || t.direction !== s.direction)))
                    d.splice(0);
                  else if (
                    d.length >= 15 &&
                    t.time - i.time < 500 &&
                    i.delta - t.delta >= 1 &&
                    t.delta <= 6
                  ) {
                    const s = c > 0 ? 0.8 : 0.2;
                    ((o = t),
                      d.splice(0),
                      (n = m(() => {
                        e.slideToClosest(e.params.speed, !0, void 0, s);
                      }, 0)));
                  }
                  n ||
                    (n = m(() => {
                      ((o = t), d.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5));
                    }, 500));
                }
                if (
                  (a || i('scroll', s),
                  e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(),
                  l === e.minTranslate() || l === e.maxTranslate())
                )
                  return !0;
              }
            } else {
              const s = { time: g(), delta: Math.abs(c), direction: Math.sign(c), raw: t };
              d.length >= 2 && d.shift();
              const i = d.length ? d[d.length - 1] : void 0;
              if (
                (d.push(s),
                i
                  ? (s.direction !== i.direction || s.delta > i.delta || s.time > i.time + 150) &&
                    u(s)
                  : u(s),
                (function (t) {
                  const s = e.params.mousewheel;
                  if (t.direction < 0) {
                    if (e.isEnd && !e.params.loop && s.releaseOnEdges) return !0;
                  } else if (e.isBeginning && !e.params.loop && s.releaseOnEdges) return !0;
                  return !1;
                })(s))
              )
                return !0;
            }
            return (s.preventDefault ? s.preventDefault() : (s.returnValue = !1), !1);
          }
          function w(t) {
            let s = e.$el;
            ('container' !== e.params.mousewheel.eventsTarget &&
              (s = f(e.params.mousewheel.eventsTarget)),
              s[t]('mouseenter', c),
              s[t]('mouseleave', p),
              s[t]('wheel', h));
          }
          function v() {
            return e.params.cssMode
              ? (e.wrapperEl.removeEventListener('wheel', h), !0)
              : !e.mousewheel.enabled && (w('on'), (e.mousewheel.enabled = !0), !0);
          }
          function b() {
            return e.params.cssMode
              ? (e.wrapperEl.addEventListener(event, h), !0)
              : !!e.mousewheel.enabled && (w('off'), (e.mousewheel.enabled = !1), !0);
          }
          (s('init', () => {
            (!e.params.mousewheel.enabled && e.params.cssMode && b(),
              e.params.mousewheel.enabled && v());
          }),
            s('destroy', () => {
              (e.params.cssMode && v(), e.mousewheel.enabled && b());
            }),
            Object.assign(e.mousewheel, { enable: v, disable: b }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          function a(t) {
            let s;
            return (
              t &&
                ((s = f(t)),
                e.params.uniqueNavElements &&
                  'string' == typeof t &&
                  s.length > 1 &&
                  1 === e.$el.find(t).length &&
                  (s = e.$el.find(t))),
              s
            );
          }
          function n(t, s) {
            const i = e.params.navigation;
            t &&
              t.length > 0 &&
              (t[s ? 'addClass' : 'removeClass'](i.disabledClass),
              t[0] && 'BUTTON' === t[0].tagName && (t[0].disabled = s),
              e.params.watchOverflow &&
                e.enabled &&
                t[e.isLocked ? 'addClass' : 'removeClass'](i.lockClass));
          }
          function r() {
            if (e.params.loop) return;
            const { $nextEl: t, $prevEl: s } = e.navigation;
            (n(s, e.isBeginning && !e.params.rewind), n(t, e.isEnd && !e.params.rewind));
          }
          function o(t) {
            (t.preventDefault(),
              (!e.isBeginning || e.params.loop || e.params.rewind) && e.slidePrev());
          }
          function l(t) {
            (t.preventDefault(), (!e.isEnd || e.params.loop || e.params.rewind) && e.slideNext());
          }
          function d() {
            const t = e.params.navigation;
            if (
              ((e.params.navigation = K(e, e.originalParams.navigation, e.params.navigation, {
                nextEl: 'swiper-button-next',
                prevEl: 'swiper-button-prev',
              })),
              !t.nextEl && !t.prevEl)
            )
              return;
            const s = a(t.nextEl),
              i = a(t.prevEl);
            (s && s.length > 0 && s.on('click', l),
              i && i.length > 0 && i.on('click', o),
              Object.assign(e.navigation, {
                $nextEl: s,
                nextEl: s && s[0],
                $prevEl: i,
                prevEl: i && i[0],
              }),
              e.enabled || (s && s.addClass(t.lockClass), i && i.addClass(t.lockClass)));
          }
          function c() {
            const { $nextEl: t, $prevEl: s } = e.navigation;
            (t && t.length && (t.off('click', l), t.removeClass(e.params.navigation.disabledClass)),
              s &&
                s.length &&
                (s.off('click', o), s.removeClass(e.params.navigation.disabledClass)));
          }
          (t({
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: 'swiper-button-disabled',
              hiddenClass: 'swiper-button-hidden',
              lockClass: 'swiper-button-lock',
            },
          }),
            (e.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null }),
            s('init', () => {
              (d(), r());
            }),
            s('toEdge fromEdge lock unlock', () => {
              r();
            }),
            s('destroy', () => {
              c();
            }),
            s('enable disable', () => {
              const { $nextEl: t, $prevEl: s } = e.navigation;
              (t && t[e.enabled ? 'removeClass' : 'addClass'](e.params.navigation.lockClass),
                s && s[e.enabled ? 'removeClass' : 'addClass'](e.params.navigation.lockClass));
            }),
            s('click', (t, s) => {
              const { $nextEl: a, $prevEl: n } = e.navigation,
                r = s.target;
              if (e.params.navigation.hideOnClick && !f(r).is(n) && !f(r).is(a)) {
                if (
                  e.pagination &&
                  e.params.pagination &&
                  e.params.pagination.clickable &&
                  (e.pagination.el === r || e.pagination.el.contains(r))
                )
                  return;
                let t;
                (a
                  ? (t = a.hasClass(e.params.navigation.hiddenClass))
                  : n && (t = n.hasClass(e.params.navigation.hiddenClass)),
                  i(!0 === t ? 'navigationShow' : 'navigationHide'),
                  a && a.toggleClass(e.params.navigation.hiddenClass),
                  n && n.toggleClass(e.params.navigation.hiddenClass));
              }
            }),
            Object.assign(e.navigation, { update: r, init: d, destroy: c }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          const a = 'swiper-pagination';
          let n;
          (t({
            pagination: {
              el: null,
              bulletElement: 'span',
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: 'bullets',
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: (e) => e,
              formatFractionTotal: (e) => e,
              bulletClass: `${a}-bullet`,
              bulletActiveClass: `${a}-bullet-active`,
              modifierClass: `${a}-`,
              currentClass: `${a}-current`,
              totalClass: `${a}-total`,
              hiddenClass: `${a}-hidden`,
              progressbarFillClass: `${a}-progressbar-fill`,
              progressbarOppositeClass: `${a}-progressbar-opposite`,
              clickableClass: `${a}-clickable`,
              lockClass: `${a}-lock`,
              horizontalClass: `${a}-horizontal`,
              verticalClass: `${a}-vertical`,
            },
          }),
            (e.pagination = { el: null, $el: null, bullets: [] }));
          let r = 0;
          function o() {
            return (
              !e.params.pagination.el ||
              !e.pagination.el ||
              !e.pagination.$el ||
              0 === e.pagination.$el.length
            );
          }
          function l(t, s) {
            const { bulletActiveClass: i } = e.params.pagination;
            t[s]().addClass(`${i}-${s}`)[s]().addClass(`${i}-${s}-${s}`);
          }
          function d() {
            const t = e.rtl,
              s = e.params.pagination;
            if (o()) return;
            const a =
                e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              d = e.pagination.$el;
            let c;
            const p = e.params.loop
              ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup)
              : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((c = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
                  c > a - 1 - 2 * e.loopedSlides && (c -= a - 2 * e.loopedSlides),
                  c > p - 1 && (c -= p),
                  c < 0 && 'bullets' !== e.params.paginationType && (c = p + c))
                : (c = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
              'bullets' === s.type && e.pagination.bullets && e.pagination.bullets.length > 0)
            ) {
              const i = e.pagination.bullets;
              let a, o, p;
              if (
                (s.dynamicBullets &&
                  ((n = i.eq(0)[e.isHorizontal() ? 'outerWidth' : 'outerHeight'](!0)),
                  d.css(
                    e.isHorizontal() ? 'width' : 'height',
                    n * (s.dynamicMainBullets + 4) + 'px'
                  ),
                  s.dynamicMainBullets > 1 &&
                    void 0 !== e.previousIndex &&
                    ((r += c - (e.previousIndex - e.loopedSlides || 0)),
                    r > s.dynamicMainBullets - 1
                      ? (r = s.dynamicMainBullets - 1)
                      : r < 0 && (r = 0)),
                  (a = Math.max(c - r, 0)),
                  (o = a + (Math.min(i.length, s.dynamicMainBullets) - 1)),
                  (p = (o + a) / 2)),
                i.removeClass(
                  ['', '-next', '-next-next', '-prev', '-prev-prev', '-main']
                    .map((e) => `${s.bulletActiveClass}${e}`)
                    .join(' ')
                ),
                d.length > 1)
              )
                i.each((e) => {
                  const t = f(e),
                    i = t.index();
                  (i === c && t.addClass(s.bulletActiveClass),
                    s.dynamicBullets &&
                      (i >= a && i <= o && t.addClass(`${s.bulletActiveClass}-main`),
                      i === a && l(t, 'prev'),
                      i === o && l(t, 'next')));
                });
              else {
                const t = i.eq(c),
                  n = t.index();
                if ((t.addClass(s.bulletActiveClass), s.dynamicBullets)) {
                  const t = i.eq(a),
                    r = i.eq(o);
                  for (let e = a; e <= o; e += 1) i.eq(e).addClass(`${s.bulletActiveClass}-main`);
                  if (e.params.loop)
                    if (n >= i.length) {
                      for (let e = s.dynamicMainBullets; e >= 0; e -= 1)
                        i.eq(i.length - e).addClass(`${s.bulletActiveClass}-main`);
                      i.eq(i.length - s.dynamicMainBullets - 1).addClass(
                        `${s.bulletActiveClass}-prev`
                      );
                    } else (l(t, 'prev'), l(r, 'next'));
                  else (l(t, 'prev'), l(r, 'next'));
                }
              }
              if (s.dynamicBullets) {
                const a = Math.min(i.length, s.dynamicMainBullets + 4),
                  r = (n * a - n) / 2 - p * n,
                  o = t ? 'right' : 'left';
                i.css(e.isHorizontal() ? o : 'top', `${r}px`);
              }
            }
            if (
              ('fraction' === s.type &&
                (d.find(ee(s.currentClass)).text(s.formatFractionCurrent(c + 1)),
                d.find(ee(s.totalClass)).text(s.formatFractionTotal(p))),
              'progressbar' === s.type)
            ) {
              let t;
              t = s.progressbarOpposite
                ? e.isHorizontal()
                  ? 'vertical'
                  : 'horizontal'
                : e.isHorizontal()
                  ? 'horizontal'
                  : 'vertical';
              const i = (c + 1) / p;
              let a = 1,
                n = 1;
              ('horizontal' === t ? (a = i) : (n = i),
                d
                  .find(ee(s.progressbarFillClass))
                  .transform(`translate3d(0,0,0) scaleX(${a}) scaleY(${n})`)
                  .transition(e.params.speed));
            }
            ('custom' === s.type && s.renderCustom
              ? (d.html(s.renderCustom(e, c + 1, p)), i('paginationRender', d[0]))
              : i('paginationUpdate', d[0]),
              e.params.watchOverflow &&
                e.enabled &&
                d[e.isLocked ? 'addClass' : 'removeClass'](s.lockClass));
          }
          function c() {
            const t = e.params.pagination;
            if (o()) return;
            const s =
                e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              a = e.pagination.$el;
            let n = '';
            if ('bullets' === t.type) {
              let i = e.params.loop
                ? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup)
                : e.snapGrid.length;
              e.params.freeMode && e.params.freeMode.enabled && !e.params.loop && i > s && (i = s);
              for (let s = 0; s < i; s += 1)
                t.renderBullet
                  ? (n += t.renderBullet.call(e, s, t.bulletClass))
                  : (n += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
              (a.html(n), (e.pagination.bullets = a.find(ee(t.bulletClass))));
            }
            ('fraction' === t.type &&
              ((n = t.renderFraction
                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
              a.html(n)),
              'progressbar' === t.type &&
                ((n = t.renderProgressbar
                  ? t.renderProgressbar.call(e, t.progressbarFillClass)
                  : `<span class="${t.progressbarFillClass}"></span>`),
                a.html(n)),
              'custom' !== t.type && i('paginationRender', e.pagination.$el[0]));
          }
          function p() {
            e.params.pagination = K(e, e.originalParams.pagination, e.params.pagination, {
              el: 'swiper-pagination',
            });
            const t = e.params.pagination;
            if (!t.el) return;
            let s = f(t.el);
            0 !== s.length &&
              (e.params.uniqueNavElements &&
                'string' == typeof t.el &&
                s.length > 1 &&
                ((s = e.$el.find(t.el)),
                s.length > 1 && (s = s.filter((t) => f(t).parents('.swiper')[0] === e.el))),
              'bullets' === t.type && t.clickable && s.addClass(t.clickableClass),
              s.addClass(t.modifierClass + t.type),
              s.addClass(t.modifierClass + e.params.direction),
              'bullets' === t.type &&
                t.dynamicBullets &&
                (s.addClass(`${t.modifierClass}${t.type}-dynamic`),
                (r = 0),
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
              'progressbar' === t.type &&
                t.progressbarOpposite &&
                s.addClass(t.progressbarOppositeClass),
              t.clickable &&
                s.on('click', ee(t.bulletClass), function (t) {
                  t.preventDefault();
                  let s = f(this).index() * e.params.slidesPerGroup;
                  (e.params.loop && (s += e.loopedSlides), e.slideTo(s));
                }),
              Object.assign(e.pagination, { $el: s, el: s[0] }),
              e.enabled || s.addClass(t.lockClass));
          }
          function u() {
            const t = e.params.pagination;
            if (o()) return;
            const s = e.pagination.$el;
            (s.removeClass(t.hiddenClass),
              s.removeClass(t.modifierClass + t.type),
              s.removeClass(t.modifierClass + e.params.direction),
              e.pagination.bullets &&
                e.pagination.bullets.removeClass &&
                e.pagination.bullets.removeClass(t.bulletActiveClass),
              t.clickable && s.off('click', ee(t.bulletClass)));
          }
          (s('init', () => {
            (p(), c(), d());
          }),
            s('activeIndexChange', () => {
              (e.params.loop || void 0 === e.snapIndex) && d();
            }),
            s('snapIndexChange', () => {
              e.params.loop || d();
            }),
            s('slidesLengthChange', () => {
              e.params.loop && (c(), d());
            }),
            s('snapGridLengthChange', () => {
              e.params.loop || (c(), d());
            }),
            s('destroy', () => {
              u();
            }),
            s('enable disable', () => {
              const { $el: t } = e.pagination;
              t && t[e.enabled ? 'removeClass' : 'addClass'](e.params.pagination.lockClass);
            }),
            s('lock unlock', () => {
              d();
            }),
            s('click', (t, s) => {
              const a = s.target,
                { $el: n } = e.pagination;
              if (
                e.params.pagination.el &&
                e.params.pagination.hideOnClick &&
                n.length > 0 &&
                !f(a).hasClass(e.params.pagination.bulletClass)
              ) {
                if (
                  e.navigation &&
                  ((e.navigation.nextEl && a === e.navigation.nextEl) ||
                    (e.navigation.prevEl && a === e.navigation.prevEl))
                )
                  return;
                const t = n.hasClass(e.params.pagination.hiddenClass);
                (i(!0 === t ? 'paginationShow' : 'paginationHide'),
                  n.toggleClass(e.params.pagination.hiddenClass));
              }
            }),
            Object.assign(e.pagination, { render: c, update: d, init: p, destroy: u }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          const n = a();
          let r,
            o,
            l,
            d,
            c = !1,
            p = null,
            u = null;
          function h() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t, rtlTranslate: s, progress: i } = e,
              { $dragEl: a, $el: n } = t,
              r = e.params.scrollbar;
            let d = o,
              c = (l - o) * i;
            (s
              ? ((c = -c), c > 0 ? ((d = o - c), (c = 0)) : -c + o > l && (d = l + c))
              : c < 0
                ? ((d = o + c), (c = 0))
                : c + o > l && (d = l - c),
              e.isHorizontal()
                ? (a.transform(`translate3d(${c}px, 0, 0)`), (a[0].style.width = `${d}px`))
                : (a.transform(`translate3d(0px, ${c}px, 0)`), (a[0].style.height = `${d}px`)),
              r.hide &&
                (clearTimeout(p),
                (n[0].style.opacity = 1),
                (p = setTimeout(() => {
                  ((n[0].style.opacity = 0), n.transition(400));
                }, 1e3))));
          }
          function g() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t } = e,
              { $dragEl: s, $el: i } = t;
            ((s[0].style.width = ''),
              (s[0].style.height = ''),
              (l = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight),
              (d =
                e.size /
                (e.virtualSize +
                  e.params.slidesOffsetBefore -
                  (e.params.centeredSlides ? e.snapGrid[0] : 0))),
              (o =
                'auto' === e.params.scrollbar.dragSize
                  ? l * d
                  : parseInt(e.params.scrollbar.dragSize, 10)),
              e.isHorizontal() ? (s[0].style.width = `${o}px`) : (s[0].style.height = `${o}px`),
              (i[0].style.display = d >= 1 ? 'none' : ''),
              e.params.scrollbar.hide && (i[0].style.opacity = 0),
              e.params.watchOverflow &&
                e.enabled &&
                t.$el[e.isLocked ? 'addClass' : 'removeClass'](e.params.scrollbar.lockClass));
          }
          function w(t) {
            return e.isHorizontal()
              ? 'touchstart' === t.type || 'touchmove' === t.type
                ? t.targetTouches[0].clientX
                : t.clientX
              : 'touchstart' === t.type || 'touchmove' === t.type
                ? t.targetTouches[0].clientY
                : t.clientY;
          }
          function v(t) {
            const { scrollbar: s, rtlTranslate: i } = e,
              { $el: a } = s;
            let n;
            ((n =
              (w(t) - a.offset()[e.isHorizontal() ? 'left' : 'top'] - (null !== r ? r : o / 2)) /
              (l - o)),
              (n = Math.max(Math.min(n, 1), 0)),
              i && (n = 1 - n));
            const d = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * n;
            (e.updateProgress(d),
              e.setTranslate(d),
              e.updateActiveIndex(),
              e.updateSlidesClasses());
          }
          function b(t) {
            const s = e.params.scrollbar,
              { scrollbar: a, $wrapperEl: n } = e,
              { $el: o, $dragEl: l } = a;
            ((c = !0),
              (r =
                t.target === l[0] || t.target === l
                  ? w(t) - t.target.getBoundingClientRect()[e.isHorizontal() ? 'left' : 'top']
                  : null),
              t.preventDefault(),
              t.stopPropagation(),
              n.transition(100),
              l.transition(100),
              v(t),
              clearTimeout(u),
              o.transition(0),
              s.hide && o.css('opacity', 1),
              e.params.cssMode && e.$wrapperEl.css('scroll-snap-type', 'none'),
              i('scrollbarDragStart', t));
          }
          function y(t) {
            const { scrollbar: s, $wrapperEl: a } = e,
              { $el: n, $dragEl: r } = s;
            c &&
              (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
              v(t),
              a.transition(0),
              n.transition(0),
              r.transition(0),
              i('scrollbarDragMove', t));
          }
          function x(t) {
            const s = e.params.scrollbar,
              { scrollbar: a, $wrapperEl: n } = e,
              { $el: r } = a;
            c &&
              ((c = !1),
              e.params.cssMode && (e.$wrapperEl.css('scroll-snap-type', ''), n.transition('')),
              s.hide &&
                (clearTimeout(u),
                (u = m(() => {
                  (r.css('opacity', 0), r.transition(400));
                }, 1e3))),
              i('scrollbarDragEnd', t),
              s.snapOnRelease && e.slideToClosest());
          }
          function E(t) {
            const {
                scrollbar: s,
                touchEventsTouch: i,
                touchEventsDesktop: a,
                params: r,
                support: o,
              } = e,
              l = s.$el[0],
              d = !(!o.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
              c = !(!o.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
            if (!l) return;
            const p = 'on' === t ? 'addEventListener' : 'removeEventListener';
            o.touch
              ? (l[p](i.start, b, d), l[p](i.move, y, d), l[p](i.end, x, c))
              : (l[p](a.start, b, d), n[p](a.move, y, d), n[p](a.end, x, c));
          }
          function C() {
            const { scrollbar: t, $el: s } = e;
            e.params.scrollbar = K(e, e.originalParams.scrollbar, e.params.scrollbar, {
              el: 'swiper-scrollbar',
            });
            const i = e.params.scrollbar;
            if (!i.el) return;
            let a = f(i.el);
            e.params.uniqueNavElements &&
              'string' == typeof i.el &&
              a.length > 1 &&
              1 === s.find(i.el).length &&
              (a = s.find(i.el));
            let n = a.find(`.${e.params.scrollbar.dragClass}`);
            (0 === n.length &&
              ((n = f(`<div class="${e.params.scrollbar.dragClass}"></div>`)), a.append(n)),
              Object.assign(t, { $el: a, el: a[0], $dragEl: n, dragEl: n[0] }),
              i.draggable && e.params.scrollbar.el && E('on'),
              a && a[e.enabled ? 'removeClass' : 'addClass'](e.params.scrollbar.lockClass));
          }
          function T() {
            e.params.scrollbar.el && E('off');
          }
          (t({
            scrollbar: {
              el: null,
              dragSize: 'auto',
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: 'swiper-scrollbar-lock',
              dragClass: 'swiper-scrollbar-drag',
            },
          }),
            (e.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null }),
            s('init', () => {
              (C(), g(), h());
            }),
            s('update resize observerUpdate lock unlock', () => {
              g();
            }),
            s('setTranslate', () => {
              h();
            }),
            s('setTransition', (t, s) => {
              !(function (t) {
                e.params.scrollbar.el && e.scrollbar.el && e.scrollbar.$dragEl.transition(t);
              })(s);
            }),
            s('enable disable', () => {
              const { $el: t } = e.scrollbar;
              t && t[e.enabled ? 'removeClass' : 'addClass'](e.params.scrollbar.lockClass);
            }),
            s('destroy', () => {
              T();
            }),
            Object.assign(e.scrollbar, { updateSize: g, setTranslate: h, init: C, destroy: T }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          t({ parallax: { enabled: !1 } });
          const i = (t, s) => {
              const { rtl: i } = e,
                a = f(t),
                n = i ? -1 : 1,
                r = a.attr('data-swiper-parallax') || '0';
              let o = a.attr('data-swiper-parallax-x'),
                l = a.attr('data-swiper-parallax-y');
              const d = a.attr('data-swiper-parallax-scale'),
                c = a.attr('data-swiper-parallax-opacity');
              if (
                (o || l
                  ? ((o = o || '0'), (l = l || '0'))
                  : e.isHorizontal()
                    ? ((o = r), (l = '0'))
                    : ((l = r), (o = '0')),
                (o = o.indexOf('%') >= 0 ? parseInt(o, 10) * s * n + '%' : o * s * n + 'px'),
                (l = l.indexOf('%') >= 0 ? parseInt(l, 10) * s + '%' : l * s + 'px'),
                null != c)
              ) {
                const e = c - (c - 1) * (1 - Math.abs(s));
                a[0].style.opacity = e;
              }
              if (null == d) a.transform(`translate3d(${o}, ${l}, 0px)`);
              else {
                const e = d - (d - 1) * (1 - Math.abs(s));
                a.transform(`translate3d(${o}, ${l}, 0px) scale(${e})`);
              }
            },
            a = () => {
              const { $el: t, slides: s, progress: a, snapGrid: n } = e;
              (t
                .children(
                  '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
                )
                .each((e) => {
                  i(e, a);
                }),
                s.each((t, s) => {
                  let r = t.progress;
                  (e.params.slidesPerGroup > 1 &&
                    'auto' !== e.params.slidesPerView &&
                    (r += Math.ceil(s / 2) - a * (n.length - 1)),
                    (r = Math.min(Math.max(r, -1), 1)),
                    f(t)
                      .find(
                        '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
                      )
                      .each((e) => {
                        i(e, r);
                      }));
                }));
            };
          (s('beforeInit', () => {
            e.params.parallax.enabled &&
              ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
          }),
            s('init', () => {
              e.params.parallax.enabled && a();
            }),
            s('setTranslate', () => {
              e.params.parallax.enabled && a();
            }),
            s('setTransition', (t, s) => {
              e.params.parallax.enabled &&
                ((t = e.params.speed) => {
                  const { $el: s } = e;
                  s.find(
                    '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
                  ).each((e) => {
                    const s = f(e);
                    let i = parseInt(s.attr('data-swiper-parallax-duration'), 10) || t;
                    (0 === t && (i = 0), s.transition(i));
                  });
                })(s);
            }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          const a = r();
          (t({
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: 'swiper-zoom-container',
              zoomedSlideClass: 'swiper-slide-zoomed',
            },
          }),
            (e.zoom = { enabled: !1 }));
          let n,
            o,
            l,
            d = 1,
            c = !1;
          const p = {
              $slideEl: void 0,
              slideWidth: void 0,
              slideHeight: void 0,
              $imageEl: void 0,
              $imageWrapEl: void 0,
              maxRatio: 3,
            },
            u = {
              isTouched: void 0,
              isMoved: void 0,
              currentX: void 0,
              currentY: void 0,
              minX: void 0,
              minY: void 0,
              maxX: void 0,
              maxY: void 0,
              width: void 0,
              height: void 0,
              startX: void 0,
              startY: void 0,
              touchesStart: {},
              touchesCurrent: {},
            },
            h = {
              x: void 0,
              y: void 0,
              prevPositionX: void 0,
              prevPositionY: void 0,
              prevTime: void 0,
            };
          let m = 1;
          function g(e) {
            if (e.targetTouches.length < 2) return 1;
            const t = e.targetTouches[0].pageX,
              s = e.targetTouches[0].pageY,
              i = e.targetTouches[1].pageX,
              a = e.targetTouches[1].pageY;
            return Math.sqrt((i - t) ** 2 + (a - s) ** 2);
          }
          function v(t) {
            const s = e.support,
              i = e.params.zoom;
            if (((o = !1), (l = !1), !s.gestures)) {
              if (
                'touchstart' !== t.type ||
                ('touchstart' === t.type && t.targetTouches.length < 2)
              )
                return;
              ((o = !0), (p.scaleStart = g(t)));
            }
            (p.$slideEl && p.$slideEl.length) ||
            ((p.$slideEl = f(t.target).closest(`.${e.params.slideClass}`)),
            0 === p.$slideEl.length && (p.$slideEl = e.slides.eq(e.activeIndex)),
            (p.$imageEl = p.$slideEl
              .find(`.${i.containerClass}`)
              .eq(0)
              .find('picture, img, svg, canvas, .swiper-zoom-target')
              .eq(0)),
            (p.$imageWrapEl = p.$imageEl.parent(`.${i.containerClass}`)),
            (p.maxRatio = p.$imageWrapEl.attr('data-swiper-zoom') || i.maxRatio),
            0 !== p.$imageWrapEl.length)
              ? (p.$imageEl && p.$imageEl.transition(0), (c = !0))
              : (p.$imageEl = void 0);
          }
          function b(t) {
            const s = e.support,
              i = e.params.zoom,
              a = e.zoom;
            if (!s.gestures) {
              if ('touchmove' !== t.type || ('touchmove' === t.type && t.targetTouches.length < 2))
                return;
              ((l = !0), (p.scaleMove = g(t)));
            }
            p.$imageEl && 0 !== p.$imageEl.length
              ? (s.gestures
                  ? (a.scale = t.scale * d)
                  : (a.scale = (p.scaleMove / p.scaleStart) * d),
                a.scale > p.maxRatio &&
                  (a.scale = p.maxRatio - 1 + (a.scale - p.maxRatio + 1) ** 0.5),
                a.scale < i.minRatio &&
                  (a.scale = i.minRatio + 1 - (i.minRatio - a.scale + 1) ** 0.5),
                p.$imageEl.transform(`translate3d(0,0,0) scale(${a.scale})`))
              : 'gesturechange' === t.type && v(t);
          }
          function y(t) {
            const s = e.device,
              i = e.support,
              a = e.params.zoom,
              n = e.zoom;
            if (!i.gestures) {
              if (!o || !l) return;
              if (
                'touchend' !== t.type ||
                ('touchend' === t.type && t.changedTouches.length < 2 && !s.android)
              )
                return;
              ((o = !1), (l = !1));
            }
            p.$imageEl &&
              0 !== p.$imageEl.length &&
              ((n.scale = Math.max(Math.min(n.scale, p.maxRatio), a.minRatio)),
              p.$imageEl
                .transition(e.params.speed)
                .transform(`translate3d(0,0,0) scale(${n.scale})`),
              (d = n.scale),
              (c = !1),
              1 === n.scale && (p.$slideEl = void 0));
          }
          function x(t) {
            const s = e.zoom;
            if (!p.$imageEl || 0 === p.$imageEl.length) return;
            if (((e.allowClick = !1), !u.isTouched || !p.$slideEl)) return;
            u.isMoved ||
              ((u.width = p.$imageEl[0].offsetWidth),
              (u.height = p.$imageEl[0].offsetHeight),
              (u.startX = w(p.$imageWrapEl[0], 'x') || 0),
              (u.startY = w(p.$imageWrapEl[0], 'y') || 0),
              (p.slideWidth = p.$slideEl[0].offsetWidth),
              (p.slideHeight = p.$slideEl[0].offsetHeight),
              p.$imageWrapEl.transition(0));
            const i = u.width * s.scale,
              a = u.height * s.scale;
            if (!(i < p.slideWidth && a < p.slideHeight)) {
              if (
                ((u.minX = Math.min(p.slideWidth / 2 - i / 2, 0)),
                (u.maxX = -u.minX),
                (u.minY = Math.min(p.slideHeight / 2 - a / 2, 0)),
                (u.maxY = -u.minY),
                (u.touchesCurrent.x = 'touchmove' === t.type ? t.targetTouches[0].pageX : t.pageX),
                (u.touchesCurrent.y = 'touchmove' === t.type ? t.targetTouches[0].pageY : t.pageY),
                !u.isMoved && !c)
              ) {
                if (
                  e.isHorizontal() &&
                  ((Math.floor(u.minX) === Math.floor(u.startX) &&
                    u.touchesCurrent.x < u.touchesStart.x) ||
                    (Math.floor(u.maxX) === Math.floor(u.startX) &&
                      u.touchesCurrent.x > u.touchesStart.x))
                )
                  return void (u.isTouched = !1);
                if (
                  !e.isHorizontal() &&
                  ((Math.floor(u.minY) === Math.floor(u.startY) &&
                    u.touchesCurrent.y < u.touchesStart.y) ||
                    (Math.floor(u.maxY) === Math.floor(u.startY) &&
                      u.touchesCurrent.y > u.touchesStart.y))
                )
                  return void (u.isTouched = !1);
              }
              (t.cancelable && t.preventDefault(),
                t.stopPropagation(),
                (u.isMoved = !0),
                (u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX),
                (u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY),
                u.currentX < u.minX && (u.currentX = u.minX + 1 - (u.minX - u.currentX + 1) ** 0.8),
                u.currentX > u.maxX && (u.currentX = u.maxX - 1 + (u.currentX - u.maxX + 1) ** 0.8),
                u.currentY < u.minY && (u.currentY = u.minY + 1 - (u.minY - u.currentY + 1) ** 0.8),
                u.currentY > u.maxY && (u.currentY = u.maxY - 1 + (u.currentY - u.maxY + 1) ** 0.8),
                h.prevPositionX || (h.prevPositionX = u.touchesCurrent.x),
                h.prevPositionY || (h.prevPositionY = u.touchesCurrent.y),
                h.prevTime || (h.prevTime = Date.now()),
                (h.x = (u.touchesCurrent.x - h.prevPositionX) / (Date.now() - h.prevTime) / 2),
                (h.y = (u.touchesCurrent.y - h.prevPositionY) / (Date.now() - h.prevTime) / 2),
                Math.abs(u.touchesCurrent.x - h.prevPositionX) < 2 && (h.x = 0),
                Math.abs(u.touchesCurrent.y - h.prevPositionY) < 2 && (h.y = 0),
                (h.prevPositionX = u.touchesCurrent.x),
                (h.prevPositionY = u.touchesCurrent.y),
                (h.prevTime = Date.now()),
                p.$imageWrapEl.transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`));
            }
          }
          function E() {
            const t = e.zoom;
            p.$slideEl &&
              e.previousIndex !== e.activeIndex &&
              (p.$imageEl && p.$imageEl.transform('translate3d(0,0,0) scale(1)'),
              p.$imageWrapEl && p.$imageWrapEl.transform('translate3d(0,0,0)'),
              (t.scale = 1),
              (d = 1),
              (p.$slideEl = void 0),
              (p.$imageEl = void 0),
              (p.$imageWrapEl = void 0));
          }
          function C(t) {
            const s = e.zoom,
              i = e.params.zoom;
            if (
              (p.$slideEl ||
                (t && t.target && (p.$slideEl = f(t.target).closest(`.${e.params.slideClass}`)),
                p.$slideEl ||
                  (e.params.virtual && e.params.virtual.enabled && e.virtual
                    ? (p.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`))
                    : (p.$slideEl = e.slides.eq(e.activeIndex))),
                (p.$imageEl = p.$slideEl
                  .find(`.${i.containerClass}`)
                  .eq(0)
                  .find('picture, img, svg, canvas, .swiper-zoom-target')
                  .eq(0)),
                (p.$imageWrapEl = p.$imageEl.parent(`.${i.containerClass}`))),
              !p.$imageEl ||
                0 === p.$imageEl.length ||
                !p.$imageWrapEl ||
                0 === p.$imageWrapEl.length)
            )
              return;
            let n, r, o, l, c, h, m, g, w, v, b, y, x, E, C, T, S, A;
            (e.params.cssMode &&
              ((e.wrapperEl.style.overflow = 'hidden'), (e.wrapperEl.style.touchAction = 'none')),
              p.$slideEl.addClass(`${i.zoomedSlideClass}`),
              void 0 === u.touchesStart.x && t
                ? ((n = 'touchend' === t.type ? t.changedTouches[0].pageX : t.pageX),
                  (r = 'touchend' === t.type ? t.changedTouches[0].pageY : t.pageY))
                : ((n = u.touchesStart.x), (r = u.touchesStart.y)),
              (s.scale = p.$imageWrapEl.attr('data-swiper-zoom') || i.maxRatio),
              (d = p.$imageWrapEl.attr('data-swiper-zoom') || i.maxRatio),
              t
                ? ((S = p.$slideEl[0].offsetWidth),
                  (A = p.$slideEl[0].offsetHeight),
                  (o = p.$slideEl.offset().left + a.scrollX),
                  (l = p.$slideEl.offset().top + a.scrollY),
                  (c = o + S / 2 - n),
                  (h = l + A / 2 - r),
                  (w = p.$imageEl[0].offsetWidth),
                  (v = p.$imageEl[0].offsetHeight),
                  (b = w * s.scale),
                  (y = v * s.scale),
                  (x = Math.min(S / 2 - b / 2, 0)),
                  (E = Math.min(A / 2 - y / 2, 0)),
                  (C = -x),
                  (T = -E),
                  (m = c * s.scale),
                  (g = h * s.scale),
                  m < x && (m = x),
                  m > C && (m = C),
                  g < E && (g = E),
                  g > T && (g = T))
                : ((m = 0), (g = 0)),
              p.$imageWrapEl.transition(300).transform(`translate3d(${m}px, ${g}px,0)`),
              p.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${s.scale})`));
          }
          function T() {
            const t = e.zoom,
              s = e.params.zoom;
            (p.$slideEl ||
              (e.params.virtual && e.params.virtual.enabled && e.virtual
                ? (p.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`))
                : (p.$slideEl = e.slides.eq(e.activeIndex)),
              (p.$imageEl = p.$slideEl
                .find(`.${s.containerClass}`)
                .eq(0)
                .find('picture, img, svg, canvas, .swiper-zoom-target')
                .eq(0)),
              (p.$imageWrapEl = p.$imageEl.parent(`.${s.containerClass}`))),
              p.$imageEl &&
                0 !== p.$imageEl.length &&
                p.$imageWrapEl &&
                0 !== p.$imageWrapEl.length &&
                (e.params.cssMode &&
                  ((e.wrapperEl.style.overflow = ''), (e.wrapperEl.style.touchAction = '')),
                (t.scale = 1),
                (d = 1),
                p.$imageWrapEl.transition(300).transform('translate3d(0,0,0)'),
                p.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)'),
                p.$slideEl.removeClass(`${s.zoomedSlideClass}`),
                (p.$slideEl = void 0)));
          }
          function S(t) {
            const s = e.zoom;
            s.scale && 1 !== s.scale ? T() : C(t);
          }
          function A() {
            const t = e.support;
            return {
              passiveListener: !(
                'touchstart' !== e.touchEvents.start ||
                !t.passiveListener ||
                !e.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              activeListenerWithCapture: !t.passiveListener || { passive: !1, capture: !0 },
            };
          }
          function $() {
            return `.${e.params.slideClass}`;
          }
          function M(t) {
            const { passiveListener: s } = A(),
              i = $();
            (e.$wrapperEl[t]('gesturestart', i, v, s),
              e.$wrapperEl[t]('gesturechange', i, b, s),
              e.$wrapperEl[t]('gestureend', i, y, s));
          }
          function k() {
            n || ((n = !0), M('on'));
          }
          function P() {
            n && ((n = !1), M('off'));
          }
          function z() {
            const t = e.zoom;
            if (t.enabled) return;
            t.enabled = !0;
            const s = e.support,
              { passiveListener: i, activeListenerWithCapture: a } = A(),
              n = $();
            (s.gestures
              ? (e.$wrapperEl.on(e.touchEvents.start, k, i),
                e.$wrapperEl.on(e.touchEvents.end, P, i))
              : 'touchstart' === e.touchEvents.start &&
                (e.$wrapperEl.on(e.touchEvents.start, n, v, i),
                e.$wrapperEl.on(e.touchEvents.move, n, b, a),
                e.$wrapperEl.on(e.touchEvents.end, n, y, i),
                e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, n, y, i)),
              e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, x, a));
          }
          function O() {
            const t = e.zoom;
            if (!t.enabled) return;
            const s = e.support;
            t.enabled = !1;
            const { passiveListener: i, activeListenerWithCapture: a } = A(),
              n = $();
            (s.gestures
              ? (e.$wrapperEl.off(e.touchEvents.start, k, i),
                e.$wrapperEl.off(e.touchEvents.end, P, i))
              : 'touchstart' === e.touchEvents.start &&
                (e.$wrapperEl.off(e.touchEvents.start, n, v, i),
                e.$wrapperEl.off(e.touchEvents.move, n, b, a),
                e.$wrapperEl.off(e.touchEvents.end, n, y, i),
                e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, n, y, i)),
              e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, x, a));
          }
          (Object.defineProperty(e.zoom, 'scale', {
            get: () => m,
            set(e) {
              if (m !== e) {
                const t = p.$imageEl ? p.$imageEl[0] : void 0,
                  s = p.$slideEl ? p.$slideEl[0] : void 0;
                i('zoomChange', e, t, s);
              }
              m = e;
            },
          }),
            s('init', () => {
              e.params.zoom.enabled && z();
            }),
            s('destroy', () => {
              O();
            }),
            s('touchStart', (t, s) => {
              e.zoom.enabled &&
                (function (t) {
                  const s = e.device;
                  p.$imageEl &&
                    0 !== p.$imageEl.length &&
                    (u.isTouched ||
                      (s.android && t.cancelable && t.preventDefault(),
                      (u.isTouched = !0),
                      (u.touchesStart.x =
                        'touchstart' === t.type ? t.targetTouches[0].pageX : t.pageX),
                      (u.touchesStart.y =
                        'touchstart' === t.type ? t.targetTouches[0].pageY : t.pageY)));
                })(s);
            }),
            s('touchEnd', (t, s) => {
              e.zoom.enabled &&
                (function () {
                  const t = e.zoom;
                  if (!p.$imageEl || 0 === p.$imageEl.length) return;
                  if (!u.isTouched || !u.isMoved)
                    return ((u.isTouched = !1), void (u.isMoved = !1));
                  ((u.isTouched = !1), (u.isMoved = !1));
                  let s = 300,
                    i = 300;
                  const a = h.x * s,
                    n = u.currentX + a,
                    r = h.y * i,
                    o = u.currentY + r;
                  (0 !== h.x && (s = Math.abs((n - u.currentX) / h.x)),
                    0 !== h.y && (i = Math.abs((o - u.currentY) / h.y)));
                  const l = Math.max(s, i);
                  ((u.currentX = n), (u.currentY = o));
                  const d = u.width * t.scale,
                    c = u.height * t.scale;
                  ((u.minX = Math.min(p.slideWidth / 2 - d / 2, 0)),
                    (u.maxX = -u.minX),
                    (u.minY = Math.min(p.slideHeight / 2 - c / 2, 0)),
                    (u.maxY = -u.minY),
                    (u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX)),
                    (u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY)),
                    p.$imageWrapEl
                      .transition(l)
                      .transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`));
                })();
            }),
            s('doubleTap', (t, s) => {
              !e.animating &&
                e.params.zoom.enabled &&
                e.zoom.enabled &&
                e.params.zoom.toggle &&
                S(s);
            }),
            s('transitionEnd', () => {
              e.zoom.enabled && e.params.zoom.enabled && E();
            }),
            s('slideChange', () => {
              e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && E();
            }),
            Object.assign(e.zoom, { enable: z, disable: O, in: C, out: T, toggle: S }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          (t({
            lazy: {
              checkInView: !1,
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              scrollingElement: '',
              elementClass: 'swiper-lazy',
              loadingClass: 'swiper-lazy-loading',
              loadedClass: 'swiper-lazy-loaded',
              preloaderClass: 'swiper-lazy-preloader',
            },
          }),
            (e.lazy = {}));
          let a = !1,
            n = !1;
          function o(t, s = !0) {
            const a = e.params.lazy;
            if (void 0 === t) return;
            if (0 === e.slides.length) return;
            const n =
                e.virtual && e.params.virtual.enabled
                  ? e.$wrapperEl.children(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`)
                  : e.slides.eq(t),
              r = n.find(`.${a.elementClass}:not(.${a.loadedClass}):not(.${a.loadingClass})`);
            (!n.hasClass(a.elementClass) ||
              n.hasClass(a.loadedClass) ||
              n.hasClass(a.loadingClass) ||
              r.push(n[0]),
              0 !== r.length &&
                r.each((t) => {
                  const r = f(t);
                  r.addClass(a.loadingClass);
                  const l = r.attr('data-background'),
                    d = r.attr('data-src'),
                    c = r.attr('data-srcset'),
                    p = r.attr('data-sizes'),
                    u = r.parent('picture');
                  (e.loadImage(r[0], d || l, c, p, !1, () => {
                    if (null != e && e && (!e || e.params) && !e.destroyed) {
                      if (
                        (l
                          ? (r.css('background-image', `url("${l}")`),
                            r.removeAttr('data-background'))
                          : (c && (r.attr('srcset', c), r.removeAttr('data-srcset')),
                            p && (r.attr('sizes', p), r.removeAttr('data-sizes')),
                            u.length &&
                              u.children('source').each((e) => {
                                const t = f(e);
                                t.attr('data-srcset') &&
                                  (t.attr('srcset', t.attr('data-srcset')),
                                  t.removeAttr('data-srcset'));
                              }),
                            d && (r.attr('src', d), r.removeAttr('data-src'))),
                        r.addClass(a.loadedClass).removeClass(a.loadingClass),
                        n.find(`.${a.preloaderClass}`).remove(),
                        e.params.loop && s)
                      ) {
                        const t = n.attr('data-swiper-slide-index');
                        if (n.hasClass(e.params.slideDuplicateClass)) {
                          o(
                            e.$wrapperEl
                              .children(
                                `[data-swiper-slide-index="${t}"]:not(.${e.params.slideDuplicateClass})`
                              )
                              .index(),
                            !1
                          );
                        } else {
                          o(
                            e.$wrapperEl
                              .children(
                                `.${e.params.slideDuplicateClass}[data-swiper-slide-index="${t}"]`
                              )
                              .index(),
                            !1
                          );
                        }
                      }
                      (i('lazyImageReady', n[0], r[0]),
                        e.params.autoHeight && e.updateAutoHeight());
                    }
                  }),
                    i('lazyImageLoad', n[0], r[0]));
                }));
          }
          function l() {
            const { $wrapperEl: t, params: s, slides: i, activeIndex: a } = e,
              r = e.virtual && s.virtual.enabled,
              l = s.lazy;
            let d = s.slidesPerView;
            function c(e) {
              if (r) {
                if (t.children(`.${s.slideClass}[data-swiper-slide-index="${e}"]`).length)
                  return !0;
              } else if (i[e]) return !0;
              return !1;
            }
            function p(e) {
              return r ? f(e).attr('data-swiper-slide-index') : f(e).index();
            }
            if (('auto' === d && (d = 0), n || (n = !0), e.params.watchSlidesProgress))
              t.children(`.${s.slideVisibleClass}`).each((e) => {
                o(r ? f(e).attr('data-swiper-slide-index') : f(e).index());
              });
            else if (d > 1) for (let e = a; e < a + d; e += 1) c(e) && o(e);
            else o(a);
            if (l.loadPrevNext)
              if (d > 1 || (l.loadPrevNextAmount && l.loadPrevNextAmount > 1)) {
                const e = l.loadPrevNextAmount,
                  t = d,
                  s = Math.min(a + t + Math.max(e, t), i.length),
                  n = Math.max(a - Math.max(t, e), 0);
                for (let e = a + d; e < s; e += 1) c(e) && o(e);
                for (let e = n; e < a; e += 1) c(e) && o(e);
              } else {
                const e = t.children(`.${s.slideNextClass}`);
                e.length > 0 && o(p(e));
                const i = t.children(`.${s.slidePrevClass}`);
                i.length > 0 && o(p(i));
              }
          }
          function d() {
            const t = r();
            if (!e || e.destroyed) return;
            const s = e.params.lazy.scrollingElement ? f(e.params.lazy.scrollingElement) : f(t),
              i = s[0] === t,
              n = i ? t.innerWidth : s[0].offsetWidth,
              o = i ? t.innerHeight : s[0].offsetHeight,
              c = e.$el.offset(),
              { rtlTranslate: p } = e;
            let u = !1;
            p && (c.left -= e.$el[0].scrollLeft);
            const h = [
              [c.left, c.top],
              [c.left + e.width, c.top],
              [c.left, c.top + e.height],
              [c.left + e.width, c.top + e.height],
            ];
            for (let e = 0; e < h.length; e += 1) {
              const t = h[e];
              if (t[0] >= 0 && t[0] <= n && t[1] >= 0 && t[1] <= o) {
                if (0 === t[0] && 0 === t[1]) continue;
                u = !0;
              }
            }
            const m = !(
              'touchstart' !== e.touchEvents.start ||
              !e.support.passiveListener ||
              !e.params.passiveListeners
            ) && { passive: !0, capture: !1 };
            u ? (l(), s.off('scroll', d, m)) : a || ((a = !0), s.on('scroll', d, m));
          }
          (s('beforeInit', () => {
            e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
          }),
            s('init', () => {
              e.params.lazy.enabled && (e.params.lazy.checkInView ? d() : l());
            }),
            s('scroll', () => {
              e.params.freeMode && e.params.freeMode.enabled && !e.params.freeMode.sticky && l();
            }),
            s('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
              e.params.lazy.enabled && (e.params.lazy.checkInView ? d() : l());
            }),
            s('transitionStart', () => {
              e.params.lazy.enabled &&
                (e.params.lazy.loadOnTransitionStart ||
                  (!e.params.lazy.loadOnTransitionStart && !n)) &&
                (e.params.lazy.checkInView ? d() : l());
            }),
            s('transitionEnd', () => {
              e.params.lazy.enabled &&
                !e.params.lazy.loadOnTransitionStart &&
                (e.params.lazy.checkInView ? d() : l());
            }),
            s('slideChange', () => {
              const {
                lazy: t,
                cssMode: s,
                watchSlidesProgress: i,
                touchReleaseOnEdges: a,
                resistanceRatio: n,
              } = e.params;
              t.enabled && (s || (i && (a || 0 === n))) && l();
            }),
            Object.assign(e.lazy, { load: l, loadInSlide: o }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          function i(e, t) {
            const s = (function () {
              let e, t, s;
              return (i, a) => {
                for (t = -1, e = i.length; e - t > 1; )
                  ((s = (e + t) >> 1), i[s] <= a ? (t = s) : (e = s));
                return e;
              };
            })();
            let i, a;
            return (
              (this.x = e),
              (this.y = t),
              (this.lastIndex = e.length - 1),
              (this.interpolate = function (e) {
                return e
                  ? ((a = s(this.x, e)),
                    (i = a - 1),
                    ((e - this.x[i]) * (this.y[a] - this.y[i])) / (this.x[a] - this.x[i]) +
                      this.y[i])
                  : 0;
              }),
              this
            );
          }
          function a() {
            e.controller.control &&
              e.controller.spline &&
              ((e.controller.spline = void 0), delete e.controller.spline);
          }
          (t({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
            (e.controller = { control: void 0 }),
            s('beforeInit', () => {
              e.controller.control = e.params.controller.control;
            }),
            s('update', () => {
              a();
            }),
            s('resize', () => {
              a();
            }),
            s('observerUpdate', () => {
              a();
            }),
            s('setTranslate', (t, s, i) => {
              e.controller.control && e.controller.setTranslate(s, i);
            }),
            s('setTransition', (t, s, i) => {
              e.controller.control && e.controller.setTransition(s, i);
            }),
            Object.assign(e.controller, {
              setTranslate: function (t, s) {
                const a = e.controller.control;
                let n, r;
                const o = e.constructor;
                function l(t) {
                  const s = e.rtlTranslate ? -e.translate : e.translate;
                  ('slide' === e.params.controller.by &&
                    (!(function (t) {
                      e.controller.spline ||
                        (e.controller.spline = e.params.loop
                          ? new i(e.slidesGrid, t.slidesGrid)
                          : new i(e.snapGrid, t.snapGrid));
                    })(t),
                    (r = -e.controller.spline.interpolate(-s))),
                    (r && 'container' !== e.params.controller.by) ||
                      ((n =
                        (t.maxTranslate() - t.minTranslate()) /
                        (e.maxTranslate() - e.minTranslate())),
                      (r = (s - e.minTranslate()) * n + t.minTranslate())),
                    e.params.controller.inverse && (r = t.maxTranslate() - r),
                    t.updateProgress(r),
                    t.setTranslate(r, e),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses());
                }
                if (Array.isArray(a))
                  for (let e = 0; e < a.length; e += 1) a[e] !== s && a[e] instanceof o && l(a[e]);
                else a instanceof o && s !== a && l(a);
              },
              setTransition: function (t, s) {
                const i = e.constructor,
                  a = e.controller.control;
                let n;
                function r(s) {
                  (s.setTransition(t, e),
                    0 !== t &&
                      (s.transitionStart(),
                      s.params.autoHeight &&
                        m(() => {
                          s.updateAutoHeight();
                        }),
                      s.$wrapperEl.transitionEnd(() => {
                        a &&
                          (s.params.loop && 'slide' === e.params.controller.by && s.loopFix(),
                          s.transitionEnd());
                      })));
                }
                if (Array.isArray(a))
                  for (n = 0; n < a.length; n += 1) a[n] !== s && a[n] instanceof i && r(a[n]);
                else a instanceof i && s !== a && r(a);
              },
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          t({
            a11y: {
              enabled: !0,
              notificationClass: 'swiper-notification',
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
              firstSlideMessage: 'This is the first slide',
              lastSlideMessage: 'This is the last slide',
              paginationBulletMessage: 'Go to slide {{index}}',
              slideLabelMessage: '{{index}} / {{slidesLength}}',
              containerMessage: null,
              containerRoleDescriptionMessage: null,
              itemRoleDescriptionMessage: null,
              slideRole: 'group',
            },
          });
          let i = null;
          function a(e) {
            const t = i;
            0 !== t.length && (t.html(''), t.html(e));
          }
          function n(e) {
            e.attr('tabIndex', '0');
          }
          function r(e) {
            e.attr('tabIndex', '-1');
          }
          function o(e, t) {
            e.attr('role', t);
          }
          function l(e, t) {
            e.attr('aria-roledescription', t);
          }
          function d(e, t) {
            e.attr('aria-label', t);
          }
          function c(e) {
            e.attr('aria-disabled', !0);
          }
          function p(e) {
            e.attr('aria-disabled', !1);
          }
          function u(t) {
            if (13 !== t.keyCode && 32 !== t.keyCode) return;
            const s = e.params.a11y,
              i = f(t.target);
            (e.navigation &&
              e.navigation.$nextEl &&
              i.is(e.navigation.$nextEl) &&
              ((e.isEnd && !e.params.loop) || e.slideNext(),
              e.isEnd ? a(s.lastSlideMessage) : a(s.nextSlideMessage)),
              e.navigation &&
                e.navigation.$prevEl &&
                i.is(e.navigation.$prevEl) &&
                ((e.isBeginning && !e.params.loop) || e.slidePrev(),
                e.isBeginning ? a(s.firstSlideMessage) : a(s.prevSlideMessage)),
              e.pagination && i.is(ee(e.params.pagination.bulletClass)) && i[0].click());
          }
          function h() {
            if (e.params.loop || e.params.rewind || !e.navigation) return;
            const { $nextEl: t, $prevEl: s } = e.navigation;
            (s && s.length > 0 && (e.isBeginning ? (c(s), r(s)) : (p(s), n(s))),
              t && t.length > 0 && (e.isEnd ? (c(t), r(t)) : (p(t), n(t))));
          }
          function m() {
            return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
          }
          function g() {
            return m() && e.params.pagination.clickable;
          }
          const w = (e, t, s) => {
            (n(e),
              'BUTTON' !== e[0].tagName && (o(e, 'button'), e.on('keydown', u)),
              d(e, s),
              (function (e, t) {
                e.attr('aria-controls', t);
              })(e, t));
          };
          function v() {
            const t = e.params.a11y;
            e.$el.append(i);
            const s = e.$el;
            (t.containerRoleDescriptionMessage && l(s, t.containerRoleDescriptionMessage),
              t.containerMessage && d(s, t.containerMessage));
            const a = e.$wrapperEl,
              n =
                a.attr('id') ||
                `swiper-wrapper-${(function (e = 16) {
                  return 'x'
                    .repeat(e)
                    .replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
                })(16)}`,
              r = e.params.autoplay && e.params.autoplay.enabled ? 'off' : 'polite';
            var c;
            ((c = n),
              a.attr('id', c),
              (function (e, t) {
                e.attr('aria-live', t);
              })(a, r),
              t.itemRoleDescriptionMessage && l(f(e.slides), t.itemRoleDescriptionMessage),
              o(f(e.slides), t.slideRole));
            const p = e.params.loop
              ? e.slides.filter((t) => !t.classList.contains(e.params.slideDuplicateClass)).length
              : e.slides.length;
            let h, m;
            (e.slides.each((s, i) => {
              const a = f(s),
                n = e.params.loop ? parseInt(a.attr('data-swiper-slide-index'), 10) : i;
              d(
                a,
                t.slideLabelMessage
                  .replace(/\{\{index\}\}/, n + 1)
                  .replace(/\{\{slidesLength\}\}/, p)
              );
            }),
              e.navigation && e.navigation.$nextEl && (h = e.navigation.$nextEl),
              e.navigation && e.navigation.$prevEl && (m = e.navigation.$prevEl),
              h && h.length && w(h, n, t.nextSlideMessage),
              m && m.length && w(m, n, t.prevSlideMessage),
              g() && e.pagination.$el.on('keydown', ee(e.params.pagination.bulletClass), u));
          }
          (s('beforeInit', () => {
            i = f(
              `<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
            );
          }),
            s('afterInit', () => {
              e.params.a11y.enabled && (v(), h());
            }),
            s('toEdge', () => {
              e.params.a11y.enabled && h();
            }),
            s('fromEdge', () => {
              e.params.a11y.enabled && h();
            }),
            s('paginationUpdate', () => {
              e.params.a11y.enabled &&
                (function () {
                  const t = e.params.a11y;
                  m() &&
                    e.pagination.bullets.each((s) => {
                      const i = f(s);
                      (e.params.pagination.clickable &&
                        (n(i),
                        e.params.pagination.renderBullet ||
                          (o(i, 'button'),
                          d(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1)))),
                        i.is(`.${e.params.pagination.bulletActiveClass}`)
                          ? i.attr('aria-current', 'true')
                          : i.removeAttr('aria-current'));
                    });
                })();
            }),
            s('destroy', () => {
              e.params.a11y.enabled &&
                (function () {
                  let t, s;
                  (i && i.length > 0 && i.remove(),
                    e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (s = e.navigation.$prevEl),
                    t && t.off('keydown', u),
                    s && s.off('keydown', u),
                    g() && e.pagination.$el.off('keydown', ee(e.params.pagination.bulletClass), u));
                })();
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          t({ history: { enabled: !1, root: '', replaceState: !1, key: 'slides' } });
          let i = !1,
            a = {};
          const n = (e) =>
              e
                .toString()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
                .replace(/^-+/, '')
                .replace(/-+$/, ''),
            o = (e) => {
              const t = r();
              let s;
              s = e ? new URL(e) : t.location;
              const i = s.pathname
                  .slice(1)
                  .split('/')
                  .filter((e) => '' !== e),
                a = i.length;
              return { key: i[a - 2], value: i[a - 1] };
            },
            l = (t, s) => {
              const a = r();
              if (!i || !e.params.history.enabled) return;
              let o;
              o = e.params.url ? new URL(e.params.url) : a.location;
              const l = e.slides.eq(s);
              let d = n(l.attr('data-history'));
              if (e.params.history.root.length > 0) {
                let s = e.params.history.root;
                ('/' === s[s.length - 1] && (s = s.slice(0, s.length - 1)), (d = `${s}/${t}/${d}`));
              } else o.pathname.includes(t) || (d = `${t}/${d}`);
              const c = a.history.state;
              (c && c.value === d) ||
                (e.params.history.replaceState
                  ? a.history.replaceState({ value: d }, null, d)
                  : a.history.pushState({ value: d }, null, d));
            },
            d = (t, s, i) => {
              if (s)
                for (let a = 0, r = e.slides.length; a < r; a += 1) {
                  const r = e.slides.eq(a);
                  if (
                    n(r.attr('data-history')) === s &&
                    !r.hasClass(e.params.slideDuplicateClass)
                  ) {
                    const s = r.index();
                    e.slideTo(s, t, i);
                  }
                }
              else e.slideTo(0, t, i);
            },
            c = () => {
              ((a = o(e.params.url)), d(e.params.speed, e.paths.value, !1));
            };
          (s('init', () => {
            e.params.history.enabled &&
              (() => {
                const t = r();
                if (e.params.history) {
                  if (!t.history || !t.history.pushState)
                    return (
                      (e.params.history.enabled = !1),
                      void (e.params.hashNavigation.enabled = !0)
                    );
                  ((i = !0),
                    (a = o(e.params.url)),
                    (a.key || a.value) &&
                      (d(0, a.value, e.params.runCallbacksOnInit),
                      e.params.history.replaceState || t.addEventListener('popstate', c)));
                }
              })();
          }),
            s('destroy', () => {
              e.params.history.enabled &&
                (() => {
                  const t = r();
                  e.params.history.replaceState || t.removeEventListener('popstate', c);
                })();
            }),
            s('transitionEnd _freeModeNoMomentumRelease', () => {
              i && l(e.params.history.key, e.activeIndex);
            }),
            s('slideChange', () => {
              i && e.params.cssMode && l(e.params.history.key, e.activeIndex);
            }));
        },
        function ({ swiper: e, extendParams: t, emit: s, on: i }) {
          let n = !1;
          const o = a(),
            l = r();
          t({ hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } });
          const d = () => {
              s('hashChange');
              const t = o.location.hash.replace('#', '');
              if (t !== e.slides.eq(e.activeIndex).attr('data-hash')) {
                const s = e.$wrapperEl
                  .children(`.${e.params.slideClass}[data-hash="${t}"]`)
                  .index();
                if (void 0 === s) return;
                e.slideTo(s);
              }
            },
            c = () => {
              if (n && e.params.hashNavigation.enabled)
                if (e.params.hashNavigation.replaceState && l.history && l.history.replaceState)
                  (l.history.replaceState(
                    null,
                    null,
                    `#${e.slides.eq(e.activeIndex).attr('data-hash')}` || ''
                  ),
                    s('hashSet'));
                else {
                  const t = e.slides.eq(e.activeIndex),
                    i = t.attr('data-hash') || t.attr('data-history');
                  ((o.location.hash = i || ''), s('hashSet'));
                }
            };
          (i('init', () => {
            e.params.hashNavigation.enabled &&
              (() => {
                if (
                  !e.params.hashNavigation.enabled ||
                  (e.params.history && e.params.history.enabled)
                )
                  return;
                n = !0;
                const t = o.location.hash.replace('#', '');
                if (t) {
                  const s = 0;
                  for (let i = 0, a = e.slides.length; i < a; i += 1) {
                    const a = e.slides.eq(i);
                    if (
                      (a.attr('data-hash') || a.attr('data-history')) === t &&
                      !a.hasClass(e.params.slideDuplicateClass)
                    ) {
                      const t = a.index();
                      e.slideTo(t, s, e.params.runCallbacksOnInit, !0);
                    }
                  }
                }
                e.params.hashNavigation.watchState && f(l).on('hashchange', d);
              })();
          }),
            i('destroy', () => {
              e.params.hashNavigation.enabled &&
                e.params.hashNavigation.watchState &&
                f(l).off('hashchange', d);
            }),
            i('transitionEnd _freeModeNoMomentumRelease', () => {
              n && c();
            }),
            i('slideChange', () => {
              n && e.params.cssMode && c();
            }));
        },
        function ({ swiper: e, extendParams: t, on: s, emit: i }) {
          let n;
          function r() {
            const t = e.slides.eq(e.activeIndex);
            let s = e.params.autoplay.delay;
            (t.attr('data-swiper-autoplay') &&
              (s = t.attr('data-swiper-autoplay') || e.params.autoplay.delay),
              clearTimeout(n),
              (n = m(() => {
                let t;
                (e.params.autoplay.reverseDirection
                  ? e.params.loop
                    ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), i('autoplay'))
                    : e.isBeginning
                      ? e.params.autoplay.stopOnLastSlide
                        ? l()
                        : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)),
                          i('autoplay'))
                      : ((t = e.slidePrev(e.params.speed, !0, !0)), i('autoplay'))
                  : e.params.loop
                    ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), i('autoplay'))
                    : e.isEnd
                      ? e.params.autoplay.stopOnLastSlide
                        ? l()
                        : ((t = e.slideTo(0, e.params.speed, !0, !0)), i('autoplay'))
                      : ((t = e.slideNext(e.params.speed, !0, !0)), i('autoplay')),
                  ((e.params.cssMode && e.autoplay.running) || !1 === t) && r());
              }, s)));
          }
          function o() {
            return (
              void 0 === n &&
              !e.autoplay.running &&
              ((e.autoplay.running = !0), i('autoplayStart'), r(), !0)
            );
          }
          function l() {
            return (
              !!e.autoplay.running &&
              void 0 !== n &&
              (n && (clearTimeout(n), (n = void 0)),
              (e.autoplay.running = !1),
              i('autoplayStop'),
              !0)
            );
          }
          function d(t) {
            e.autoplay.running &&
              (e.autoplay.paused ||
                (n && clearTimeout(n),
                (e.autoplay.paused = !0),
                0 !== t && e.params.autoplay.waitForTransition
                  ? ['transitionend', 'webkitTransitionEnd'].forEach((t) => {
                      e.$wrapperEl[0].addEventListener(t, p);
                    })
                  : ((e.autoplay.paused = !1), r())));
          }
          function c() {
            const t = a();
            ('hidden' === t.visibilityState && e.autoplay.running && d(),
              'visible' === t.visibilityState &&
                e.autoplay.paused &&
                (r(), (e.autoplay.paused = !1)));
          }
          function p(t) {
            e &&
              !e.destroyed &&
              e.$wrapperEl &&
              t.target === e.$wrapperEl[0] &&
              (['transitionend', 'webkitTransitionEnd'].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, p);
              }),
              (e.autoplay.paused = !1),
              e.autoplay.running ? r() : l());
          }
          function u() {
            (e.params.autoplay.disableOnInteraction ? l() : d(),
              ['transitionend', 'webkitTransitionEnd'].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, p);
              }));
          }
          function h() {
            e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), r());
          }
          ((e.autoplay = { running: !1, paused: !1 }),
            t({
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1,
              },
            }),
            s('init', () => {
              if (e.params.autoplay.enabled) {
                o();
                (a().addEventListener('visibilitychange', c),
                  e.params.autoplay.pauseOnMouseEnter &&
                    (e.$el.on('mouseenter', u), e.$el.on('mouseleave', h)));
              }
            }),
            s('beforeTransitionStart', (t, s, i) => {
              e.autoplay.running &&
                (i || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(s) : l());
            }),
            s('sliderFirstMove', () => {
              e.autoplay.running && (e.params.autoplay.disableOnInteraction ? l() : d());
            }),
            s('touchEnd', () => {
              e.params.cssMode &&
                e.autoplay.paused &&
                !e.params.autoplay.disableOnInteraction &&
                r();
            }),
            s('destroy', () => {
              (e.$el.off('mouseenter', u), e.$el.off('mouseleave', h), e.autoplay.running && l());
              a().removeEventListener('visibilitychange', c);
            }),
            Object.assign(e.autoplay, { pause: d, run: r, start: o, stop: l }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          t({
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: 'swiper-slide-thumb-active',
              thumbsContainerClass: 'swiper-thumbs',
            },
          });
          let i = !1,
            a = !1;
          function n() {
            const t = e.thumbs.swiper;
            if (!t) return;
            const s = t.clickedIndex,
              i = t.clickedSlide;
            if (i && f(i).hasClass(e.params.thumbs.slideThumbActiveClass)) return;
            if (null == s) return;
            let a;
            if (
              ((a = t.params.loop
                ? parseInt(f(t.clickedSlide).attr('data-swiper-slide-index'), 10)
                : s),
              e.params.loop)
            ) {
              let t = e.activeIndex;
              e.slides.eq(t).hasClass(e.params.slideDuplicateClass) &&
                (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (t = e.activeIndex));
              const s = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${a}"]`).eq(0).index(),
                i = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${a}"]`).eq(0).index();
              a = void 0 === s ? i : void 0 === i ? s : i - t < t - s ? i : s;
            }
            e.slideTo(a);
          }
          function r() {
            const { thumbs: t } = e.params;
            if (i) return !1;
            i = !0;
            const s = e.constructor;
            if (t.swiper instanceof s)
              ((e.thumbs.swiper = t.swiper),
                Object.assign(e.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Object.assign(e.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }));
            else if (v(t.swiper)) {
              const i = Object.assign({}, t.swiper);
              (Object.assign(i, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                (e.thumbs.swiper = new s(i)),
                (a = !0));
            }
            return (
              e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
              e.thumbs.swiper.on('tap', n),
              !0
            );
          }
          function o(t) {
            const s = e.thumbs.swiper;
            if (!s) return;
            const i =
                'auto' === s.params.slidesPerView
                  ? s.slidesPerViewDynamic()
                  : s.params.slidesPerView,
              a = e.params.thumbs.autoScrollOffset,
              n = a && !s.params.loop;
            if (e.realIndex !== s.realIndex || n) {
              let r,
                o,
                l = s.activeIndex;
              if (s.params.loop) {
                s.slides.eq(l).hasClass(s.params.slideDuplicateClass) &&
                  (s.loopFix(), (s._clientLeft = s.$wrapperEl[0].clientLeft), (l = s.activeIndex));
                const t = s.slides
                    .eq(l)
                    .prevAll(`[data-swiper-slide-index="${e.realIndex}"]`)
                    .eq(0)
                    .index(),
                  i = s.slides
                    .eq(l)
                    .nextAll(`[data-swiper-slide-index="${e.realIndex}"]`)
                    .eq(0)
                    .index();
                ((r =
                  void 0 === t
                    ? i
                    : void 0 === i
                      ? t
                      : i - l == l - t
                        ? s.params.slidesPerGroup > 1
                          ? i
                          : l
                        : i - l < l - t
                          ? i
                          : t),
                  (o = e.activeIndex > e.previousIndex ? 'next' : 'prev'));
              } else ((r = e.realIndex), (o = r > e.previousIndex ? 'next' : 'prev'));
              (n && (r += 'next' === o ? a : -1 * a),
                s.visibleSlidesIndexes &&
                  s.visibleSlidesIndexes.indexOf(r) < 0 &&
                  (s.params.centeredSlides
                    ? (r = r > l ? r - Math.floor(i / 2) + 1 : r + Math.floor(i / 2) - 1)
                    : r > l && s.params.slidesPerGroup,
                  s.slideTo(r, t ? 0 : void 0)));
            }
            let r = 1;
            const o = e.params.thumbs.slideThumbActiveClass;
            if (
              (e.params.slidesPerView > 1 &&
                !e.params.centeredSlides &&
                (r = e.params.slidesPerView),
              e.params.thumbs.multipleActiveThumbs || (r = 1),
              (r = Math.floor(r)),
              s.slides.removeClass(o),
              s.params.loop || (s.params.virtual && s.params.virtual.enabled))
            )
              for (let t = 0; t < r; t += 1)
                s.$wrapperEl.children(`[data-swiper-slide-index="${e.realIndex + t}"]`).addClass(o);
            else for (let t = 0; t < r; t += 1) s.slides.eq(e.realIndex + t).addClass(o);
          }
          ((e.thumbs = { swiper: null }),
            s('beforeInit', () => {
              const { thumbs: t } = e.params;
              t && t.swiper && (r(), o(!0));
            }),
            s('slideChange update resize observerUpdate', () => {
              e.thumbs.swiper && o();
            }),
            s('setTransition', (t, s) => {
              const i = e.thumbs.swiper;
              i && i.setTransition(s);
            }),
            s('beforeDestroy', () => {
              const t = e.thumbs.swiper;
              t && a && t && t.destroy();
            }),
            Object.assign(e.thumbs, { init: r, update: o }));
        },
        function ({ swiper: e, extendParams: t, emit: s, once: i }) {
          (t({
            freeMode: {
              enabled: !1,
              momentum: !0,
              momentumRatio: 1,
              momentumBounce: !0,
              momentumBounceRatio: 1,
              momentumVelocityRatio: 1,
              sticky: !1,
              minimumVelocity: 0.02,
            },
          }),
            Object.assign(e, {
              freeMode: {
                onTouchMove: function () {
                  const { touchEventsData: t, touches: s } = e;
                  (0 === t.velocities.length &&
                    t.velocities.push({
                      position: s[e.isHorizontal() ? 'startX' : 'startY'],
                      time: t.touchStartTime,
                    }),
                    t.velocities.push({
                      position: s[e.isHorizontal() ? 'currentX' : 'currentY'],
                      time: g(),
                    }));
                },
                onTouchEnd: function ({ currentPos: t }) {
                  const {
                      params: a,
                      $wrapperEl: n,
                      rtlTranslate: r,
                      snapGrid: o,
                      touchEventsData: l,
                    } = e,
                    d = g() - l.touchStartTime;
                  if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
                  else if (t > -e.maxTranslate())
                    e.slides.length < o.length
                      ? e.slideTo(o.length - 1)
                      : e.slideTo(e.slides.length - 1);
                  else {
                    if (a.freeMode.momentum) {
                      if (l.velocities.length > 1) {
                        const t = l.velocities.pop(),
                          s = l.velocities.pop(),
                          i = t.position - s.position,
                          n = t.time - s.time;
                        ((e.velocity = i / n),
                          (e.velocity /= 2),
                          Math.abs(e.velocity) < a.freeMode.minimumVelocity && (e.velocity = 0),
                          (n > 150 || g() - t.time > 300) && (e.velocity = 0));
                      } else e.velocity = 0;
                      ((e.velocity *= a.freeMode.momentumVelocityRatio), (l.velocities.length = 0));
                      let t = 1e3 * a.freeMode.momentumRatio;
                      const d = e.velocity * t;
                      let c = e.translate + d;
                      r && (c = -c);
                      let p,
                        u = !1;
                      const h = 20 * Math.abs(e.velocity) * a.freeMode.momentumBounceRatio;
                      let f;
                      if (c < e.maxTranslate())
                        (a.freeMode.momentumBounce
                          ? (c + e.maxTranslate() < -h && (c = e.maxTranslate() - h),
                            (p = e.maxTranslate()),
                            (u = !0),
                            (l.allowMomentumBounce = !0))
                          : (c = e.maxTranslate()),
                          a.loop && a.centeredSlides && (f = !0));
                      else if (c > e.minTranslate())
                        (a.freeMode.momentumBounce
                          ? (c - e.minTranslate() > h && (c = e.minTranslate() + h),
                            (p = e.minTranslate()),
                            (u = !0),
                            (l.allowMomentumBounce = !0))
                          : (c = e.minTranslate()),
                          a.loop && a.centeredSlides && (f = !0));
                      else if (a.freeMode.sticky) {
                        let t;
                        for (let e = 0; e < o.length; e += 1)
                          if (o[e] > -c) {
                            t = e;
                            break;
                          }
                        ((c =
                          Math.abs(o[t] - c) < Math.abs(o[t - 1] - c) || 'next' === e.swipeDirection
                            ? o[t]
                            : o[t - 1]),
                          (c = -c));
                      }
                      if (
                        (f &&
                          i('transitionEnd', () => {
                            e.loopFix();
                          }),
                        0 !== e.velocity)
                      ) {
                        if (
                          ((t = r
                            ? Math.abs((-c - e.translate) / e.velocity)
                            : Math.abs((c - e.translate) / e.velocity)),
                          a.freeMode.sticky)
                        ) {
                          const s = Math.abs((r ? -c : c) - e.translate),
                            i = e.slidesSizesGrid[e.activeIndex];
                          t = s < i ? a.speed : s < 2 * i ? 1.5 * a.speed : 2.5 * a.speed;
                        }
                      } else if (a.freeMode.sticky) return void e.slideToClosest();
                      (a.freeMode.momentumBounce && u
                        ? (e.updateProgress(p),
                          e.setTransition(t),
                          e.setTranslate(c),
                          e.transitionStart(!0, e.swipeDirection),
                          (e.animating = !0),
                          n.transitionEnd(() => {
                            e &&
                              !e.destroyed &&
                              l.allowMomentumBounce &&
                              (s('momentumBounce'),
                              e.setTransition(a.speed),
                              setTimeout(() => {
                                (e.setTranslate(p),
                                  n.transitionEnd(() => {
                                    e && !e.destroyed && e.transitionEnd();
                                  }));
                              }, 0));
                          }))
                        : e.velocity
                          ? (s('_freeModeNoMomentumRelease'),
                            e.updateProgress(c),
                            e.setTransition(t),
                            e.setTranslate(c),
                            e.transitionStart(!0, e.swipeDirection),
                            e.animating ||
                              ((e.animating = !0),
                              n.transitionEnd(() => {
                                e && !e.destroyed && e.transitionEnd();
                              })))
                          : e.updateProgress(c),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses());
                    } else {
                      if (a.freeMode.sticky) return void e.slideToClosest();
                      a.freeMode && s('_freeModeNoMomentumRelease');
                    }
                    (!a.freeMode.momentum || d >= a.longSwipesMs) &&
                      (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
                  }
                },
              },
            }));
        },
        function ({ swiper: e, extendParams: t }) {
          let s, i, a;
          (t({ grid: { rows: 1, fill: 'column' } }),
            (e.grid = {
              initSlides: (t) => {
                const { slidesPerView: n } = e.params,
                  { rows: r, fill: o } = e.params.grid;
                ((i = s / r),
                  (a = Math.floor(t / r)),
                  (s = Math.floor(t / r) === t / r ? t : Math.ceil(t / r) * r),
                  'auto' !== n && 'row' === o && (s = Math.max(s, n * r)));
              },
              updateSlide: (t, n, r, o) => {
                const { slidesPerGroup: l, spaceBetween: d } = e.params,
                  { rows: c, fill: p } = e.params.grid;
                let u, h, f;
                if ('row' === p && l > 1) {
                  const e = Math.floor(t / (l * c)),
                    i = t - c * l * e,
                    a = 0 === e ? l : Math.min(Math.ceil((r - e * c * l) / c), l);
                  ((f = Math.floor(i / a)),
                    (h = i - f * a + e * l),
                    (u = h + (f * s) / c),
                    n.css({ '-webkit-order': u, order: u }));
                } else
                  'column' === p
                    ? ((h = Math.floor(t / c)),
                      (f = t - h * c),
                      (h > a || (h === a && f === c - 1)) &&
                        ((f += 1), f >= c && ((f = 0), (h += 1))))
                    : ((f = Math.floor(t / i)), (h = t - f * i));
                n.css(o('margin-top'), 0 !== f ? d && `${d}px` : '');
              },
              updateWrapperSize: (t, i, a) => {
                const { spaceBetween: n, centeredSlides: r, roundLengths: o } = e.params,
                  { rows: l } = e.params.grid;
                if (
                  ((e.virtualSize = (t + n) * s),
                  (e.virtualSize = Math.ceil(e.virtualSize / l) - n),
                  e.$wrapperEl.css({ [a('width')]: `${e.virtualSize + n}px` }),
                  r)
                ) {
                  i.splice(0, i.length);
                  const t = [];
                  for (let s = 0; s < i.length; s += 1) {
                    let a = i[s];
                    (o && (a = Math.floor(a)), i[s] < e.virtualSize + i[0] && t.push(a));
                  }
                  i.push(...t);
                }
              },
            }));
        },
        function ({ swiper: e }) {
          Object.assign(e, {
            appendSlide: te.bind(e),
            prependSlide: se.bind(e),
            addSlide: ie.bind(e),
            removeSlide: ae.bind(e),
            removeAllSlides: ne.bind(e),
          });
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          (t({ fadeEffect: { crossFade: !1, transformEl: null } }),
            re({
              effect: 'fade',
              swiper: e,
              on: s,
              setTranslate: () => {
                const { slides: t } = e,
                  s = e.params.fadeEffect;
                for (let i = 0; i < t.length; i += 1) {
                  const t = e.slides.eq(i);
                  let a = -t[0].swiperSlideOffset;
                  e.params.virtualTranslate || (a -= e.translate);
                  let n = 0;
                  e.isHorizontal() || ((n = a), (a = 0));
                  const r = e.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs(t[0].progress), 0)
                    : 1 + Math.min(Math.max(t[0].progress, -1), 0);
                  oe(s, t).css({ opacity: r }).transform(`translate3d(${a}px, ${n}px, 0px)`);
                }
              },
              setTransition: (t) => {
                const { transformEl: s } = e.params.fadeEffect;
                ((s ? e.slides.find(s) : e.slides).transition(t),
                  le({ swiper: e, duration: t, transformEl: s, allSlides: !0 }));
              },
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !e.params.cssMode,
              }),
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          (t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } }),
            re({
              effect: 'cube',
              swiper: e,
              on: s,
              setTranslate: () => {
                const {
                    $el: t,
                    $wrapperEl: s,
                    slides: i,
                    width: a,
                    height: n,
                    rtlTranslate: r,
                    size: o,
                    browser: l,
                  } = e,
                  d = e.params.cubeEffect,
                  c = e.isHorizontal(),
                  p = e.virtual && e.params.virtual.enabled;
                let u,
                  h = 0;
                d.shadow &&
                  (c
                    ? ((u = s.find('.swiper-cube-shadow')),
                      0 === u.length &&
                        ((u = f('<div class="swiper-cube-shadow"></div>')), s.append(u)),
                      u.css({ height: `${a}px` }))
                    : ((u = t.find('.swiper-cube-shadow')),
                      0 === u.length &&
                        ((u = f('<div class="swiper-cube-shadow"></div>')), t.append(u))));
                for (let e = 0; e < i.length; e += 1) {
                  const t = i.eq(e);
                  let s = e;
                  p && (s = parseInt(t.attr('data-swiper-slide-index'), 10));
                  let a = 90 * s,
                    n = Math.floor(a / 360);
                  r && ((a = -a), (n = Math.floor(-a / 360)));
                  const l = Math.max(Math.min(t[0].progress, 1), -1);
                  let u = 0,
                    m = 0,
                    g = 0;
                  (s % 4 == 0
                    ? ((u = 4 * -n * o), (g = 0))
                    : (s - 1) % 4 == 0
                      ? ((u = 0), (g = 4 * -n * o))
                      : (s - 2) % 4 == 0
                        ? ((u = o + 4 * n * o), (g = o))
                        : (s - 3) % 4 == 0 && ((u = -o), (g = 3 * o + 4 * o * n)),
                    r && (u = -u),
                    c || ((m = u), (u = 0)));
                  const w = `rotateX(${c ? 0 : -a}deg) rotateY(${c ? a : 0}deg) translate3d(${u}px, ${m}px, ${g}px)`;
                  if (
                    (l <= 1 && l > -1 && ((h = 90 * s + 90 * l), r && (h = 90 * -s - 90 * l)),
                    t.transform(w),
                    d.slideShadows)
                  ) {
                    let e = c
                        ? t.find('.swiper-slide-shadow-left')
                        : t.find('.swiper-slide-shadow-top'),
                      s = c
                        ? t.find('.swiper-slide-shadow-right')
                        : t.find('.swiper-slide-shadow-bottom');
                    (0 === e.length &&
                      ((e = f(`<div class="swiper-slide-shadow-${c ? 'left' : 'top'}"></div>`)),
                      t.append(e)),
                      0 === s.length &&
                        ((s = f(
                          `<div class="swiper-slide-shadow-${c ? 'right' : 'bottom'}"></div>`
                        )),
                        t.append(s)),
                      e.length && (e[0].style.opacity = Math.max(-l, 0)),
                      s.length && (s[0].style.opacity = Math.max(l, 0)));
                  }
                }
                if (
                  (s.css({
                    '-webkit-transform-origin': `50% 50% -${o / 2}px`,
                    'transform-origin': `50% 50% -${o / 2}px`,
                  }),
                  d.shadow)
                )
                  if (c)
                    u.transform(
                      `translate3d(0px, ${a / 2 + d.shadowOffset}px, ${-a / 2}px) rotateX(90deg) rotateZ(0deg) scale(${d.shadowScale})`
                    );
                  else {
                    const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                      t =
                        1.5 -
                        (Math.sin((2 * e * Math.PI) / 360) / 2 +
                          Math.cos((2 * e * Math.PI) / 360) / 2),
                      s = d.shadowScale,
                      i = d.shadowScale / t,
                      a = d.shadowOffset;
                    u.transform(
                      `scale3d(${s}, 1, ${i}) translate3d(0px, ${n / 2 + a}px, ${-n / 2 / i}px) rotateX(-90deg)`
                    );
                  }
                const m = l.isSafari || l.isWebView ? -o / 2 : 0;
                s.transform(
                  `translate3d(0px,0,${m}px) rotateX(${e.isHorizontal() ? 0 : h}deg) rotateY(${e.isHorizontal() ? -h : 0}deg)`
                );
              },
              setTransition: (t) => {
                const { $el: s, slides: i } = e;
                (i
                  .transition(t)
                  .find(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .transition(t),
                  e.params.cubeEffect.shadow &&
                    !e.isHorizontal() &&
                    s.find('.swiper-cube-shadow').transition(t));
              },
              perspective: () => !0,
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: !1,
                virtualTranslate: !0,
              }),
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          (t({ flipEffect: { slideShadows: !0, limitRotation: !0, transformEl: null } }),
            re({
              effect: 'flip',
              swiper: e,
              on: s,
              setTranslate: () => {
                const { slides: t, rtlTranslate: s } = e,
                  i = e.params.flipEffect;
                for (let a = 0; a < t.length; a += 1) {
                  const n = t.eq(a);
                  let r = n[0].progress;
                  e.params.flipEffect.limitRotation &&
                    (r = Math.max(Math.min(n[0].progress, 1), -1));
                  const o = n[0].swiperSlideOffset;
                  let l = -180 * r,
                    d = 0,
                    c = e.params.cssMode ? -o - e.translate : -o,
                    p = 0;
                  if (
                    (e.isHorizontal() ? s && (l = -l) : ((p = c), (c = 0), (d = -l), (l = 0)),
                    (n[0].style.zIndex = -Math.abs(Math.round(r)) + t.length),
                    i.slideShadows)
                  ) {
                    let t = e.isHorizontal()
                        ? n.find('.swiper-slide-shadow-left')
                        : n.find('.swiper-slide-shadow-top'),
                      s = e.isHorizontal()
                        ? n.find('.swiper-slide-shadow-right')
                        : n.find('.swiper-slide-shadow-bottom');
                    (0 === t.length && (t = de(i, n, e.isHorizontal() ? 'left' : 'top')),
                      0 === s.length && (s = de(i, n, e.isHorizontal() ? 'right' : 'bottom')),
                      t.length && (t[0].style.opacity = Math.max(-r, 0)),
                      s.length && (s[0].style.opacity = Math.max(r, 0)));
                  }
                  const u = `translate3d(${c}px, ${p}px, 0px) rotateX(${d}deg) rotateY(${l}deg)`;
                  oe(i, n).transform(u);
                }
              },
              setTransition: (t) => {
                const { transformEl: s } = e.params.flipEffect;
                ((s ? e.slides.find(s) : e.slides)
                  .transition(t)
                  .find(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .transition(t),
                  le({ swiper: e, duration: t, transformEl: s }));
              },
              perspective: () => !0,
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !e.params.cssMode,
              }),
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          (t({
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              scale: 1,
              modifier: 1,
              slideShadows: !0,
              transformEl: null,
            },
          }),
            re({
              effect: 'coverflow',
              swiper: e,
              on: s,
              setTranslate: () => {
                const { width: t, height: s, slides: i, slidesSizesGrid: a } = e,
                  n = e.params.coverflowEffect,
                  r = e.isHorizontal(),
                  o = e.translate,
                  l = r ? t / 2 - o : s / 2 - o,
                  d = r ? n.rotate : -n.rotate,
                  c = n.depth;
                for (let e = 0, t = i.length; e < t; e += 1) {
                  const t = i.eq(e),
                    s = a[e],
                    o = ((l - t[0].swiperSlideOffset - s / 2) / s) * n.modifier;
                  let p = r ? d * o : 0,
                    u = r ? 0 : d * o,
                    h = -c * Math.abs(o),
                    f = n.stretch;
                  'string' == typeof f &&
                    -1 !== f.indexOf('%') &&
                    (f = (parseFloat(n.stretch) / 100) * s);
                  let m = r ? 0 : f * o,
                    g = r ? f * o : 0,
                    w = 1 - (1 - n.scale) * Math.abs(o);
                  (Math.abs(g) < 0.001 && (g = 0),
                    Math.abs(m) < 0.001 && (m = 0),
                    Math.abs(h) < 0.001 && (h = 0),
                    Math.abs(p) < 0.001 && (p = 0),
                    Math.abs(u) < 0.001 && (u = 0),
                    Math.abs(w) < 0.001 && (w = 0));
                  const v = `translate3d(${g}px,${m}px,${h}px)  rotateX(${u}deg) rotateY(${p}deg) scale(${w})`;
                  if (
                    (oe(n, t).transform(v),
                    (t[0].style.zIndex = 1 - Math.abs(Math.round(o))),
                    n.slideShadows)
                  ) {
                    let e = r
                        ? t.find('.swiper-slide-shadow-left')
                        : t.find('.swiper-slide-shadow-top'),
                      s = r
                        ? t.find('.swiper-slide-shadow-right')
                        : t.find('.swiper-slide-shadow-bottom');
                    (0 === e.length && (e = de(n, t, r ? 'left' : 'top')),
                      0 === s.length && (s = de(n, t, r ? 'right' : 'bottom')),
                      e.length && (e[0].style.opacity = o > 0 ? o : 0),
                      s.length && (s[0].style.opacity = -o > 0 ? -o : 0));
                  }
                }
              },
              setTransition: (t) => {
                const { transformEl: s } = e.params.coverflowEffect;
                (s ? e.slides.find(s) : e.slides)
                  .transition(t)
                  .find(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .transition(t);
              },
              perspective: () => !0,
              overwriteParams: () => ({ watchSlidesProgress: !0 }),
            }));
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          t({
            creativeEffect: {
              transformEl: null,
              limitProgress: 1,
              shadowPerProgress: !1,
              progressMultiplier: 1,
              perspective: !0,
              prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
              next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
            },
          });
          const i = (e) => ('string' == typeof e ? e : `${e}px`);
          re({
            effect: 'creative',
            swiper: e,
            on: s,
            setTranslate: () => {
              const { slides: t, $wrapperEl: s, slidesSizesGrid: a } = e,
                n = e.params.creativeEffect,
                { progressMultiplier: r } = n,
                o = e.params.centeredSlides;
              if (o) {
                const t = a[0] / 2 - e.params.slidesOffsetBefore || 0;
                s.transform(`translateX(calc(50% - ${t}px))`);
              }
              for (let s = 0; s < t.length; s += 1) {
                const a = t.eq(s),
                  l = a[0].progress,
                  d = Math.min(Math.max(a[0].progress, -n.limitProgress), n.limitProgress);
                let c = d;
                o ||
                  (c = Math.min(
                    Math.max(a[0].originalProgress, -n.limitProgress),
                    n.limitProgress
                  ));
                const p = a[0].swiperSlideOffset,
                  u = [e.params.cssMode ? -p - e.translate : -p, 0, 0],
                  h = [0, 0, 0];
                let f = !1;
                e.isHorizontal() || ((u[1] = u[0]), (u[0] = 0));
                let m = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                (d < 0 ? ((m = n.next), (f = !0)) : d > 0 && ((m = n.prev), (f = !0)),
                  u.forEach((e, t) => {
                    u[t] = `calc(${e}px + (${i(m.translate[t])} * ${Math.abs(d * r)}))`;
                  }),
                  h.forEach((e, t) => {
                    h[t] = m.rotate[t] * Math.abs(d * r);
                  }),
                  (a[0].style.zIndex = -Math.abs(Math.round(l)) + t.length));
                const g = u.join(', '),
                  w = `rotateX(${h[0]}deg) rotateY(${h[1]}deg) rotateZ(${h[2]}deg)`,
                  v =
                    c < 0
                      ? `scale(${1 + (1 - m.scale) * c * r})`
                      : `scale(${1 - (1 - m.scale) * c * r})`,
                  b = c < 0 ? 1 + (1 - m.opacity) * c * r : 1 - (1 - m.opacity) * c * r,
                  y = `translate3d(${g}) ${w} ${v}`;
                if ((f && m.shadow) || !f) {
                  let e = a.children('.swiper-slide-shadow');
                  if ((0 === e.length && m.shadow && (e = de(n, a)), e.length)) {
                    const t = n.shadowPerProgress ? d * (1 / n.limitProgress) : d;
                    e[0].style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                  }
                }
                const x = oe(n, a);
                (x.transform(y).css({ opacity: b }),
                  m.origin && x.css('transform-origin', m.origin));
              }
            },
            setTransition: (t) => {
              const { transformEl: s } = e.params.creativeEffect;
              ((s ? e.slides.find(s) : e.slides)
                .transition(t)
                .find('.swiper-slide-shadow')
                .transition(t),
                le({ swiper: e, duration: t, transformEl: s, allSlides: !0 }));
            },
            perspective: () => e.params.creativeEffect.perspective,
            overwriteParams: () => ({
              watchSlidesProgress: !0,
              virtualTranslate: !e.params.cssMode,
            }),
          });
        },
        function ({ swiper: e, extendParams: t, on: s }) {
          (t({ cardsEffect: { slideShadows: !0, transformEl: null } }),
            re({
              effect: 'cards',
              swiper: e,
              on: s,
              setTranslate: () => {
                const { slides: t, activeIndex: s } = e,
                  i = e.params.cardsEffect,
                  { startTranslate: a, isTouched: n } = e.touchEventsData,
                  r = e.translate;
                for (let o = 0; o < t.length; o += 1) {
                  const l = t.eq(o),
                    d = l[0].progress,
                    c = Math.min(Math.max(d, -4), 4);
                  let p = l[0].swiperSlideOffset;
                  (e.params.centeredSlides &&
                    !e.params.cssMode &&
                    e.$wrapperEl.transform(`translateX(${e.minTranslate()}px)`),
                    e.params.centeredSlides && e.params.cssMode && (p -= t[0].swiperSlideOffset));
                  let u = e.params.cssMode ? -p - e.translate : -p,
                    h = 0;
                  const f = -100 * Math.abs(c);
                  let m = 1,
                    g = -2 * c,
                    w = 8 - 0.75 * Math.abs(c);
                  const v =
                      (o === s || o === s - 1) &&
                      c > 0 &&
                      c < 1 &&
                      (n || e.params.cssMode) &&
                      r < a,
                    b =
                      (o === s || o === s + 1) &&
                      c < 0 &&
                      c > -1 &&
                      (n || e.params.cssMode) &&
                      r > a;
                  if (v || b) {
                    const e = (1 - Math.abs((Math.abs(c) - 0.5) / 0.5)) ** 0.5;
                    ((g += -28 * c * e),
                      (m += -0.5 * e),
                      (w += 96 * e),
                      (h = -25 * e * Math.abs(c) + '%'));
                  }
                  if (
                    ((u =
                      c < 0
                        ? `calc(${u}px + (${w * Math.abs(c)}%))`
                        : c > 0
                          ? `calc(${u}px + (-${w * Math.abs(c)}%))`
                          : `${u}px`),
                    !e.isHorizontal())
                  ) {
                    const e = h;
                    ((h = u), (u = e));
                  }
                  const y = `\n        translate3d(${u}, ${h}, ${f}px)\n        rotateZ(${g}deg)\n        scale(${c < 0 ? '' + (1 + (1 - m) * c) : '' + (1 - (1 - m) * c)})\n      `;
                  if (i.slideShadows) {
                    let e = l.find('.swiper-slide-shadow');
                    (0 === e.length && (e = de(i, l)),
                      e.length &&
                        (e[0].style.opacity = Math.min(Math.max((Math.abs(c) - 0.5) / 0.5, 0), 1)));
                  }
                  l[0].style.zIndex = -Math.abs(Math.round(d)) + t.length;
                  oe(i, l).transform(y);
                }
              },
              setTransition: (t) => {
                const { transformEl: s } = e.params.cardsEffect;
                ((s ? e.slides.find(s) : e.slides)
                  .transition(t)
                  .find('.swiper-slide-shadow')
                  .transition(t),
                  le({ swiper: e, duration: t, transformEl: s }));
              },
              perspective: () => !0,
              overwriteParams: () => ({
                watchSlidesProgress: !0,
                virtualTranslate: !e.params.cssMode,
              }),
            }));
        },
      ];
      J.use(ce);
      var pe = s(3379),
        ue = s.n(pe),
        he = s(2615),
        fe = { insert: 'head', singleton: !1 };
      ue()(he.Z, fe);
      he.Z.locals;
      var me = s(8588),
        ge = s.n(me),
        we = s(9528),
        ve = { insert: 'head', singleton: !1 };
      ue()(we.Z, ve);
      we.Z.locals;
      var be = s(456),
        ye = s(9669);
      function xe() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        ye.get(' /cart?sections=side-cart-qf', {})
          .then(function (t) {
            var s = t.data['side-cart-qf'],
              i = document.querySelector('#cart-drawer-container .inner');
            if (i && s) {
              i.innerHTML = s;
              var a = new CustomEvent('cart_rendered', { detail: { response: t, html: s } });
              (window.dispatchEvent(a), e && e());
            }
          })
          .catch(function (e) {
            window.log('Error:', e);
          })
          .then(function () {
            window.log('Complete');
          });
      }
      ((window.axios = s(9669)),
        (window.swiper = J),
        (window.Toastify = ge()),
        (window.qf_cart = {
          addToCart: be.Xq,
          bulkAddToCart: be.dv,
          removeFromCart: be.h2,
          removeUniqFromCart: be.$8,
          updateCart: be.xu,
          clearCart: be.LL,
          getCart: be.Bz,
          reRenderCart: be.Qb,
          updateCartVatItems: be.Xu,
          furnishCartLineItemProperties: be.cr,
        }),
        (window.qf_side_cart = {
          openSideCart: function () {
            xe(function () {
              var e = document.querySelector('#cart-drawer-container');
              if (e) {
                (e.classList.add('open'), document.body.classList.add('no-overflow'));
                var t = new CustomEvent('side_cart_opened', { detail: {} });
                window.dispatchEvent(t);
              }
            });
          },
          closeSideCart: function () {
            (document.querySelector('#cart-drawer-container').classList.remove('open'),
              document.body.classList.remove('no-overflow'));
            var e = new CustomEvent('side_cart_closed', { detail: {} });
            window.dispatchEvent(e);
          },
          reRenderSideCart: xe,
        }));
    })());
})();
